import { useSelector, useDispatch } from 'react-redux';
import { authActions } from '_store';
import XrayViewer from '_components/XrayViewer'; 
import ActivityLogTable from '_components/ActivityLogTable'; 
import ReportDiff from '_components/ReportDiff'; 
import { useState, useRef, useEffect } from 'react';
import axios from 'axios';

import { EditorState, ContentState, convertFromHTML, convertToRaw, convertFromRaw, getDefaultKeyBinding, Modifier, BlockMapBuilder } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

import { date } from 'yup';
import {ReactPictureAnnotation } from "react-picture-annotation";
import QRCode from "react-qr-code";

import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

import htmlDocx from "html-docx-js/dist/html-docx";
import { saveAs } from "file-saver";

export { StudyList };
var search_report_status = 'P';
var search_priority = 'A';
var myWindow = null;
var patientObject = new Object();
var patient_key_recover = '';

var myWindowJPG = null;
let scale = 1;
let rotateDeg = 0;
let flipped = false;
let fullscreenFlag = false;

let isDragging = false;
let pan_scale = 1;
let zoom_scale = 1;
let startX, startY, translateX = 0, translateY = 0;
let prev_zoom_startX = 0, prev_zoom_startY = 0;
let zoom_startX, zoom_startY, zoom_translateX = 0, zoom_translateY = 0;

let activeJPGAction = 'windowlevel';
let brightness = 1, contrast = 1;
var retryAPICounter = 0;

const Msg = ({ closeToast, toastProps }) => (
  <div>
    Custom Message {toastProps.position}
    <button>Retry</button>
    <button onClick={closeToast}>Close</button>
  </div>
);

function StudyList(prop) {
    const authUser = useSelector(x => x.auth.user);
    const dispatch = useDispatch();
    const logout = () => dispatch(authActions.logout());

    const [patientFilesData, setPatientFilesData] = useState([]);
    const [activitylogData, setActivitylogData] = useState([]);
    const [doctorListData, setDoctorListData] = useState([]);
    const [assignDoctorKey, setAssignDoctorKey] = useState(0);
    const [studyPriorityLevel, setStudyPriorityLevel] = useState(0);

    const [patientData, setPatientData] = useState([]);
    const [patientIndex, setPatientIndex] = useState(0);
    const [pageIndex, setPageIndex] = useState(1);
    const [reportIndex, setReportIndex] = useState(1);

    const [filterColName, setFilterColName] = useState("");
    const [filterColValue, setFilterColValue] = useState("");
    const [sortColName, setSortColName] = useState("");
    const [sortColValue, setSortColValue] = useState("");
    
    const [pendingCount, setPendingCount] = useState(0);
    const [waitingCount, setWaitingCount] = useState(0);
    const [holdCount, setHoldCount] = useState(0);
    const [draftCount, setDraftCount] = useState(0);
    const [reviewCount, setReviewCount] = useState(0);
    const [signedoffCount, setSignedoffCount] = useState(0);
    const [urgentCount, setUrgentCount] = useState(0);
    const [reportTemplates, setReportTemplates] = useState([]);
    const [reportTemplatesFiltered, setReportTemplatesFiltered] = useState([]);

    const [editorState, setEditorState] = useState(
      () => EditorState.createEmpty(),
    );
    
    const [reportLineHeight, setReportLineHeight] = useState("");
    const [printLineHeight, setPrintLineHeight] = useState("");
    
    const [activeTab, setActiveTab] = useState("overview");
    const tabs = [
      { id: "overview", label: "Overview" },
      { id: "details", label: "Details" },
      { id: "settings", label: "Settings" },
    ];

    const [customStyleMap, setCustomeStyleMap] = useState();
    const content = editorState.getCurrentContent();
    const dataToSaveBackend = convertToRaw(content);
    const markupReport = draftToHtml(
      dataToSaveBackend
    );

    let divStyle1 = {
      float: "left",
      marginTop: "4rem",
      marginLeft: "30px",
    };
    let divStyle2 = {
      border: "#dadada 1px solid"/*,
      height: "135px",*/
    };
    let divStyle3 = {
      float: "right",
      marginTop: "4rem",
      marginRight: "30px",
    };
    let displayNone = {
      display: "none"
    };
    
    const [fileList, setFile] = useState();
    const [fileCount, setFileCount] = useState(0);
    const files = fileList ? [...fileList] : [];
    
    const [notesFile, setNotesFile] = useState();
    const [notesFileCount, setNotesFileCount] = useState(0);
    const notesFiles = notesFile ? [...notesFile] : [];
    const [filePaste, setFilePaste] = useState();
    
    const [pageSize, setPageSize] = useState({
      width: window.innerWidth ,
      height: window.innerHeight 
    });
    const [jpgPath, setJpgPath] = useState('#');
    const [toolDefault, setToolDefault] = useState('wl');
    const [refNumber, setRefNumber] = useState(1);
    const [patientKey, setPatientKey] = useState(0);
    
    const [alertDesc, setAlertDesc] = useState("");
    const [autoClose0, setAutoClose0] = useState(0);
    const [autoClose5, setAutoClose5] = useState(5000);
    const [autoCloseTime, setAutoCloseTime] = useState(0);

    const [columnNameReport, setColumnNameReport] = useState("");
    const [oldReport, setOldReport] = useState("");
    const [newReport, setNewReport] = useState("");
    
    
    const notifyDefault = (msgValue) => {
      toast(msgValue);
    };
  const notifySuccess = (msgValue) => {
    setTimeout(function () {
      toast.success(msgValue, {
        position: "top-right"
      });
    }, 100);
      
    };
  const notifyError = (msgValue) => {
    
    setTimeout(function () {
      toast.error(msgValue, {
        position: "top-right"
      });
    }, 100);

    //let modalAlert = document.querySelector("#modal_alert");
    //modalAlert.classList.toggle("closed");

    };
    const notifyWarn = (msgValue) => {
      toast.warn(msgValue, {
        position: "top-right"
      });
    };
    const notifyInfo = (msgValue) => {
      toast.info(msgValue, {
        position: "top-right"
      });
    };
    const notifyCustom = (msgValue) => {
      toast(msgValue, {
        position: "top-right",
        className: 'foo-bar'
      });
    };
    //toast('Show now');
    //toast('Show after 1sec', { delay: 1000 });

    const displayMsg = () => {
      toast(<Msg />);
      // toast(Msg) would also work
    };

    const onResize = () => {
      setPageSize({ width: window.innerWidth, height: window.innerHeight });
    };
  
    const onSelectDicomJPG = selectedId => console.log(selectedId);
    const onChangeDicomJPG = data => console.log(data);
  
      var prev_filter_col_name = "";
      var prev_sort_col_name = "";
      var prev_dicomobj = null;

    useEffect(() => {
        var objddlSelection = document.getElementById("ddlSelection");
        if(objddlSelection!==null){
          if(authUser?.user_type === 'A' || authUser?.user_type === 'S'){
            objddlSelection.value = 'today';
          }
          else{
            objddlSelection.value = 'last7days';
          }
        }

        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
          var lipagesearch = document.getElementById("lipagesearch");
          lipagesearch.style.display='none';
          var lipage_no_s = document.getElementById("lipage_no_s");
          lipage_no_s.style.display='none';

          var objddlcase_type = document.getElementById("ddlcase_type");
          objddlcase_type.style.width='85px';

          var objlblRBG = document.getElementById("lblRBG");
          objlblRBG.innerText='Report BG';

          var objtxthistory = document.getElementById("txthistory");
          objtxthistory.rows = 2;
        }
        
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && 1===2){
          document.getElementById("lnkpageno1").parentNode.style.display='none';
          document.getElementById("lnkpageno2").parentNode.style.display='none';
          document.getElementById("lnkpageno3").parentNode.style.display='none';
          
          document.getElementById("lnkpagenoLast").parentNode.style.display='';
          document.getElementById("lnkpagenomore").parentNode.style.display='';
        }

        patient_key_recover = '';
        /* Network issue recover report */
        if(authUser?.user_type === 'D' || authUser?.user_type === 'R')
        {
          let api_status = localStorage.getItem('api_status');
          let user_key = localStorage.getItem('user_key');
          if(api_status!=='Y' && user_key === authUser?.user_key.toString())
          {
            let patient_id_recover = localStorage.getItem('patient_id');
            if(patient_id_recover !== null && patient_id_recover!=='')
            {
              patient_key_recover = localStorage.getItem('patient_key');
              setTimeout(function () {
                alert('Report is unsafe mode, please open and save. Patient id: ' + patient_id_recover)
              }, 100);
            }
          }
        }

        search_report_status = 'P';
        search_priority = 'A';
        tabClick(search_report_status, search_priority);

        if(authUser?.user_type === 'D' || authUser?.user_type === 'R')
        {
          reportTemplateList();
        }

        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    // only show Menu when logged in
    if (!authUser){
      alert('Unauthorized session, please try to relogin.');
      return null;
    }

    /*
      setTimeout(function() {
        patientStudyList(search_report_status, search_priority, null, false, true);
      }, 600000);
    */

  //setInterval(RefreshPage, 60000);

  function lineHeightChange() {
    var objddlLineHeight = document.getElementById("ddlLineHeight");
    const LineHeight = objddlLineHeight.options[objddlLineHeight.selectedIndex].innerHTML;
    var lineHeightValue = 0;
    if(LineHeight==='Line Height - Default') { lineHeightValue = 0; }
    else if(LineHeight==='Line Height - 1') { lineHeightValue = 10; }
    else if(LineHeight==='Line Height - 1.3') { lineHeightValue = 13; }
    else if(LineHeight==='Line Height - 1.5') { lineHeightValue = 15; }
    else if(LineHeight==='Line Height - 1.8')  { lineHeightValue = 18; }
    else if(LineHeight==='Line Height - 2') { lineHeightValue = 20; }
    else if(LineHeight==='Line Height - 2.3') { lineHeightValue = 23; }
    else if(LineHeight==='Line Height - 2.5') { lineHeightValue = 25; }
    else if(LineHeight==='Line Height - 2.8')  { lineHeightValue = 28; }

    if(lineHeightValue === 0) { 
      setReportLineHeight(""); 
      setPrintLineHeight(""); 
    }
    else { 
      var lineHeightValuePixel = lineHeightValue + "px";
      setReportLineHeight(lineHeightValuePixel); 

      lineHeightValue = lineHeightValue - 5;
      lineHeightValuePixel = lineHeightValue + "px";
      setPrintLineHeight(lineHeightValuePixel);
    }
  }

   function RefreshPage(){
    //alert('refresh...');
    if(myWindow !== null){
      if(myWindow.closed){
        if(prev_dicomobj!=null){
          //prev_dicomobj.classList.remove("bi-eye-slash");
          //prev_dicomobj.classList.add("bi-eye-fill");
        }
      }
    }
    return true;
   }
      
   const styleTokenizers = {
    'font-size': style => {
    const match = style.match(/font-size:\s*(\d+)px/);
    return match ? [`FONT_SIZE_${match[1]}`] : [];
    },
    'font-family': style => {
    const match = style.match(/font-family:\s*([^;]+)/);
    if (!match) return [];
    const cleaned = match[1].trim().replace(/['"]/g, '').replace(/\s+/g, '_');
    return [`FONT_FAMILY_${cleaned}`];
    },
    'color': style => {
    const match = style.match(/color:\s*([^;]+)/);
    return match ? [`COLOR_${match[1].trim().replace(/#/g, '')}`] : [];
    },
    'background-color': style => {
    const match = style.match(/background-color:\s*([^;]+)/);
    return match ? [`BG_COLOR_${match[1].trim().replace(/#/g, '')}`] : [];
    },
    'text-decoration': style => {
    const match = style.match(/text-decoration:\s*([\w\-]+)/);
    return match ? [`TEXT_DECORATION_${match[1].toUpperCase()}`] : [];
    },
    'text-align': style => {
    const match = style.match(/text-align:\s*(left|right|center|justify)/);
    return match ? [`TEXT_ALIGN_${match[1].toUpperCase()}`] : [];
    },
    'margin': style => {
    const match = style.match(/margin:\s*([^;]+)/);
    return match ? [`MARGIN_${match[1].replace(/\s+/g, '_')}`] : [];
    },
    'padding': style => {
    const match = style.match(/padding:\s*([^;]+)/);
    return match ? [`PADDING_${match[1].replace(/\s+/g, '_')}`] : [];
    },
    'border': style => {
    const match = style.match(/border:\s*([^;]+)/);
    return match ? [`BORDER_${match[1].replace(/\s+/g, '_')}`] : [];
    },
    'width': style => {
    const match = style.match(/width:\s*([^;]+)/);
    return match ? [`WIDTH_${match[1]}`] : [];
    },
    'height': style => {
    const match = style.match(/height:\s*([^;]+)/);
    return match ? [`HEIGHT_${match[1]}`] : [];
    },
    'display': style => {
    const match = style.match(/display:\s*(\w+)/);
    return match ? [`DISPLAY_${match[1].toUpperCase()}`] : [];
    },
};

const handlePastedText = (text, html, editorState) => {
  const raw = window.clipboardData?.getData('application/x-draftjs');
  if (raw) {
    const pastedContentState = convertFromRaw(JSON.parse(raw));
    const fragment = pastedContentState.getBlockMap();

    const currentContent = editorState.getCurrentContent();
    const selection = editorState.getSelection();

    const newContentState = Modifier.replaceWithFragment(
      currentContent,
      selection,
      fragment
    );

    const newEditorState = EditorState.push(
      editorState,
      newContentState,
      'insert-fragment'
    );

    setEditorState(EditorState.forceSelection(newEditorState, newContentState.getSelectionAfter()));
    return 'handled'; // 👈 This prevents Draft.js from doing its own paste
  }

  return 'not-handled';
};

function decodeHTMLEntities(str) {
    const txt = document.createElement('textarea');
    txt.innerHTML = str;
    return txt.value;
}

function HTMLToEditorState(rawHTML) {
    const parser = new DOMParser();
    const cleanedHTML = rawHTML
        .replace(/^<div>(\s*<p>(?:&nbsp;|\s)*<\/p>\s*)+/i, '')
        .replace(/\r/g, '')         // Remove carriage returns
        //.replace(/\u00A0/g, ' ')    // Replace non-breaking spaces
        .trim();
    const decodedHTML = decodeHTMLEntities(cleanedHTML);
    const doc = parser.parseFromString(`<div>${decodedHTML}</div>`, 'text/html');

    const spans = doc.querySelectorAll('span[style]');
    spans.forEach(span => {
        const style = span.getAttribute('style');
        const tokens = [];

        Object.keys(styleTokenizers).forEach(key => {
            tokens.push(...styleTokenizers[key](style));
        });

        if (tokens.length) span.setAttribute('data-style', tokens.join(' '));
    });

    const paragraphs = doc.querySelectorAll('p');

    paragraphs.forEach(p => {
        const html = p.innerHTML;

        // Match leading &nbsp; sequences
        const match = html.match(/^(&nbsp;)+/);
        if (match) {
            const count = match[0].split('&nbsp;').length - 1;

            // Apply a custom data-style token
            const existing = p.getAttribute('data-style') || '';
            const updated = existing ? `${existing} INDENT_${count}` : `INDENT_${count}`;
            p.setAttribute('data-style', updated);
        }
    });

    const preprocessedHTML = doc.body.innerHTML.replace(/^\s*<p>(?:&nbsp;|\s)*<\/p>\s*/i, '').trim();
    const { contentBlocks, entityMap } = htmlToDraft(preprocessedHTML);
    const filteredBlocks = contentBlocks.filter(block => {
        const text = block.getText().trim();
        return text.length > 0 || block.type !== 'unstyled';
    });
    const contentState = ContentState.createFromBlockArray(filteredBlocks, entityMap);
    const eState = EditorState.createWithContent(contentState);

    const raw = convertToRaw(contentState);
    const styleSet = new Set();
    raw.blocks.forEach(block => {
        block.inlineStyleRanges?.forEach(range => styleSet.add(range.style));
    });

    const CSMap = {};
    styleSet.forEach(style => {
        if (style.startsWith('COLOR_')) {
            const hex = '#' + style.replace('COLOR_', '');
            CSMap[style] = { color: hex };
        }
        if (style.startsWith('BG_COLOR_')) {
            const hex = '#' + style.replace('BG_COLOR_', '');
            CSMap[style] = { backgroundColor: hex };
        }
        if (style.startsWith('TEXT_DECORATION_')) {
            CSMap[style] = { textDecoration: style.split('_')[2].toLowerCase() };
        }
        if (style.startsWith('TEXT_ALIGN_')) {
            CSMap[style] = { textAlign: style.split('_')[2].toLowerCase() };
        }
        if (style.startsWith('MARGIN_')) {
            CSMap[style] = { margin: style.replace('MARGIN_', '').replace(/_/g, ' ') };
        }
        if (style.startsWith('PADDING_')) {
            CSMap[style] = { padding: style.replace('PADDING_', '').replace(/_/g, ' ') };
        }
        if (style.startsWith('BORDER_')) {
            CSMap[style] = { border: style.replace('BORDER_', '').replace(/_/g, ' ') };
        }
        if (style.startsWith('WIDTH_')) {
            CSMap[style] = { width: style.replace('WIDTH_', '') };
        }
        if (style.startsWith('HEIGHT_')) {
            CSMap[style] = { height: style.replace('HEIGHT_', '') };
        }
        if (style.startsWith('DISPLAY_')) {
            CSMap[style] = { display: style.split('_')[1].toLowerCase() };
        }
        if (style.startsWith('INDENT_')) {
            const level = parseInt(style.replace('INDENT_', ''), 10);
            CSMap[style] = { marginLeft: `${level * 8}px` }; // or 16px, depending on your design
        }

    });
    return { eState, CSMap };
}

  const showPatientInfo = (event, p_key) => {    
    event.preventDefault();
    let index = patientIndex;
    if(patientData[index].patient_key === p_key){
//alert('patient' + patientData[index].patient_id);
      openViewStudy(null, 'OPEN', index);
    }
    else{
      alert('Wrong patient information, pelase refresh');
    }
  }

  const handleTab = (e) => {
    e.preventDefault();

    const selection = editorState.getSelection();
    const contentState = editorState.getCurrentContent();
    const blockKey = selection.getStartKey();
    const block = contentState.getBlockForKey(blockKey);
    const blockText = block.getText();

    const offset = selection.getStartOffset();

    if (e.shiftKey) {
        // Remove up to 4 leading spaces before cursor
        const start = Math.max(0, offset - 4);
        const beforeCursor = blockText.slice(start, offset);
        const spacesToRemove = beforeCursor.match(/ *$/)?.[0].length || 0;

        if (spacesToRemove > 0) {
            const targetRange = selection.merge({
                anchorOffset: offset - spacesToRemove,
                focusOffset: offset,
            });

            const newContentState = Modifier.removeRange(contentState, targetRange, 'backward');
            const newEditorState = EditorState.push(editorState, newContentState, 'remove-range');
            setEditorState(newEditorState);
        }
    } else {
        // Insert 4 spaces on Tab
        const newContentState = Modifier.insertText(contentState, selection, '    ');
        const newEditorState = EditorState.push(editorState, newContentState, 'insert-characters');
        setEditorState(newEditorState);
    }
  };

  function reportTemplateList(){
    const url = `${process.env.REACT_APP_API_URL}/doctor/getTemplate`;
    const user_key = authUser?.user_key;

    const request_id = randomNumberInRange(1000000, 9000000);
    const userJSON = localStorage.getItem('user');
    let validToken = true;
    if(userJSON===null){
        validToken = false;
    }
    
    if(validToken)
    {
        if(JSON.parse(userJSON)===undefined){
        validToken = false;
        }
    }

    if(validToken)
    {
      if(JSON.parse(userJSON).token===undefined){
      validToken = false;
      }
    }

    if(!validToken){
      alert('Session expired, try to relogin.');
      logout();
      //refreshExpiryToken();
      return false;
    }
    const token = JSON.parse(userJSON).token;

    const config = {
      headers: {
      'content-type': 'application/json',
      //'Access-Control-Allow-Origin': '*',
      //'Access-Control-Allow-Methods': 'POST,PATCH,OPTIONS',
      'Authorization': `Bearer ${token}`,
      'doctor_key': user_key.toString(),
      'request_id': request_id.toString(),
      'template_id': ''          
      },
    };
    try {
        axios.get(url, config).then((response) => {
            var objddlReportTemplate = document.getElementById("ddlReportTemplate");
            if(response.data.length > 0){
              setReportTemplates(response.data);
              objddlReportTemplate.style.display='inline';
            }
            else
            {
              objddlReportTemplate.style.display='none';
            }
        })
        .catch(error => {
          if(error.response.data.message==='Unauthorized')
          {
            alert('Unauthorized session, try to relogin.');
            logout();
          }
          else{
            alert(error.response.data.message);
          }
        });
    } catch (err) {
      if (err.code === '404') {
        return
      }
    }
  }

  const selectReportTemplate = (event) => {
    var templateId = event.target.value;
    if(templateId === '[CLEAR FILTER]')
    {
      ReportTemplateFilter('', '', '', true);
      return true;
    }
    
    if (templateId) { 
      var blankReportContent = false;
      if(markupReport==='' || markupReport===`<p></p>\n`
         || markupReport===`<h1></h1>\n`
         || markupReport===`<h2></h2>\n`
         || markupReport===`<h3></h3>\n`
         || markupReport===`<h4></h4>\n`
        ){
          blankReportContent = true;
      }

      if(!blankReportContent){
        if(window.confirm('The report already contains data. Do you want to overwrite the template report?')!== true) {
          return false;
        }
      }

      const selectedTemplate = reportTemplates.find(template => String(template.template_id) === templateId); 
      if (selectedTemplate) {        
          const { eState, CSMap } = HTMLToEditorState(selectedTemplate.report_template);
          setEditorState(eState);
          setCustomeStyleMap(CSMap);
      }
      else{
        alert('Report template assignment failed based on the selected template.');
      }
    }
  }

   const copyClipboard = (event, index, patient_key) => {
    event.preventDefault();
 
    var textCopy = 'Patient: ' + patientData[index].patient_id + ' - ' + patientData[index].patient_name 
      + ', Age/Sex: ' + patientData[index].patient_age.toString() 
      + patientData[index].patient_age_unit + '-' + patientData[index].patient_sex
      + '\r\nStudy: ' + patientData[index].modality + ' - ' + patientData[index].study_description;

    navigator.clipboard.writeText(textCopy).then(() => {
      //alert("Text copied to clipboard!");
      var objbtnCopyClip = document.getElementById(`btnCopyClip_`+ patient_key.toString());
      if(objbtnCopyClip!==null){
        objbtnCopyClip.classList.remove("bi-clipboard");
        objbtnCopyClip.classList.add("bi-clipboard-check");
      }
    }).catch(err => {
      console.error("Failed to copy text: ", err);
    });
    
  };

   function pageClick(index, report_status, priority, refreshGrid) {
    if(refreshGrid===undefined){
      refreshGrid = true;
    }

    var objtxtpage_no_s = document.getElementById("txtpage_no_s");
    var page_count = parseInt(objtxtpage_no_s.tag, 10);

    var page_index = 0; var objlnkpageno; var objlnkpageno_old;

    var objpageFirst = document.getElementById("pageFirst");
    var objpageLast = document.getElementById("pageLast");
    var objpagePrev = document.getElementById("pagePrev");
    var objpageNext = document.getElementById("pageNext");

    if(index === 0){
      objlnkpageno = document.getElementById("lnkpagenoLast");
      page_index = page_count;
    }
    else{
      objlnkpageno = document.getElementById("lnkpageno"+ index.toString());
      if(objlnkpageno===null){
        page_index = index;  
      }
      else{
        page_index = parseInt(objlnkpageno.innerText, 10);
      }
    }

    if(pageIndex === page_count || index === page_count){
      objlnkpageno_old = document.getElementById("lnkpagenoLast");
    }
    else{
      objlnkpageno_old = document.getElementById("lnkpageno"+ pageIndex.toString());
    }

    if(page_index === 1 || page_count === 1 || page_count === 0){
      objpageFirst.classList.add('disabled');
      objpagePrev.classList.add('disabled');
    }
    else
    {
      objpageFirst.classList.remove('disabled');
      objpagePrev.classList.remove('disabled');
    }

    if(page_count === 1 || page_index === page_count){
      objpageLast.classList.add('disabled');
      objpageNext.classList.add('disabled');
    }
    else 
    {
      objpageLast.classList.remove('disabled');
      objpageNext.classList.remove('disabled');
    }

    if((page_index > 0 && page_index <= page_count) || refreshGrid)
    {
      if(objlnkpageno_old!==null){
        objlnkpageno_old.parentNode.classList.remove("active");
      }
      if(objlnkpageno!==null){
        objlnkpageno.parentNode.classList.add("active");
      }
      setPageIndex(page_index);

      if(report_status===undefined){
        report_status = search_report_status;
      }
      if(priority===undefined){
        priority = search_priority;
      }

      if(refreshGrid)
      {
        patientStudyList(report_status, priority, page_index, false);
      }
    }
   }

   function pageSearch () {
    var objtxtpage_no_s = document.getElementById("txtpage_no_s");
    var page_count = parseInt(objtxtpage_no_s.tag, 10);
    if(parseInt(objtxtpage_no_s.value, 10) > 0 && parseInt(objtxtpage_no_s.value, 10) <= page_count)
    {
      var page_index = parseInt(objtxtpage_no_s.value, 10);
      setPageIndex(page_index);
      patientStudyList(search_report_status, search_priority, page_index, false);
    }
    else{
      alert('Invalid page number searching, ' + objtxtpage_no_s.title);
    }
   }
   function pagePrev()
   {
    pageNavigate('Prev');
   }
   function pageNext()
   {
      pageNavigate('Next');
   }
   function pageNavigate(actionFlag)
   {
      var objtxtpage_no_s = document.getElementById("txtpage_no_s");
      var page_count = parseInt(objtxtpage_no_s.tag, 10);

      var page_index = pageIndex;
      var processFlag = false;
      if(actionFlag==='Next'){
        if(page_index < page_count){
          page_index++;
          processFlag = true;
        }
      }
      else if(actionFlag==='Prev'){
        if(page_index > 1){
          page_index--;
          processFlag = true;
        }
      }

      if(processFlag){
        pageClick(page_index);
      }
   }
   function pageSizeChange(page_index, refresh) {
    if(page_index===undefined || page_index===null){
      page_index = pageIndex;
    }

    var objddlpage_size_s = document.getElementById("ddlpage_size_s");
    const page_size = objddlpage_size_s.options[objddlpage_size_s.selectedIndex].innerHTML;
  
    var objbtnpagesearch = document.getElementById("btnpagesearch");
    var paginateCount = parseInt(objbtnpagesearch.value, 10);
    
    var objtxtpage_no_s = document.getElementById("txtpage_no_s");
    var page_count = 0;
    if(page_size > 0 && paginateCount > 0){
      page_count = paginateCount/page_size;
      var arraypage_count = page_count.toString().split('.');
      
      if(arraypage_count.length>1)
      {
        page_count = parseInt(arraypage_count[0], 10);
        if(parseInt(arraypage_count[1], 10)>0){
          page_count++;
        }
      }
    }
    if(page_count===0){
      page_index = page_count;
    }
    objtxtpage_no_s.placeholder = page_index.toString() + ' of ' + parseInt(page_count, 10).toString();
    objtxtpage_no_s.title = 'Total Page: ' + parseInt(page_count, 10).toString();
    objtxtpage_no_s.tag = page_count;

    var objlnkpagenoLast = document.getElementById("lnkpagenoLast");
    objlnkpagenoLast.innerText = page_count;

    if(refresh){
      pageClick(1);
    }
   }

  function sortClick (event, column_name){
    var sort_col_name = column_name;
    var sort_col_value = '';

    if(event.target.className.indexOf("arrow-up")>=0)
    {
      sort_col_value = "DESC";

      //event.target.classList.remove('icon-muted');

      event.target.classList.remove('bi-arrow-up');
      event.target.classList.add('bi-arrow-down');
    }
    else
    {
      sort_col_value = "ASC";

      event.target.classList.remove('bi-arrow-down');
      event.target.classList.add('bi-arrow-up');
    }

    if(prev_sort_col_name!== sort_col_name){
      prev_sort_col_name = sort_col_name;
    }

    setSortColName(sort_col_name);
    setSortColValue(sort_col_value);

    patientStudyList(search_report_status, search_priority,  null, false, null, null, null, sort_col_name, sort_col_value);
  }
  const handleSearchChange = (event) => {
      var filter_col_name = event.target.id;
      var filter_col_value = event.target.value; 
      
      if(filter_col_name==='center_id' && filter_col_value.length < 4 && filter_col_value !== ''){
        return;
      }

      var forceReset = false;
      if(filter_col_name==='regn_date'){
        forceReset = true;
        if(filter_col_value===''){
          filter_col_name = ''; 
          filter_col_value = '';
        }
        else{
          var value_split = filter_col_value.split('-');
            filter_col_value = value_split[2] + '-' + value_split[1] + '-' + value_split[0];
        }
      }

      if(filter_col_name==='modality'){
        if(filter_col_value==='' || filter_col_value==='DX' || filter_col_value==='MG' || filter_col_value==='CT' || filter_col_value==='ECG'){
          ;
        }
        else{
          filter_col_name='study_description';
          filter_col_value = '%'+filter_col_value + '%';
        }
      }

      //alert( filter_col_name + ': ' + filter_col_value);

      if(prev_filter_col_name!== filter_col_name){
        prev_filter_col_name = filter_col_name;
      }

      if(filter_col_name==='patient_name'
        || filter_col_name==='report_status_desc')
      {
        filter_col_value = filter_col_value + '%';
        forceReset = true;
      }

      setFilterColName(filter_col_name);
      setFilterColValue(filter_col_value);

      patientStudyList(search_report_status, search_priority, null, forceReset, null, filter_col_name, filter_col_value, null, null);
      //setPatientData({ ...patientData, [event.target.name]: event.target.value });
    };

    function randomNumberInRange(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    function tabReportClick(event, reportNo, ignoreAssignContent)
    {
      if(event!==null){
        event.preventDefault();
      }
      
      if(ignoreAssignContent){;}
      else{
        document.getElementById('report'+reportIndex.toString()+'-tab').tag = markupReport;
      }
      setReportIndex(reportNo);
      var report_content = document.getElementById('report'+reportNo.toString()+'-tab').tag;
      
      //report_content = report_content.replace(/ins>/g, "u>");
      
      //setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(report_content))));
      const { eState, CSMap } = HTMLToEditorState(report_content);
      setEditorState(eState);
      setCustomeStyleMap(CSMap);

      if(authUser?.user_type === 'D' || authUser?.user_type === 'R'){
        var objddlReportTemplate = document.getElementById("ddlReportTemplate");
        if(objddlReportTemplate != null ){
          objddlReportTemplate.selectedIndex = 0;
        }
      }
    }
    function ReportTemplateFilter(modality_filter, study_desc_filter, body_part_filter, displayAll)
    {
      if(authUser?.user_type === 'D' || authUser?.user_type === 'R'){
      
        let filteredTmpl;
        if(displayAll){
          filteredTmpl = reportTemplates;
        }
        else
        {
          let tmpl_modality = modality_filter;
          if(tmpl_modality==='CR') { tmpl_modality = 'DX'; }

          let study_desc_filter2 = '';

          if(study_desc_filter.toLowerCase().indexOf('pelvis')>=0){
            study_desc_filter2 = 'hip';
          }
          else if(study_desc_filter.toLowerCase().indexOf('hip')>=0){
            study_desc_filter2 = 'pelvis';
          }
          else if(study_desc_filter.toLowerCase().indexOf('thump')>=0){
            study_desc_filter2 = 'hand';
          }
          else if(study_desc_filter.toLowerCase().indexOf('hand')>=0){
            study_desc_filter2 = 'thump';
          }
          else if(study_desc_filter.toLowerCase().indexOf('ankel')>=0){
            study_desc_filter2 = 'ankle';
          }

          let study_desc_filter3 = '';
          if(study_desc_filter.toLowerCase().indexOf('forearm')>=0){
            study_desc_filter3 = 'wrist';
          }
          
          /*BARIUM*/
          let study_desc_barium = '';
          if(body_part_filter.toUpperCase().indexOf('ABDOMEN')>=0){
            study_desc_barium = 'BARIUM';
          }
          else if(study_desc_filter.toUpperCase().indexOf('BA-MEAL')>=0){
            study_desc_barium = 'BARIUM';
          }
          else if(study_desc_filter.toUpperCase().indexOf('BA MEAL')>=0){
            study_desc_barium = 'BARIUM';
          }
          else if(study_desc_filter.toUpperCase().indexOf('BA  FOLLOW')>=0){
            study_desc_barium = 'BARIUM';
          }
          else if(study_desc_filter.toUpperCase().indexOf('BA FOLLOW')>=0){
            study_desc_barium = 'BARIUM';
          }
          else if(study_desc_filter.toUpperCase().indexOf('BA. FOLLOW')>=0){
            study_desc_barium = 'BARIUM';
          }
          else if(study_desc_filter.toUpperCase().indexOf('ABDOMEN')>=0){
            study_desc_barium = 'BARIUM';
          }
          else if(study_desc_filter.toUpperCase().indexOf('BA. ILOCICCAL')>=0){
            study_desc_barium = 'BARIUM';
          }
          else if(study_desc_filter.toUpperCase().indexOf('BA ILOCICCAL')>=0){
            study_desc_barium = 'BARIUM';
          }
          else if(study_desc_filter.toUpperCase().indexOf('BE AC')>=0){
            study_desc_barium = 'BARIUM';
          }
          else if(study_desc_filter.toUpperCase().indexOf('BA SWALLOW')>=0){
            study_desc_barium = 'BARIUM';
          }
          
          /*HSG*/
          let study_desc_hsg = '';
          if(body_part_filter.toUpperCase().indexOf('HSG')>=0){
            study_desc_hsg = 'HSG';
          }
          else if(study_desc_filter.toUpperCase().indexOf('H.S.G')>=0){
            study_desc_hsg = 'HSG';
          }
          
          filteredTmpl = reportTemplates.filter((template) =>
            (template['modality'] === tmpl_modality) &&
            (template['category'] === "" 
              || study_desc_filter.toLowerCase().includes(String(template['category']).toLowerCase())
              || study_desc_filter2.toLowerCase().includes(String(template['category']).toLowerCase())
              || study_desc_filter3.toLowerCase().includes(String(template['category']).toLowerCase())
              || study_desc_barium.toLowerCase().includes(String(template['category']).toLowerCase())
              || study_desc_hsg.toLowerCase().includes(String(template['category']).toLowerCase())
              || body_part_filter.toLowerCase().includes(String(template['category']).toLowerCase())
            ) 
          );
          
          if(filteredTmpl.length === 0)
          {
            filteredTmpl = reportTemplates;
          }
        }

        setReportTemplatesFiltered(filteredTmpl);
      
        var objddlReportTemplate = document.getElementById("ddlReportTemplate");
        if(objddlReportTemplate != null ){
          objddlReportTemplate.selectedIndex = 0;
        }
      }
    }
    function tabAddClick()
    {
      var report_count = parseInt(document.getElementById('myReportTab').tag, 10);
      document.getElementById('report'+(report_count+1).toString()+'-tab').style.display = '';
      
      if(report_count===3)
      {
        document.getElementById('btnreportadd').style.display = 'none';
      }
      document.getElementById('btnreportremove').style.display = '';
      
      document.getElementById('myReportTab').tag = (report_count+1).toString();
      
      document.getElementById('report'+(report_count+1).toString()+'-tab').ariaSelected = false;
      document.getElementById('report'+(report_count+1).toString()+'-tab').classList.remove("active");
    }
    function tabRemoveClick()
    {
      var report_count = parseInt(document.getElementById('myReportTab').tag, 10);
      if(report_count>1)
      {
        document.getElementById('report'+report_count.toString()+'-tab').tag = '';
        document.getElementById('report'+report_count.toString()+'-tab').style.display = 'none';
      }
      
      if(report_count===2)
      {
        document.getElementById('btnreportremove').style.display = 'none';
      }
      document.getElementById('btnreportadd').style.display = '';
      document.getElementById('myReportTab').tag = (report_count-1).toString();
      
      if(reportIndex===report_count){

        document.getElementById('report'+reportIndex.toString()+'-tab').ariaSelected = false;
        document.getElementById('report1-tab').ariaSelected = true;

        document.getElementById('report'+reportIndex.toString()+'-tab').classList.remove("active");

        document.getElementById('report1-tab').classList.remove("active");
        document.getElementById('report1-tab').classList.add("active");
        
        tabReportClick(null, 1, true);
      }
    }
    function tabClick(report_status, priority) {
      patientStudyList(report_status, priority, 1, true);
    }
    function refreshExpiryToken()
    {
      return prop.refreshToken();
    }
    function patientStudyList(report_status, priority, page_index, forceReset, autoRefresh, filter_col_name, filter_col_value, sort_col_name, sort_col_value) {
      if(forceReset===undefined || forceReset === null){
        forceReset = false;
      }
      if(autoRefresh===undefined || autoRefresh === null){
        autoRefresh = false;
      }

      if(prev_dicomobj!=null){
        //prev_dicomobj.classList.remove("bi-eye-slash");
        //prev_dicomobj.classList.add("bi-eye-fill");
      }

      search_report_status = report_status;
      search_priority = priority;
      var objddlpage_size_s = document.getElementById("ddlpage_size_s");
      
      const page_size = objddlpage_size_s.options[objddlpage_size_s.selectedIndex].innerHTML;
      const url = `${process.env.REACT_APP_API_URL}/patients`;
      
      const user_key = authUser?.user_key;
      const center_key = authUser?.center_key;

      if(page_index===undefined || page_index===null){
        page_index = pageIndex;
      }

      if(filter_col_name===undefined || filter_col_name===null){
        filter_col_name = filterColName;
        filter_col_value = filterColValue;
      }
      
      if(sort_col_name===undefined || sort_col_name===null){
        sort_col_name = sortColName;
        sort_col_value = sortColValue;
      }

      var objddlSelection = document.getElementById("ddlSelection");
      var search_flag = objddlSelection.options[objddlSelection.selectedIndex].value;

      const request_id = randomNumberInRange(1000000, 9000000);
      const userJSON = localStorage.getItem('user');
      let validToken = true;
      if(userJSON===null){
        validToken = false;
      }
      
      if(validToken)
      {
        if(JSON.parse(userJSON)===undefined){
          validToken = false;
        }
      }

      if(validToken)
      {
        if(JSON.parse(userJSON).token===undefined){
          validToken = false;
        }
      }

      if(!validToken){
        alert('Session expired, try to relogin.');
         logout();
         //refreshExpiryToken();
        return false;
      }
      const token = JSON.parse(userJSON).token;

      const config = {
        headers: {
          'content-type': 'application/json',
          //'Access-Control-Allow-Origin': '*',
          //'Access-Control-Allow-Methods': 'POST,PATCH,OPTIONS',
          'Authorization': `Bearer ${token}`,
          'user_key': user_key.toString(),
          'center_key': center_key.toString(),
          'report_status': report_status,
          'priority': priority,
          'request_id': request_id.toString(),
          'page_index': page_index.toString(),
          'page_size': page_size,
          'filter_col_name': filter_col_name,
          'filter_col_value': filter_col_value,
          'sort_col_name': sort_col_name,
          'sort_col_value': sort_col_value,
          'search_flag': search_flag
        },
      };
  //alert(sort_col_name + ' - ' + sort_col_value); 
      try {
        
        if(!autoRefresh){
          ProcessStatus(true, false, filter_col_value);
        }

        axios.get(url, config).then((response) => {
          //alert('response'); alert(JSON.stringify(response.data));
          //console.log(response.data);
          //console.log(JSON.stringify(response.data));

         //var total_count = response?.headers?.["X-Total-Count"];
         //var paginate_count = response?.headers?.["X-Total-Paginate"];

        let updatedValue = {};
        updatedValue = response.data; 
        
        var record_exist = false;
        if(updatedValue.length>0){
          if(updatedValue[0].patient_key>0){
            record_exist = true;
          }

          let def_modality = localStorage.getItem('def_modality');
          if(def_modality===null){
            localStorage.setItem('def_modality', updatedValue[0].modality);
          }

          setPendingCount(updatedValue[0].pending_count);
          setWaitingCount(updatedValue[0].waiting_count);
          setHoldCount(updatedValue[0].hold_count);
          setDraftCount(updatedValue[0].draft_count);
          setReviewCount(updatedValue[0].review_count);
          if(authUser?.user_type === 'U'){
            setSignedoffCount(updatedValue[0].signedoff_count);
          }
          setUrgentCount(updatedValue[0].urgent_count);
          if(updatedValue[0].urgent_count>0)
          {
            document.title = '('+updatedValue[0].urgent_count.toString()+')Teleradiology';
          }
          else{
            document.title = 'Teleradiology';
          }
         }
         else
         {
          setPendingCount(0);
          setWaitingCount(0);
          setHoldCount(0);
          setDraftCount(0);
          setReviewCount(0);
          setSignedoffCount(0);
          setUrgentCount(0);
          document.title = 'Teleradiology';
         }
        
         ProcessStatus(false, record_exist, filter_col_value);
         
         if(record_exist || forceReset){
            //const data = JSON.stringify(response.data);

            if(record_exist){
              setPatientData(updatedValue);
            }
            else
            {
              setPatientData([]); 
            }
            
            var paginateCount = 0;
            if(updatedValue.length>0){
             paginateCount = updatedValue[0].paginateCount;
            }
            var objbtnpagesearch = document.getElementById("btnpagesearch");
            objbtnpagesearch.value = paginateCount;
            
            pageSizeChange(page_index, false);

            if(forceReset){
              pageClick(page_index, report_status, priority, false);

              var objtxtpage_no_s = document.getElementById("txtpage_no_s");
              var page_count = parseInt(objtxtpage_no_s.tag, 10);
              
              if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)  && 1===2){
               ; 
              }
              else {

                if(page_count < 4) {
                  document.getElementById("lnkpagenoLast").parentNode.style.display='none';
                  document.getElementById("lnkpagenomore").parentNode.style.display='none';
                }
                else {
                  document.getElementById("lnkpagenoLast").parentNode.style.display='';
                  document.getElementById("lnkpagenomore").parentNode.style.display='';
                }

                if(page_count < 3) {
                  document.getElementById("lnkpageno3").parentNode.style.display='none';
                }
                else {
                  document.getElementById("lnkpageno3").parentNode.style.display='';
                }

                if(page_count < 2) {
                  document.getElementById("lnkpageno2").parentNode.style.display='none';
                }
                else {
                  document.getElementById("lnkpageno2").parentNode.style.display='';
                }
              }
            }
         }

          /*
          setPatientData(patientData => ({
              ...patientData,
              ...updatedValue
              }));
          */
              

        })
       .catch(error => {
        if(error.response.data.message==='Unauthorized')
        {
          alert('Unauthorized session, try to relogin.');
          logout();
        }
        else{
          ProcessStatus(false, false, filter_col_value);
          alert(error.response.data.message);
        }
       });

      } catch (err) {
        ProcessStatus(false, false, filter_col_value);
        //alert('error');
          //alert(err.code);
        if (err.code === '404') {
          //setError('Object does not exist.')
          return
        }
      }
  
    }
    function ProcessStatus(buttonDisabled, record_exist, filter_col_value) {
      if(buttonDisabled){
        document.getElementById("divLoading").style.display = '';
        document.getElementById("divLoading").innerHTML = 'Processing...';
      }
      else
      {
        document.getElementById("divLoading").innerHTML = '';
        document.getElementById("divLoading").style.display = 'none';

        if(record_exist)
         {
            document.getElementById("divStatusResult").innerHTML = '';
            document.getElementById("divStatusResult").style.display = 'none';
         }
         else{
            document.getElementById("divStatusResult").style.display = '';
            
            if(filter_col_value===''){
              document.getElementById("divStatusResult").innerHTML = 'No Record Found!';
            }
            else{
              document.getElementById("divStatusResult").innerHTML = 'Search value '+filter_col_value+' does not found any record.';
            }
         }
      }
    }

    function handleChangeUploadFile(e) {
      if (e.target.files) {
        setFileCount(e.target.files.length);
        setFile(e.target.files);
  
        if (window.File && window.FileReader && window.FileList && window.Blob) {
          const files = e.target.files;
          //console.log(files[1].name);
  
          const output = document.querySelector("#attachFileResult");
          output.innerHTML = "";
          for (let i = 0; i < files.length; i++) {
            if (!files[i].type.match("image")) continue;
            const picReader = new FileReader();
            // console.log(picReader);
            picReader.addEventListener("load", function (event) {
              const picFile = event.target;
              //console.log(picFile);
              const div = document.createElement("div");
              div.className = "col-2";
              div.innerHTML = `<div class ="mb-2"><div id="display_report`+i.toString()+`"><img class ="thumbnail2" src="${picFile.result}"/>
              <div class ="row float-right py-2 px-2">
              <div class ="col-4">
              <button type="button" style="display:none" class ="btn btn-outline-danger btn-sm hist-btn bi bi-cloud-arrow-down-fill" title="Download"></button>
              </div>
              <div class ="col-4">
              <button type="button" class ="btn btn-outline-danger btn-sm hist-btn bi-box-arrow-up-right" title="Show" onclick="window.open('${picFile.result}', 'mytsoftdicom-attachfile')"></button>
              </div>
              <div class ="col-4">
              <button type="button" style="display:none" class ="btn btn-outline-danger btn-sm hist-btn bi bi bi-trash3-fill" title="Remove"></button>
              </div>                                
              </div>
              </div>
              </div>`;
              output.appendChild(div);
            });
            picReader.readAsDataURL(files[i]);
          }
        } else {
          alert("Your browser does not support File API");
        }
      }
    }

    function handleChangeNotesFile(e) {
      if (e.target.files) {
        setNotesFileCount(e.target.files.length);
        setNotesFile(e.target.files);
      }
    }
    const selectAssignDoctor = (event, doctor_key, assign_dr_allow) => {
      event.preventDefault();
      if(assign_dr_allow === "N") {
        ;
      }
      else{
        setAssignDoctorKey(doctor_key);
      }
    }

    const selectStudyNoneLowHigh = (event, StudyPriorityLevel) => {
      event.preventDefault();
      setStudyPriorityLevel(StudyPriorityLevel);
    }

    const openAssignDoctor = (event, param, index) => {
      event.preventDefault();

      if(index!=null){
        setPatientIndex(index);
      }
 
      if(param === 'OPEN'){
        document.getElementById("spnassign_doctor").innerHTML = '🧑' + patientData[index].patient_name + ' | Center: ' + patientData[index].center_id + '-' + patientData[index].center_name.slice(0,25);

        document.getElementById("hidc_key_assigndr").value = patientData[index].center_key;
        document.getElementById("hidp_key_assigndr").value = patientData[index].patient_key;

        document.getElementById("hiddoctor_key").value = patientData[index].doctor_key;
        setAssignDoctorKey(patientData[index].doctor_key);
        
        document.getElementById("hidpriority_level").value = patientData[index].priority_level;
        setStudyPriorityLevel(patientData[index].priority_level);
        
        if (!authUser){
          alert('Unauthorized session, please try to relogin.');
          return null;
        }

        const url = `${process.env.REACT_APP_API_URL}/doctor`;
  
        const user_key = authUser?.user_key;
        const center_key = patientData[index].center_key;
        const patient_key = patientData[index].patient_key;
        const doctor_key = patientData[index].doctor_key;

        const request_id = randomNumberInRange(1000000, 9000000);
        const token = JSON.parse(localStorage.getItem('user')).token;
        const action_tag = "";
        const config = {
          headers: {
            'content-type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'user_key': user_key.toString(),
            'center_key': center_key.toString(),
            'patient_key': patient_key.toString(),
            'doctor_key': doctor_key.toString(),
            'action_tag': action_tag,
            'request_id': request_id.toString()
          },
        };
    
        try {
          
          setDoctorListData([]); 
          document.getElementById('assign_doctor_notes').innerHTML = '';
          document.getElementById('divassign_doctor_notes').style.display = 'none';

          axios.get(url, config).then((response) => { 
            let updatedValue = {};
            if(response.data.length>0){
              updatedValue = response.data; 

              document.getElementById('assign_doctor_notes').innerHTML = response.data[0].assign_dr_notes;
              if(response.data[0].assign_dr_notes!==''){
                document.getElementById('divassign_doctor_notes').style.display = '';
              }

              /*setTimeout(function() {
                for(var i = 0; i<response.data.length; i++){
                  if(response.data[i].select_flag === 'Yes'){
                    var rdoDoctorAssign = document.getElementById(`rdoDoctor_`+response.data[i].doctor_key.toString());
                    if(rdoDoctorAssign!==null){
                      rdoDoctorAssign.checked = true;
                    }
                  }
                }                
              }, 500);              */

            }
           
           setDoctorListData(updatedValue); 
          })
          
        .catch(error => {
          var Unauthorized = false; var errorCatch = '';
          if(error.response!= null)
          {
            errorCatch = 'Exception found!';
            if(error.response.data != null)
            {
              if(error.response.data.message==='Unauthorized')
              {
                Unauthorized = true;
              }
              else
              {
                errorCatch = error.response.data.message;
              }
            }
          }
          else if(error.message!= null)
          {
            errorCatch = error.message;
          }

          if(Unauthorized)
          {
            alert('Unauthorized session, try to relogin.');
            logout();
          }
          else{
            alert(errorCatch);
          }
         });
        } catch (err) {
          //debugger;
            //alert(err.code);
          if (err.code === '404') {
            //setError('Object does not exist.')
            return
          }
        }

      }

      if(index!=null && 1===2){

        setTimeout(function() {
          if(document.getElementById("hidp_key_assigndr").value!==patientData[index].patient_key.toString())
          {
            alert('Wrong patient details updating, refresh and try again.');
            return false;
          }

          if(document.getElementById("hidc_key_assigndr").value!==patientData[index].center_key.toString())
          {
            alert('Wrong center patient updating, refresh and try again.');
            return false;
          }
        }, 1000);
      }

      if(param==='SAVE'){
        index = patientIndex;

        var action_tag = 'ASSIGN_DOCTOR';
        var user_key = authUser?.user_key; 
        
        var report_count = 1;
        var report_content = '';
        var report_content2 = '';
        var report_content3 = '';
        var report_content4 = '';

        var notes = '';

        var center_key = document.getElementById("hidc_key_assigndr").value;
        var patient_key = document.getElementById("hidp_key_assigndr").value;
        var doctor_key_old = document.getElementById("hiddoctor_key").value;
        var priority_level_old = document.getElementById("hidpriority_level").value;
        var doctor_key = assignDoctorKey;
        var priority_level = studyPriorityLevel;
        if(doctor_key===0){
          alert('Please select available doctor/radiologist');
          return false;
        }
        
        if(doctor_key.toString()===doctor_key_old){
          if(priority_level.toString()===priority_level_old){
            alert('Selected doctor/adiologist is already assigned and Study priority level remain same');
            return false;
          }
        }

        if(patient_key!==patientData[index].patient_key.toString())
        {
          alert('Wrong patient details updating, refresh and try again.');
          return false;
        }

        if(center_key!==patientData[index].center_key.toString())
        {
          alert('Wrong center patient updating, refresh and try again.');
          return false;
        }

        updateStudy(index, action_tag, user_key, patientData[index].center_key, patientData[index].patient_key, report_count, report_content, report_content2, report_content3, report_content4, notes,patientData[index].patient_name,patientData[index].patient_age,patientData[index].patient_sex,patientData[index].study_description,patientData[index].refer_physician,patientData[index].remarks,patientData[index].priority,patientData[index].patient_age_unit, '', patientData[index].patient_id_ref, doctor_key, null, priority_level);
      }

      let modal = document.querySelector("#modalAssignDoctor");
      modal.classList.toggle("closed");
    };
    
    const openEditStudy2 = (event, param) => {
      event.preventDefault();
      var index=patientIndex;
      openEditStudy(event, param, index);
    }
    const openEditStudy = (event, param, index) => {
      event.preventDefault();

      if(index!=null){
        setPatientIndex(index);
      }

      if(index!=null){
        document.getElementById("spnedit_patient").innerHTML = '🧑' + patientData[index].patient_name + ' | 🎂' + patientData[index].patient_age.toString() + patientData[index].patient_age_unit;
        
        if(patientData[index].report_content === '') 
        {
          document.getElementById('txtstudyname').title = '';
          document.getElementById('txtstudyname').disabled = false;

          document.getElementById('txthistory').title = '';
          document.getElementById('txthistory').disabled = false;
          document.getElementById('historyFiles').disabled = false;
        }
        else
        {
          document.getElementById('txtstudyname').title = 'Add notes if any correction required';
          document.getElementById('txtstudyname').disabled = true;

          document.getElementById('txthistory').title = 'Add notes if any correction required';
          document.getElementById('txthistory').disabled = true;
          document.getElementById('historyFiles').disabled = true;
        }

        if(patientData[index].report_status === "F" || patientData[index].report_status === "S") 
        {
          document.getElementById('chkurgent').disabled = true;
        }
        else
        {
          document.getElementById('btnEditSave').disabled = false;
          document.getElementById('chkurgent').disabled = false;
        }

        document.getElementById("hidc_key").value = patientData[index].center_key;
        document.getElementById("hidp_key").value = patientData[index].patient_key;

        document.getElementById("txtp_id").value = patientData[index].patient_id;
        document.getElementById("txtp_name").value = patientData[index].patient_name;
        document.getElementById("txtage").value = patientData[index].patient_age;
        var patient_age_unit_d = patientData[index].patient_age_unit;
        if(patient_age_unit_d===""){
          patient_age_unit_d="Y";
        }
        document.getElementById("ddlage_unit").value = patient_age_unit_d;
        document.getElementById("txtgender").value = patientData[index].patient_sex;
        document.getElementById("txtp_id_ref").value = patientData[index].patient_id_ref;
        document.getElementById("ddlcase_type").value = patientData[index].case_type;
        
        document.getElementById("txtstudyname").value = patientData[index].study_description; 
        document.getElementById("txtphysician_name").value = patientData[index].refer_physician;
        document.getElementById("txthistory").value = patientData[index].remarks;
        if(patientData[index].priority === "Y"){
          document.getElementById("chkurgent").checked = true;
        }
        else
        {
          document.getElementById("chkurgent").checked = false;
        }

        if(patientData[index].zipcode === "Y"){
          document.getElementById("chkreport_background").checked = true;
        }
        else
        {
          document.getElementById("chkreport_background").checked = false;
        }

        document.getElementById('historyFiles').value = '';
        setFileCount(0);
        setFile(null);
        
        document.getElementById("hidattachcount").value = patientData[index].attach_file_count;
        document.getElementById("hidattachjson").value = patientData[index].attach_json_data;

        const output = document.querySelector("#attachFileResult");
        output.innerHTML = "";
      
        if(patientData[index].attach_file_count> 0){
          var attachJSON = JSON.parse(patientData[index].attach_json_data);
          
          for (let i = 0; i < attachJSON.files.length; i++) {
            //if (!files[i].type.match("image")) continue;
            const picReader = new FileReader();
            // console.log(picReader);
            //picReader.addEventListener("load", function (event) {
              
              //console.log(picFile);
              const div = document.createElement("div");
              div.className = "col-2";
              div.innerHTML = `<div class ="mb-2"><div id="display_report`+i.toString()+`"><img class ="thumbnail2" src="${attachJSON.files[i].fileUrl}"/>
              <div class ="row float-right py-2 px-2">
              <div class ="col-4">
              <button type="button" style="display:none;" class ="btn btn-outline-danger btn-sm hist-btn bi bi-cloud-arrow-down-fill" title="Download" onclick="AttachImageAction('D',${i},'${attachJSON.files[i].fileUrl}')"></button>
              </div>
              <div class ="col-4">
              <button type="button" class ="btn btn-outline-danger btn-sm hist-btn bi-box-arrow-up-right" title="Show" onclick="window.open('${attachJSON.files[i].fileUrl}', 'mytsoftdicom-attachfile')"></button>
              </div>
              <div class ="col-4">
              <button type="button" style="display:none;" class ="btn btn-outline-danger btn-sm hist-btn bi bi bi-trash3-fill" title="remove" onclick="AttachImageAction('R',${i},'${attachJSON.files[i].fileUrl}')"></button>
              </div>                                
              </div>
              </div>
              </div>`;
              output.appendChild(div);
            //});
            //picReader.readAsDataURL(attachJSON.files[i].fileUrl);
          }
        }

        setTimeout(function() {
          if(document.getElementById("hidp_key").value!==patientData[index].patient_key.toString())
          {
            alert('Wrong patient details updating, refresh and try again.');
            return false;
          }

          if(document.getElementById("hidc_key").value!==patientData[index].center_key.toString())
          {
            alert('Wrong center patient updating, refresh and try again.');
            return false;
          }
        }, 1000);
      }

      if(param==='SAVE'){
        index = patientIndex;

        if(authUser?.user_type === 'D' || authUser?.user_type === 'R')
        {
          alert('Permission denied for the user');
          return false;
        }

        /*if(patientData[index].report_status === "F")
        {
          alert('Cannot allow to edit after printed.');
          return false;
        }*/

        var action_tag = 'EDIT_PATIENT';
        var user_key = authUser?.user_key; 
        
        var report_count = 1;
        var report_content = '';
        var report_content2 = '';
        var report_content3 = '';
        var report_content4 = '';

        var notes = '';

        var center_key = document.getElementById("hidc_key").value;
        var patient_key = document.getElementById("hidp_key").value;

        var patient_id = document.getElementById("txtp_id").value;
        var patient_name = document.getElementById("txtp_name").value;
        var patient_age = document.getElementById("txtage").value;
        var patient_age_unit = document.getElementById("ddlage_unit").value;
        var patient_sex = document.getElementById("txtgender").value;
        var patient_id_ref = document.getElementById("txtp_id_ref").value;
        var case_type = document.getElementById("ddlcase_type").value;
        var study_description = document.getElementById("txtstudyname").value; 
        var refer_physician = document.getElementById("txtphysician_name").value;
        var remarks = document.getElementById("txthistory").value;
        var priority = 'N';
        
        if(document.getElementById("chkurgent").checked){
          if(remarks===''){
            alert('History cannot be blank for urgent study');
            return false;
          }
          priority = 'Y';
        }

        var report_background = 'N';
        if(document.getElementById("chkreport_background").checked){
          report_background = 'Y';
        }

        if(patient_id===''){
          alert('Patient id cannot be blank');
          return false;
        }
        if(patient_name===''){
          alert('Patient name cannot be blank');
          return false;
        }
        if(patient_age==='' || patient_age==='0'){
          alert('Patient age cannot be blank');
          return false;
        }
        else
        {
          patient_age = parseFloat(patient_age);
        }

        if(patient_age===0){
          alert('Patient age cannot be blank, numberic value only');
          return false;
        }
        else{
          var patient_age_tmp = patient_age.toString().split(`.`);
          if( patient_age_tmp.length>1){
              if(patient_age_unit===`Y`)
              {
                if(parseFloat(patient_age_tmp[1]) > 11)
                {
                  alert('Invalid patient age in months, cannot exceed 11months and convert to year.');
                  return false;
                }
              }
              else if(patient_age_unit===`M`)
              {
                if(parseFloat(patient_age_tmp[1]) > 30)
                {
                  alert('Invalid patient age in days, cannot exceed 30days and convert to month.');
                  return false;
                }
              }
              else if(patient_age_unit===`D`)
              {
                if(parseFloat(patient_age_tmp[1]) > 0)
                {
                  alert('Invalid patient age in days, avoid decimal digit.');
                  return false;
                }
              }
            }
        }
        
        if(patient_sex===''){
          alert('Patient gender cannot be blank');
          return false;
        }
        else
        {
          patient_sex = patient_sex.substring(0, 1);
        }

        if(study_description===''){
          alert('Study name cannot be blank');
          return false;
        }

        if(patient_key!==patientData[index].patient_key.toString())
        {
          alert('Wrong patient details updating, refresh and try again.');
          return false;
        }

        if(center_key!==patientData[index].center_key.toString())
        {
          alert('Wrong center patient updating, refresh and try again.');
          return false;
        }

        updateStudy(index, action_tag, user_key, patientData[index].center_key, patientData[index].patient_key, report_count, report_content, report_content2, report_content3, report_content4, notes,patient_name,patient_age,patient_sex,study_description,refer_physician,remarks,priority, patient_age_unit,'', patient_id_ref,null,null,null, report_background, case_type);
      }

      let modal = document.querySelector("#modal");
      modal.classList.toggle("closed");
    };
    
    const openViewStudy = (event, param, index) => {
      if(event!=null){
        event.preventDefault();
      }

      if(index!=null){
        setPatientIndex(index);
      }

      if(index!=null){
        document.getElementById("spnview_patient").innerHTML = '🧑' + patientData[index].patient_name + ' | 🎂' + patientData[index].patient_age.toString() + patientData[index].patient_age_unit;

        var _case_type = patientData[index].case_type;
        if(_case_type==='NEW') { _case_type = 'New Case';}
        else if(_case_type==='FUP') { _case_type = 'Follow-up';}
        else if(_case_type==='POP') { _case_type = 'Post-operative';}
        else if(_case_type==='SCR') { _case_type = 'Screening';}
        else if(_case_type==='REf') { _case_type = 'Referral';}
        
        var _priority = '';
        if(patientData[index].priority === "Y"){
          _priority = 'Urgent';
        }
        else{
          if(_case_type===''){
            _priority = '.';
          }
        }

        var _sex = patientData[index].patient_sex;
        if(_sex==='M') { _sex = 'Male'; }
        else if(_sex==='F') { _sex = 'Female'; }
        
        var patient_age_unit_d = patientData[index].patient_age_unit;
        if(patient_age_unit_d===""){
          patient_age_unit_d="Y";
        }
        
        document.getElementById("lblpatient_v").innerText = patientData[index].patient_id 
            + ' ' + patientData[index].patient_name 
            + ' ' + patientData[index].patient_age + patient_age_unit_d
            + ' ' + _sex;

        document.getElementById("lblurgent_v").innerText = _case_type + ' ' + _priority; 
        
        var _remarks = patientData[index].remarks;
        if(_remarks!==''){
          _remarks = '• ' + _remarks.replace(/, /g, ',').replace(/, /g, ',').replace(/,/g, '\n • ');
        }
        document.getElementById("lblstudy_v").innerText = '• ' + patientData[index].study_description.replace(/, /g, ',').replace(/, /g, ',').replace(/,/g, '\n • '); 
        document.getElementById("lblhistory_v").innerText = _remarks;
        
        const output = document.querySelector("#attachFileResult_v");
        output.innerHTML = "";
      
        if(patientData[index].attach_file_count> 0){
          var attachJSON = JSON.parse(patientData[index].attach_json_data);
          
          for (let i = 0; i < attachJSON.files.length; i++) {
            //if (!files[i].type.match("image")) continue;
            const picReader = new FileReader();
              
            //console.log(picFile);
            const div = document.createElement("div");
            div.className = "col-2";
            div.innerHTML = `<div class ="mb-2"><div><img class ="thumbnail2" src="${attachJSON.files[i].fileUrl}"/>
              <div class ="row float-right py-2 px-2">
                <div class ="col-4">
                <button type="button" style="display:none;" class ="btn btn-outline-danger btn-sm hist-btn bi bi-cloud-arrow-down-fill" title="Download" onclick="AttachImageAction('D',${i},'${attachJSON.files[i].fileUrl}')"></button>
                </div>
                <div class ="col-4">
                <button type="button" class ="btn btn-outline-danger btn-sm hist-btn bi-box-arrow-up-right" title="Show" onclick="window.open('${attachJSON.files[i].fileUrl}', 'mytsoftdicom-attachfile')"></button>
                </div>
                <div class ="col-4">
                <button type="button" style="display:none;" class ="btn btn-outline-danger btn-sm hist-btn bi bi bi-trash3-fill" title="remove" onclick="AttachImageAction('R',${i},'${attachJSON.files[i].fileUrl}')"></button>
                </div>                                
                </div>
              </div>
            </div>`;
            output.appendChild(div);
          }
        }
      }

      let modal = document.querySelector("#modalShowPatient");
      modal.classList.toggle("closed");
    };

    function ChangeStudyStatus(action_tag, index, dicomUrl, center_key, patient_key, viewerName)
    {
      if(center_key===null){
        center_key = patientData[index].center_key;
        patient_key = patientData[index].patient_key;
      }
      else
      {
        if(patient_key !== patientData[index].patient_key){
          alert(`Patient study changed, refresh the page and try again.`);
          return false;
        }
      }
      
      var notes = '';
      if(action_tag === 'UNLOCK_STUDY'){
        if(patientData[index].report_status !== 'S'){
          alert(`Signed-off status allow to rework study.`);
          return false;
        }
        let unlockReason = prompt(`Please enter reason for unlock`, ``);
        if(unlockReason===null){
          return false;
        }
        if(unlockReason===null || unlockReason === ''){
          alert(`Unlock reason is mandatory.`);
          return false;
        }

        if(patient_key !== patientData[index].patient_key){
          alert(`Patient study changed, refresh the page and try again.`);
          return false;
        }

        notes= 'Unlock Reason: '+unlockReason;
      }
      else if(action_tag === 'REWORK_STUDY'){
        if(patientData[index].report_status !== 'F'){
          alert(`Printed status allow to unlock study.`);
          return false;
        }
        let reworkReason = prompt(`Please enter reason for rework`, ``);
        if(reworkReason===null){
          return false;
        }
        if(reworkReason===null || reworkReason === ''){
          alert(`Rework reason is mandatory.`);
          return false;
        }

        if(patient_key !== patientData[index].patient_key){
          alert(`Patient study changed, refresh the page and try again.`);
          return false;
        }

        notes= 'Rework Reason: '+reworkReason;
      }
      else if(action_tag === 'COPY_STUDY'){
        if(window.confirm('Are you sure want to copy the study, Id: '+patientData[index].patient_id+'?')!== true) 
        {
          return false;
        }
      }

      var user_key = authUser?.user_key; 
      var report_count = 1;
      var report_content = '';
      var report_content2 = '';
      var report_content3 = '';
      var report_content4 = '';
      const priority = 'N';
      const patient_id_ref = '';
      var status = updateStudy(index, action_tag, user_key, center_key, patient_key, report_count, report_content, report_content2, report_content3, report_content4, notes, '', 0, '', '', '', '', priority, '', dicomUrl, patient_id_ref, null, viewerName);
      return status;
    }

    function updateStudy(index, action_tag, user_key, center_key, patient_key, report_count, report_content, report_content2, report_content3, report_content4, notes,patient_name,patient_age,patient_sex,study_description,refer_physician,remarks,priority,patient_age_unit,dicomUrl,patient_id_ref, doctor_key, viewerName, priority_level, report_background, case_type, heart_rate, pr_interval, qrs_duration, qt_interval, qtc_interval, rhythm, axis, p_wave, t_wave, st_segment, q_wave, qrs_complex) {
      var url = `${process.env.REACT_APP_API_URL}/patients/Patient`;

      if(priority===null){
        priority='';
      }
      
      if(case_type===null || case_type===undefined) { case_type='NEW'; }
      if(heart_rate===null || heart_rate===undefined) { heart_rate=0; }
      if(pr_interval===null || pr_interval===undefined) { pr_interval=0; }
      if(qrs_duration===null || qrs_duration===undefined) { qrs_duration=0; }
      if(qt_interval===null || qt_interval===undefined) { qt_interval=0; }
      if(qtc_interval===null || qtc_interval===undefined) { qtc_interval=0; }
      if(rhythm===null || rhythm===undefined) { rhythm=''; }
      if(axis===null || axis===undefined) { axis=''; }
      if(p_wave===null || p_wave===undefined) { p_wave=''; }
      if(t_wave===null || t_wave===undefined) { t_wave=''; }
      if(st_segment===null || st_segment===undefined) { st_segment=''; }
      if(q_wave===null || q_wave===undefined) { q_wave=''; }
      if(qrs_complex===null || qrs_complex===undefined) { qrs_complex=''; }
      
      if(doctor_key===null || doctor_key===undefined){ doctor_key=0; }
      if(viewerName===null || viewerName===undefined){ viewerName=''; }
      if(priority_level===null || priority_level===undefined){ priority_level=0; }
      if(report_background===null || report_background===undefined){ report_background='N'; }

      var action_tag_api = action_tag;
      if(action_tag==='ADD_NOTES_PASTE'){
        action_tag_api = 'ADD_NOTES';
      }

      // 👇 Create new FormData object and append files
      const data = new FormData();
      data.append(`user_key`, user_key.toString());
      data.append(`center_key`, center_key.toString());
      data.append(`patient_key`, patient_key.toString());
      data.append(`action_tag`, action_tag_api.toString());
      
      data.append(`report_count`, report_count);
      data.append(`report_content`, report_content);
      data.append(`report_content2`, report_content2);
      data.append(`report_content3`, report_content3);
      data.append(`report_content4`, report_content4);

      data.append(`notes`, notes);
      data.append(`patient_name`, patient_name);
      data.append(`patient_age`, patient_age);
      data.append(`patient_age_unit`, patient_age_unit);
      data.append(`patient_sex`, patient_sex);
      data.append(`study_description`, study_description);
      data.append(`refer_physician`, refer_physician);
      data.append(`remarks`, remarks);
      data.append(`priority`, priority);
      data.append(`patient_id_ref`, patient_id_ref);
      data.append(`case_type`, case_type);
      data.append(`heart_rate`, heart_rate.toString());
      data.append(`pr_interval`, pr_interval.toString());
      data.append(`qrs_duration`, qrs_duration.toString());
      data.append(`qt_interval`, qt_interval.toString());
      data.append(`qtc_interval`, qtc_interval.toString());
      data.append(`rhythm`, rhythm);
      data.append(`axis`, axis);
      data.append(`p_wave`, p_wave);
      data.append(`t_wave`, t_wave);
      data.append(`st_segment`, st_segment);
      data.append(`q_wave`, q_wave);
      data.append(`qrs_complex`, qrs_complex);

    if (action_tag === "EDIT_PATIENT") {
      data.append(`zipcode`, report_background);
      data.append(`attach_uploadfile_count`, fileCount.toString());

      if(fileCount>0){
        url = `${process.env.REACT_APP_API_URL_EC2}/patients/Patient`;

        files.forEach((file, i) => {
          data.append(`AttachUploadFiles`, file, file.name);
        });
      }
    }

    if (action_tag === "ADD_NOTES" || action_tag === "REWORK_STUDY"
      || action_tag === "UNLOCK_STUDY" || action_tag === "REVIEW_REWORK"
    ) {
      data.append(`attach_uploadfile_count`, notesFileCount.toString());

      if(notesFileCount>0){ 
        url = `${process.env.REACT_APP_API_URL_EC2}/patients/Patient`;

        notesFiles.forEach((file, i) => {
          data.append(`AttachUploadFiles`, file, file.name);
        });
      }
    }
    
    if (action_tag === "ADD_NOTES_PASTE") {
      var notesFileCount_paste=1;

      data.append(`attach_uploadfile_count`, notesFileCount_paste.toString());

      if(notesFileCount_paste>0){  
        url = `${process.env.REACT_APP_API_URL_EC2}/patients/Patient`;
        data.append(`AttachUploadFiles`, filePaste, filePaste.name);
      }
    }

    if(action_tag === 'ASSIGN_DOCTOR'){
      data.append(`doctor_key`, doctor_key.toString());
      data.append(`priority_level`, priority_level.toString());
    }

      const token = JSON.parse(localStorage.getItem('user')).token;
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
          'Authorization': `Bearer ${token}`
        },
      };
  
      /*Network issue recover reports*/
      if((action_tag === 'REPORT_SUBMIT' || action_tag === 'REPORT_SUBMIT_SIGNOFF') 
        && (authUser?.user_type === 'D' || authUser?.user_type === 'R'))
      {
        localStorage.setItem('user_key', authUser?.user_key);
        localStorage.setItem('patient_id', patientData[index].patient_id);
        localStorage.setItem('patient_key', patient_key);
        localStorage.setItem('report_count', report_count);
        localStorage.setItem('api_status', '');
        localStorage.setItem('report_content', report_content);
        localStorage.setItem('report_content2', report_content2);
        localStorage.setItem('report_content3', report_content3);
        localStorage.setItem('report_content4', report_content4);
      }

      try {
          axios.post(url, data, config).then((response) => {
            retryAPICounter = 0;
          //console.log(response.data);
          //alert(JSON.stringify(response.data));
          
         // console.log(JSON.stringify(response.data));

         if((action_tag === 'REPORT_SUBMIT' || action_tag === 'REPORT_SUBMIT_SIGNOFF') 
          && (authUser?.user_type === 'D' || authUser?.user_type === 'R'))
          {
            localStorage.setItem('api_status', 'Y');
          }

         var refreshgrid = false;
         
         if(action_tag === 'LOCK_DICOM' || action_tag === 'LOCK_PATIENT'){
          let updatedValue = {};
          updatedValue = response.data;
          
          var error_code = updatedValue.error_code;
          var error_msg = updatedValue.error_msg;
          
          /*//temp allow asif doctor, no need to lock
          if(authUser?.user_key === 78 || authUser?.user_key === 79)
          {
            error_code='';
          }*/

          if(error_code === '' && search_report_status ==='P' && search_report_status!==updatedValue.report_status){
            alert(`Patient status is changed to `+updatedValue.report_status_desc+`, please refresh and try again.`);
          }
          else if(error_code === ''){
            if(action_tag === 'LOCK_DICOM'){
              
              if(patientData[index].viewer_flag !== 'JPG'){
                openDicomViewer(patientData[index].patient_key, patientData[index].study_key, patientData[index].instance_uid, patientData[index].modality, patientData[index].image_total_count, dicomUrl, viewerName);
              }

              if(search_report_status==='P' || patientData[index].viewer_flag === 'JPG'){
                setTimeout(function() {
                  var caller = '';
                  if(action_tag === 'LOCK_DICOM'){
                    caller = 'DICOM';
                  }

                  const divbody = document.getElementById('body');
                  if(divbody!=null){
                      divbody.style.overflow = 'hidden';
                  }
      
                  openSubmitReportCallBack('OPEN', index, caller);
                }, 1);
              }
            }
            else
            {
              const divbody = document.getElementById('body');
              if(divbody!=null){
                  divbody.style.overflow = 'hidden';
              }
              openSubmitReportCallBack('OPEN', index, '');
            }
          }
          else{
            alert('Study is locked by ' + error_msg);
          }
        }
        else if (action_tag === 'REMOVE_LOCK'){
          openSubmitReportCallBack('CLOSE', index, '');
        }
        else if(action_tag === 'COPY_STUDY'){
          alert('Patient study is copied');
          refreshgrid= true;
        }
        else if(action_tag === 'UNLOCK_STUDY'){
          //if(search_report_status !== 'A'){
            refreshgrid= true;
          //}
        }
        else if(action_tag === 'PRINT_STUDY' || action_tag === 'EXPORT_RTF_STUDY'){
          //if(search_report_status !== 'A'){
            refreshgrid= true;
          //}
        }
        else if(action_tag === 'REWORK_STUDY' 
          || action_tag === 'REVIEW_REWORK'
          || action_tag === 'REVIEW_SIGNOFF'){
          //if(search_report_status !== 'A'){
            refreshgrid= true;
          //}
        }
        else if(action_tag === 'ASSIGN_DOCTOR'){
          let updatedValue = {};
          updatedValue = response.data;
          
          var error_code = updatedValue.error_code;
          var error_msg = updatedValue.error_msg;
          
          if (error_msg === ''){
            patientData[index].doctor_key = doctor_key;
            refreshgrid= true;
            
            setTimeout(function () {
              alert('Radiologist assigned and study priority level updated successfully.');
            }, 100);
          }
          else{
            alert('Study is locked by ' + error_msg);
          }
        }
        else if(action_tag === 'ADD_NOTES' || action_tag === 'ADD_NOTES_PASTE'){
          patientData[index].notes = notes;
          
          refreshgrid=false; /* notes refresh stop from report study screen, direct notes can do it  */

          setNotesFileCount(0);
          setNotesFile(null);

          /*setTimeout(function () {
            alert('Notes added successfully.');
          }, 100);*/
          setAutoCloseTime(autoClose5);
          notifySuccess('Notes added successfully.');
        }
        else if(action_tag === 'REPORT_SUBMIT' || action_tag === 'REPORT_SUBMIT_SIGNOFF'){
          patientData[index].report_content = report_content;
          patientData[index].report_content2 = report_content2;
          patientData[index].report_content3 = report_content3;
          patientData[index].report_content4 = report_content4;
          patientData[index].report_count = report_count;

          if(action_tag === 'REPORT_SUBMIT_SIGNOFF') { refreshgrid= true; }

          if(action_tag === 'REPORT_SUBMIT_SIGNOFF' && search_report_status !== 'A'){
            refreshgrid= true;
          }
        }
        else if(action_tag === 'EDIT_PATIENT'){
          if(patientData[index].patient_id_ref !== patient_id_ref){
            refreshgrid= true;
          }
          else if(patientData[index].patient_name !== patient_name){
            refreshgrid= true;
          }
          else if(patientData[index].patient_age !== patient_age){
            refreshgrid= true;
          }
          else if(patientData[index].patient_age_unit !== patient_age_unit){
            refreshgrid= true;
          }
          else if(patientData[index].patient_sex !== patient_sex){
            refreshgrid= true;
          }
          else if(patientData[index].priority !== priority){
            refreshgrid= true;
          }
          else if(patientData[index].zipcode !== report_background){
            refreshgrid= true;
          }
          else if(patientData[index].study_description !== study_description){
            refreshgrid= true;
          }
          else if(patientData[index].remarks !== remarks){
            refreshgrid= true;
          }
          else if(patientData[index].attach_file_count !== fileCount){
            refreshgrid= true;
          }

          if(!refreshgrid){
            patientData[index].patient_name = patient_name;
            patientData[index].patient_age = patient_age;
            patientData[index].patient_sex = patient_sex;
            patientData[index].study_description = study_description; 
            patientData[index].refer_physician = refer_physician;
            patientData[index].remarks = remarks;
            patientData[index].priority = priority;
          }
          setTimeout(function () {
            alert('Details modified successfully.');
          }, 100);
        }

        if(refreshgrid){
          //alert(refreshgrid);
          patientStudyList(search_report_status, search_priority, null, true);
        }

         /*let updatedValue = {};
          updatedValue = response.data; //JSON.stringify(response.data);
          //alert(updatedValue);
          setPatientData(patientData => ({
              ...patientData,
              ...updatedValue
              }));
              */
        })
        .catch(error => {
          retryAPICounter++;
          if(retryAPICounter>3){
            retryAPICounter = 0;

            if((action_tag === 'REPORT_SUBMIT' || action_tag === 'REPORT_SUBMIT_SIGNOFF') 
              && (authUser?.user_type === 'D' || authUser?.user_type === 'R'))
            {
              localStorage.setItem('api_status', 'N');
            }

            var Unauthorized = false; var errorCatch = '';
            if(error.response!== undefined)
            {
              errorCatch = 'Exception found!';
              if(error.response.data !== undefined)
              {
                if(error.response.data.message==='Unauthorized')
                {
                  Unauthorized = true;
                }
                else
                {
                  errorCatch = error.response.data.message;
                }
              }
            }

            if(Unauthorized)
            {
              alert('Unauthorized session, try to relogin.');
              logout();
            }
            else{
              if(errorCatch===''){
                errorCatch = error.message;
              }
              alert(errorCatch);
            }
          }
          else{
            setTimeout(function () {
              updateStudy(index, action_tag, user_key, center_key, patient_key, report_count, report_content, report_content2, report_content3, report_content4, notes,patient_name,patient_age,patient_sex,study_description,refer_physician,remarks,priority,patient_age_unit,dicomUrl,patient_id_ref, doctor_key, viewerName, priority_level, report_background, case_type, heart_rate, pr_interval, qrs_duration, qt_interval, qtc_interval, rhythm, axis, p_wave, t_wave, st_segment, q_wave, qrs_complex)
            }, 5000);
          }
         });
      } catch (err) {
        retryAPICounter = 0;
        if((action_tag === 'REPORT_SUBMIT' || action_tag === 'REPORT_SUBMIT_SIGNOFF') 
          && (authUser?.user_type === 'D' || authUser?.user_type === 'R'))
          {
            localStorage.setItem('api_status', 'N');
          }
          alert(err.code);
        if (err.code === '404') {
          //setError('Object does not exist.')
          return
        }
      }
    }
  function openDicomViewer(patient_key, study_key, instance_uid, modality, image_total_count, dicomUrl, viewerName)
  {
    if(viewerName!=='ohif' && modality === 'MR')
    {
      viewerName='ohif';
    }
    
    var dicomUrl_ohif = `https://dev-ohif.mytsofts.com/viewer/dicomjson?url=https://dev-ohif.mytsofts.com/json_ohif/` + study_key +`/` + instance_uid + `.json`;
    if(modality === 'CT' || modality === 'MR'){
      dicomUrl_ohif = `https://dev-ohif.mytsofts.com/viewer/dicomjson?url=https://dev-ohif.mytsofts.com/Prod/patientjson?patient_key=` + patient_key;
    }
    
    if(viewerName==='ohif'){
      dicomUrl = dicomUrl_ohif;
    }
    else{
      var considerMedream = false;
      /*if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
        if(authUser?.user_key === 9 || authUser?.user_key === 20)
        {
          considerMedream = true;
        }
      }*/
      if(authUser?.user_key === 9 || authUser?.user_key === 20 || authUser?.user_key === 170)
      {
        considerMedream = true;
      }
      else if (modality === 'CT' || modality === 'MR' || modality === 'US')
      {
        considerMedream = true;
      }
      
      if(considerMedream === true){
        ;
      }
      else if (image_total_count < 4 && patient_key > 16883){
          if(image_total_count === 1 || (authUser?.user_key === 11 
            || authUser?.user_key === 47 || authUser?.user_key === 2 
            || authUser?.user_key === 78 || authUser?.user_key === 79
            || authUser?.user_key === 125 || authUser?.user_key === 126
            ))
          {
          //&& (authUser?.user_key === 1 || authUser?.user_key === 2 || authUser?.user_key === 20)
          dicomUrl = dicomUrl_ohif;
          }
      }
    }

    if(myWindow === null){
      myWindow = window.open(dicomUrl, "mytsoftdicom");
    }
    else
    {
      if(myWindow.closed){
        myWindow = window.open(dicomUrl, "mytsoftdicom");
      }
      else
      {
        myWindow.location.href = dicomUrl;
      }
    } 
    return;
  }
    const openDicomJPG = (user_key, center_key, patient_key, modality, json_data) => {
        setPatientFilesData([]); 
        setJpgPath('/img/blank.jpg');
        setPatientKey(patient_key);

        setRefNumber(randomNumberInRange(1000, 9000));
        resetImage(null);
         
        if (!authUser){
          alert('Unauthorized session, please try to relogin.');
          return null;
        }

        if(modality==='CT' || modality==='ct' || modality==='MR') {
           return null;
        }
    
        if(json_data !== ''){          
          let json_data_split = json_data.split(';')
          for(var iCnt = 0; iCnt<json_data_split.length; iCnt++){
            const newRow = { 
              file_name: json_data_split[iCnt],
              study_description: '',
              series_description: ''
            };

            setPatientFilesData(prevData => [...prevData, newRow]);
          
            if(iCnt===0){              
              setJpgPath(json_data_split[iCnt]);
              setRefNumber(randomNumberInRange(1000, 9000));
              resetImage(null);
            }
          }
          return;
        }

        const url = `${process.env.REACT_APP_API_URL}/patientfiles`;
        const request_id = randomNumberInRange(1000000, 9000000);
        const token = JSON.parse(localStorage.getItem('user')).token;
        const action_tag = "";
        const config = {
          headers: {
            'content-type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'user_key': user_key.toString(),
            'center_key': center_key.toString(),
            'patient_key': patient_key.toString(),
            'action_tag': action_tag,
            'request_id': request_id.toString()
          },
        };
        
        try {
          axios.get(url, config).then((response) => { 
            let updatedValue = {};
             
            if(response.data.length>0){
              updatedValue = response.data; 
              setJpgPath(updatedValue[0].file_name);
              setRefNumber(randomNumberInRange(1000, 9000));
              resetImage(null);
            }
            setPatientFilesData(updatedValue); 
          })
          
        .catch(error => {
          //alert('error');
          var Unauthorized = false; var errorCatch = '';
          if(error.response!= null)
          {
            errorCatch = 'Exception found!';
            if(error.response.data != null)
            {
              if(error.response.data.message==='Unauthorized')
              {
                Unauthorized = true;
              }
              else
              {
                errorCatch = error.response.data.message;
              }
            }
          }
          else if(error.message!= null)
          {
            errorCatch = error.message;
          }

          if(Unauthorized)
          {
            alert('Unauthorized session, try to relogin.');
            logout();
          }
          else{
            alert(errorCatch);
          }
         });
        } catch (err) {
          //debugger;
          //alert('error');
            //alert(err.code);
          if (err.code === '404') {
            //setError('Object does not exist.')
            return
          }
        }
    };

    // Touch events for pan and zoom
    const imageTouchStart = (e) =>  {
      e.preventDefault();

      const image = document.getElementById('mainImage');

      if (e.touches.length === 1) {
        isDragging = true;

        if(activeJPGAction === 'zoom'){
          zoom_startX = e.touches[0].clientX - zoom_translateX;
          zoom_startY = e.touches[0].clientY - zoom_translateY;
        }
        else {
          startX = e.touches[0].clientX - translateX;
          startY = e.touches[0].clientY - translateY;
        }
      }

      if(activeJPGAction === 'pan'){
        if (e.button === 0) { // Left mouse button
            image.style.cursor = 'grabbing';
        }
      }
      else{
        image.style.cursor = 'default';
      }
  };

  const imageTouchMove = (e) =>  {
    e.preventDefault();
    
    const imageContainer = document.getElementById('mainImageContainer');
    const magnifier = document.querySelector('.magnifier');
    const image = document.getElementById('mainImage');

    if (isDragging) { //&& e.touches.length === 1
      if(activeJPGAction === 'zoom'){
        prev_zoom_startX = zoom_startX;
        prev_zoom_startY = zoom_startY;
        
        zoom_translateX = e.touches[0].clientX - zoom_startX;
        zoom_translateY = e.touches[0].clientY - zoom_startY;
      }
      else {
        translateX = e.touches[0].clientX - startX;
        translateY = e.touches[0].clientY - startY;
      }

      if(activeJPGAction === 'windowlevel'){
        // Adjust values based on movement
        brightness = Math.max(0.5, Math.min(2, 1 + translateX * 0.01));
        contrast = Math.max(0.5, Math.min(3, 1 + translateY * 0.01));
      }
      else if(activeJPGAction === 'zoom'){
        // Adjust zoom level based on drag distance
        zoom_scale = Math.max(0.5, Math.min(3, zoom_scale + zoom_translateX * 0.0005));

        /*if(prev_translateX > translateX && prev_translateY > translateY)
        {
          zoom_scale = zoom_scale+0.01;
        }
        else{
          zoom_scale = Math.max(zoom_scale - 0.1, 0.1);
        }*/
      }

      applyTransform2();
    }

    if(activeJPGAction === 'pan'){
    }
    
  };

  const imageTouchEnd = (e) =>  {
    e.preventDefault();

    isDragging = false;

    const image = document.getElementById('mainImage');
    if(activeJPGAction === 'pan'){
      image.style.cursor = 'grab';
    }
    else{
      image.style.cursor = 'default';
    }
  };

        // Panning with mouse drag
        const imageMouseDown = (e) =>  {
          e.preventDefault();

          const image = document.getElementById('mainImage');

          if (e.button === 0) { // Left mouse button
            isDragging = true;

            if(activeJPGAction === 'zoom'){
              prev_zoom_startX = zoom_startX;
              prev_zoom_startY = zoom_startY;

              zoom_startX = e.clientX - zoom_translateX;
              zoom_startY = e.clientY - zoom_translateY;
            }
            else {
              startX = e.clientX - translateX;
              startY = e.clientY - translateY;
            }
          }

          if(activeJPGAction === 'pan'){
            if (e.button === 0) { // Left mouse button
                image.style.cursor = 'grabbing';
            }
          }
          else{
            image.style.cursor = 'default';
          }
      };
  
      const imageMouseMove = (e) =>  {
        e.preventDefault();
        
        const imageContainer = document.getElementById('mainImageContainer');
        const magnifier = document.querySelector('.magnifier');
        const image = document.getElementById('mainImage');

        if (isDragging) {
          if(activeJPGAction === 'zoom'){
            prev_zoom_startX = zoom_startX;
            prev_zoom_startY = zoom_startY;
            
            zoom_translateX = e.clientX - zoom_startX;
            zoom_translateY = e.clientY - zoom_startY;
          }
          else {
            translateX = e.clientX - startX;
            translateY = e.clientY - startY;
          }

          if(activeJPGAction === 'windowlevel'){
            // Adjust values based on movement
            brightness = Math.max(0.5, Math.min(2, 1 + translateX * 0.01));
            contrast = Math.max(0.5, Math.min(3, 1 + translateY * 0.01));
          }
          else if(activeJPGAction === 'zoom'){
            // Adjust zoom level based on drag distance
            zoom_scale = Math.max(0.5, Math.min(3, zoom_scale + zoom_translateX * 0.0005));

            /*if(prev_translateX > translateX && prev_translateY > translateY)
            {
              zoom_scale = zoom_scale+0.01;
            }
            else{
              zoom_scale = Math.max(zoom_scale - 0.1, 0.1);
            }*/
          }

          applyTransform2();
        }

        if(activeJPGAction === 'pan'){
        }
/*
          // Magnify
          if (pan_scale > 1) {
              const rect = imageContainer.getBoundingClientRect();
              const x = e.clientX - rect.left;
              const y = e.clientY - rect.top;
  
              magnifier.style.display = 'block';
              magnifier.style.backgroundImage = `url(${image.src})`;
              magnifier.style.backgroundSize = `${image.width * pan_scale}px ${image.height * pan_scale}px`;
              magnifier.style.backgroundPosition = `-${x * pan_scale - magnifier.offsetWidth / 2}px -${y * pan_scale - magnifier.offsetHeight / 2}px`;
              magnifier.style.left = `${x - magnifier.offsetWidth / 2}px`;
              magnifier.style.top = `${y - magnifier.offsetHeight / 2}px`;
          } else {
              magnifier.style.display = 'none';
          }
              */
        
      };
  
      const imageMouseUp = (e) =>  {
        e.preventDefault();

        if (e.button === 0) { // Left mouse button
          isDragging = false;
        }

        const image = document.getElementById('mainImage');
        if(activeJPGAction === 'pan'){
          if (e.button === 0) { // Left mouse button
              image.style.cursor = 'grab';
          }
        }
        else{
          image.style.cursor = 'default';
        }
      };
  
      const imageMouseLeave = (e) =>  {
        e.preventDefault();

        isDragging = false;

        const image = document.getElementById('mainImage');
        if(activeJPGAction === 'pan'){
          image.style.cursor = 'grab';
        }
        else{
          image.style.cursor = 'default';
        }
      };

    // Apply transformations to the image
    function applyTransform2() {
      const image = document.getElementById('mainImage');
      if(activeJPGAction === 'pan'){
        image.style.transform = `translate(${translateX}px, ${translateY}px) scale(${pan_scale})`;
      }
      else if(activeJPGAction === 'windowlevel'){
        image.style.filter = `brightness(${brightness}) contrast(${contrast})`;
      }
      else if(activeJPGAction === 'zoom'){
        image.style.transform = `scale(${zoom_scale})`;
      }
  }
  
  function setButtonSelect(){
    const btnWindowLevelMobile = document.getElementById('btnWindowLevelMobile');
    btnWindowLevelMobile.classList.remove("btn-selected");

    const btnZoomMobile = document.getElementById('btnZoomMobile');
    btnZoomMobile.classList.remove("btn-selected");

    const btnPanMobile = document.getElementById('btnPanMobile');
    btnPanMobile.classList.remove("btn-selected");

    const btnWindowLevel = document.getElementById('btnWindowLevel');
    btnWindowLevel.classList.remove("btn-selected");

    const btnZoom = document.getElementById('btnZoom');
    btnZoom.classList.remove("btn-selected");

    const btnPan = document.getElementById('btnPan');
    btnPan.classList.remove("btn-selected");

    if(activeJPGAction ==='windowlevel'){
      btnWindowLevelMobile.classList.add("btn-selected");
      btnWindowLevel.classList.add("btn-selected");
    }
    else if(activeJPGAction ==='zoom'){
      btnZoomMobile.classList.add("btn-selected");
      btnZoom.classList.add("btn-selected");
    }
    else if(activeJPGAction ==='pan'){
      btnPanMobile.classList.add("btn-selected");
      btnPan.classList.add("btn-selected");
    }
    return true;
  };

  const windowlevelJPG = (event) => {
    event.preventDefault();
  
    activeJPGAction = 'windowlevel';

    setButtonSelect();
  }
  
  const panJPG = (event) => {
    event.preventDefault();
  
    activeJPGAction = 'pan';
    setButtonSelect();
  }
  const zoomJPG = (event) => {
    event.preventDefault();
  
    activeJPGAction = 'zoom';
    setButtonSelect();
  }

    const zoomIn = (event) => {
      event.preventDefault();
    
      scale += 0.1;
      applyTransform();
    }
    
    const zoomOut = (event) => {
      event.preventDefault();
    
      scale = Math.max(scale - 0.1, 0.1);
      applyTransform();
    }
    
    const rotate = (event) => {
      event.preventDefault();
      
      rotateDeg = (rotateDeg + 90) % 360;
      applyTransform();
    }
    
    const flip = (event) => {
      event.preventDefault();

      flipped = !flipped;
      applyTransform();
    }
    
    const pan = (event, direction) => {
      event.preventDefault();
    
      const image = document.getElementById('mainImage');
        const panAmount = 20;
        switch (direction) {
            case 'left':
                image.style.transform += ` translateX(-${panAmount}px)`;
                break;
            case 'right':
                image.style.transform += ` translateX(${panAmount}px)`;
                break;
            case 'up':
                image.style.transform += ` translateY(-${panAmount}px)`;
                break;
            case 'down':
                image.style.transform += ` translateY(${panAmount}px)`;
                break;
            default:
                image.style.transform += ` translateY(${panAmount}px)`;
                break;
        }
    }
    
    const invert = (event) => {
      event.preventDefault();

      const image = document.getElementById('mainImage');
      image.style.filter = image.style.filter === 'invert(1)' ? 'none' : 'invert(1)';
    }
    const magnify = (event) => {
      event.preventDefault();

      const magnifyAmount = 1.5;
      scale = scale === 1 ? magnifyAmount : 1;
      applyTransform();
    }
    
    function applyTransform() {
      const image = document.getElementById('mainImage'); 
      image.style.transform = `scale(${scale}) rotate(${rotateDeg}deg) ${flipped ? 'scaleX(-1)' : ''}`;
    }

    const fullScreen = (event) => {
      event.preventDefault();
      if(fullscreenFlag)
      {
        document.exitFullscreen();
        fullscreenFlag = false;
      }
      else{
        document.documentElement.requestFullscreen();
        fullscreenFlag = true;
      }
    };

    const resetImage = (event) => {
      if(event!=null){
        event.preventDefault();
      }

      //const image = document.getElementById('mainImage');
      //image.src = jpgPath;
      
      scale = 1;
      rotateDeg = 0;
      flipped = false;
      
      applyTransform();

      const image = document.getElementById('mainImage');
      image.style.filter = 'none';
    };

    const openImage = (event, i) => {
      event.preventDefault();
      
      if(myWindowJPG === null){
        myWindow = window.open(jpgPath, "mytsoftdicom-jpg");
      }
      else
      {
        if(myWindowJPG.closed){
          myWindowJPG = window.open(jpgPath, "mytsoftdicom-jpg");
        }
        else
        {
          myWindowJPG.location.href = jpgPath;
        }
      } 
    };

    const showImage = (event, i) => {
      event.preventDefault();
      
      setJpgPath(patientFilesData[i].file_name);
      setRefNumber(randomNumberInRange(1000, 9000));
      
      const image = document.getElementById('mainImage');
      image.src = patientFilesData[i].file_name;

      resetImage(null);
    };
    
    const showTabArea = (event, tabId) => {
      if(event!=null){
        event.preventDefault();
      }

      const thumnailarea = document.getElementById('thumnailarea');
      const imgarea = document.getElementById('imgarea');
      const imgarea2 = document.getElementById('imgarea2');
      const reportarea = document.getElementById('reportarea');
      const splitwindow1 = document.getElementById('splitwindow1');
      const splitwindow2 = document.getElementById('splitwindow2');
      
      var mobileView = false;
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
        mobileView = true;
      }

      if(mobileView === false && authUser?.user_type === 'U'){
        localStorage.setItem('show_tabarea', tabId);
      }

      if(tabId==='T1'){
        thumnailarea.style.display='inline'; imgarea.style.display='inline';
        imgarea2.style.display='none'; reportarea.style.display='none';
      }

      if(tabId==='T2'){
        thumnailarea.style.display='none'; imgarea.style.display='none';
        imgarea2.style.display='inline'; reportarea.style.display='none';
      }
      
      if(tabId==='T3'){
        thumnailarea.style.display='none'; imgarea.style.display='none';
        imgarea2.style.display='none'; reportarea.style.display='inline';
        reportarea.style.display='inline';
      }

      if(tabId==='T13'){
        thumnailarea.style.display='inline'; imgarea.style.display='inline';
        imgarea2.style.display='none'; reportarea.style.display='inline';
        reportarea.style.display='inline';
        
        splitwindow1.style.display='none'; splitwindow2.style.display='none';

        if(!mobileView){
          reportarea.classList.remove("icol-12");
          reportarea.classList.add("icol-7");

          imgarea.classList.remove("icol-11");
          imgarea.classList.add("icol-5");
        }
      }
      else{
        if(mobileView){
          splitwindow1.style.display='none'; splitwindow2.style.display='none';
        }
        else{
          splitwindow1.style.display='inline'; splitwindow2.style.display='inline';

          reportarea.classList.remove("icol-7");
          reportarea.classList.add("icol-12");

          imgarea.classList.remove("icol-5");
          imgarea.classList.add("icol-11");
        }
      }

      if(mobileView){
        var objddlReportTemplate = document.getElementById("ddlReportTemplate");
        var objddlLineHeight = document.getElementById("ddlLineHeight");
       
        if(tabId==='T3'){
          if(objddlReportTemplate!==null){
            objddlReportTemplate.style.width='100px';
          }
          if(objddlLineHeight!==null){
            objddlLineHeight.style.width='160px';
          }
        }
      }
    };

    const openNotes2 = (event, param) => {
      event.preventDefault();

      var index=patientIndex; 
      openNotes(event, param, index);
    }
    const openNotes = (event, param, index) => {
      event.preventDefault();
      
      if(index!=null){
        setPatientIndex(index);
      }

      if(param==='OPEN'){
        if(index!=null){
          document.getElementById("spnnotes_patient").innerHTML = '🧑' + patientData[index].patient_name + ' | 🎂' + patientData[index].patient_age.toString() + patientData[index].patient_age_unit;

          if(patientData[index].report_status === "F") 
          {
            document.getElementById('btnNotesSave').disabled = true;
          }
          else
          {
            document.getElementById('btnNotesSave').disabled = false;
          }

          document.getElementById("txtp_notes").value = patientData[index].notes;
          var commentsValue = patientData[index].comments;
          if(commentsValue==='' && document.getElementById("txtp_notes").value!=='')
          {
            commentsValue = document.getElementById("txtp_notes").value;
          }
          document.getElementById("divp_comments").innerHTML = commentsValue;

          document.getElementById("txtp_notes").value = '';
          document.getElementById("hidc_key_notes").value = patientData[index].center_key;
          document.getElementById("hidp_key_notes").value = patientData[index].patient_key;
        }
      }

      if(param==='SAVE' || param==='PASTE'){
        index = patientIndex;

        var action_tag = 'ADD_NOTES';
        if (param==='PASTE'){
          action_tag = 'ADD_NOTES_PASTE';

          setFilePaste(null); 
          //alert('s');
          const items = event.clipboardData?.items;
          if (!items) return;
          //alert(items.length);
          for (let i = 0; i < items.length; i++) {
            if (items[i].type.indexOf("image") !== -1) {
              const blob = items[i].getAsFile();
              //alert(blob.name);
              setFilePaste(blob);
            }
          }
        }
        var user_key = authUser?.user_key; 
        var report_count = 1;
        var report_content = '';
        var report_content2 = '';
        var report_content3 = '';
        var report_content4 = '';

        var notes = document.getElementById("txtp_notes").value;
        if(notes===''){
          //alert('Notes cannot be blank');
          setAutoCloseTime(autoClose5);
          notifyError('Notes cannot be blank.');
          return false;
        }

        if(patientData[index].report_status === "F")
        {
          //alert('Cannot allow to edit after printed.');
          setAutoCloseTime(autoClose5);
          notifyError('Cannot allow to edit after printed.');
          return false;
        }

        var center_key = document.getElementById("hidc_key_notes").value;
        var patient_key = document.getElementById("hidp_key_notes").value;

        if(patient_key!==patientData[index].patient_key.toString())
        {
          alert('Wrong patient details updating, refresh and try again.');
          return false;
        }

        if(center_key!==patientData[index].center_key.toString())
        {
          alert('Wrong center patient updating, refresh and try again.');
          return false;
        }

        const priority = 'N';
        updateStudy(index, action_tag, user_key, patientData[index].center_key, patientData[index].patient_key, report_count, report_content, report_content2, report_content3, report_content4, notes, '', 0, '', '', '', '', priority, '', '', '');
      }

      let modal = document.querySelector("#attachNotes");
      modal.classList.toggle("closed");
    };

    const openReworkStudy = (event, param, index) => {
      event.preventDefault();
      
      if(index!=null){
        setPatientIndex(index);
      }

      if(param==='OPEN'){
        if(index!=null){
          document.getElementById("spnrework_patient").innerHTML = '🧑' + patientData[index].patient_name + ' | 🎂' + patientData[index].patient_age.toString() + patientData[index].patient_age_unit;

          document.getElementById("txtrework_reason").value = '';
          document.getElementById("hidc_key_rework").value = patientData[index].center_key;
          document.getElementById("hidp_key_rework").value = patientData[index].patient_key;
        }
      }

      if(param==='SAVE'){
        index = patientIndex;

        var action_tag = 'REWORK_STUDY';
        
        var user_key = authUser?.user_key; 
        var report_count = 1;
        var report_content = '';
        var report_content2 = '';
        var report_content3 = '';
        var report_content4 = '';

        if(patientData[index].report_status !== 'F'){
          setAutoCloseTime(autoClose5);
          notifyError('Printed status allow to unlock study.');
          return false;
        }

        var notes = document.getElementById("txtrework_reason").value;
        if(notes===''){
          setAutoCloseTime(autoClose5);
          notifyError('Rework reason cannot be blank.');
          return false;
        }
        notes= 'Rework Reason: '+notes;

        var center_key = document.getElementById("hidc_key_rework").value;
        var patient_key = document.getElementById("hidp_key_rework").value;

        if(patient_key!==patientData[index].patient_key.toString())
        {
          alert('Wrong patient details updating, refresh and try again.');
          return false;
        }

        if(center_key!==patientData[index].center_key.toString())
        {
          alert('Wrong center patient updating, refresh and try again.');
          return false;
        }

        const priority = 'N';
        updateStudy(index, action_tag, user_key, patientData[index].center_key, patientData[index].patient_key, report_count, report_content, report_content2, report_content3, report_content4, notes, '', 0, '', '', '', '', priority, '', '', '');
      }

      let modal = document.querySelector("#reworkStudy");
      modal.classList.toggle("closed");
    };
    const openUnlockStudy = (event, param, index) => {
      event.preventDefault();
      
      if(index!=null){
        setPatientIndex(index);
      }

      if(param==='OPEN'){
        if(index!=null){
          document.getElementById("spnunlock_patient").innerHTML = '🧑' + patientData[index].patient_name + ' | 🎂' + patientData[index].patient_age.toString() + patientData[index].patient_age_unit;

          document.getElementById("txtunlock_reason").value = '';
          document.getElementById("hidc_key_unlock").value = patientData[index].center_key;
          document.getElementById("hidp_key_unlock").value = patientData[index].patient_key;
        }
      }

      if(param==='SAVE'){
        index = patientIndex;

        var action_tag = 'UNLOCK_STUDY';
        
        var user_key = authUser?.user_key; 
        var report_count = 1;
        var report_content = '';
        var report_content2 = '';
        var report_content3 = '';
        var report_content4 = '';

        if(patientData[index].report_status !== 'S'){
          setAutoCloseTime(autoClose5);
          notifyError('Signed-off status allow to unlock study.');
          return false;
        }

        var notes = document.getElementById("txtunlock_reason").value;
        if(notes===''){
          setAutoCloseTime(autoClose5);
          notifyError('Unlock study reason cannot be blank.');
          return false;
        }
        notes= 'Unlock Study Reason: '+notes;

        var center_key = document.getElementById("hidc_key_unlock").value;
        var patient_key = document.getElementById("hidp_key_unlock").value;

        if(patient_key!==patientData[index].patient_key.toString())
        {
          alert('Wrong patient details updating, refresh and try again.');
          return false;
        }

        if(center_key!==patientData[index].center_key.toString())
        {
          alert('Wrong center patient updating, refresh and try again.');
          return false;
        }

        const priority = 'N';
        updateStudy(index, action_tag, user_key, patientData[index].center_key, patientData[index].patient_key, report_count, report_content, report_content2, report_content3, report_content4, notes, '', 0, '', '', '', '', priority, '', '', '');
      }

      let modal = document.querySelector("#unlockStudy");
      modal.classList.toggle("closed");
    };
    const openReviewRework = (event, param) => {
      event.preventDefault();
      
      var index = patientIndex;
      
      if(param==='OPEN'){
        if(index!=null){
          document.getElementById("spnreview_rework").innerHTML = '🧑' + patientData[index].patient_name + ' | 🎂' + patientData[index].patient_age.toString() + patientData[index].patient_age_unit;

          document.getElementById("txtreview_rework_reason").value = '';
          document.getElementById("hidc_key_review_rework").value = patientData[index].center_key;
          document.getElementById("hidp_key_review_rework").value = patientData[index].patient_key;
        }
      }

      if(param==='SAVE'){
        index = patientIndex;

        var action_tag = 'REVIEW_REWORK';
        
        var user_key = authUser?.user_key; 
        var report_count = 1;
        var report_content = '';
        var report_content2 = '';
        var report_content3 = '';
        var report_content4 = '';

        var notes = document.getElementById("txtreview_rework_reason").value;
        if(notes===''){
          setAutoCloseTime(autoClose5);
          notifyError('Rework reason cannot be blank.');
          return false;
        }
        notes= 'Rework Reason: '+notes;

        var center_key = document.getElementById("hidc_key_review_rework").value;
        var patient_key = document.getElementById("hidp_key_review_rework").value;

        if(patient_key!==patientData[index].patient_key.toString())
        {
          alert('Wrong patient details updating, refresh and try again.');
          return false;
        }

        if(center_key!==patientData[index].center_key.toString())
        {
          alert('Wrong center patient updating, refresh and try again.');
          return false;
        }

        const priority = 'N';
        updateStudy(index, action_tag, user_key, patientData[index].center_key, patientData[index].patient_key, report_count, report_content, report_content2, report_content3, report_content4, notes, '', 0, '', '', '', '', priority, '', '', '');

        let modal_Submit = document.querySelector("#openSubmitReport");
        modal_Submit.classList.toggle("closed");
      }

      let modal = document.querySelector("#reviewRework");
      modal.classList.toggle("closed");
    };

    const selectPatient = (index) => {
      if(index !==null){
        patientObject.center_key=patientData[index].center_key;
        patientObject.patient_key=patientData[index].patient_key;
        patientObject.patient_id=patientData[index].patient_id;
        patientObject.patient_name=patientData[index].patient_name;
        patientObject.patient_sex=patientData[index].patient_sex;
        patientObject.patient_age=patientData[index].patient_age;
        patientObject.patient_age_unit=patientData[index].patient_age_unit;
        patientObject.report_count=patientData[index].report_count;
        patientObject.report_content=patientData[index].report_content;
        patientObject.report_content2=patientData[index].report_content2;
        patientObject.report_content3=patientData[index].report_content3;
        patientObject.report_content4=patientData[index].report_content4;
        patientObject.report_status=patientData[index].report_status;
      }
    }
    const openSubmitReport = (event, param, index, caller) => {
      if(event!=null){
        event.preventDefault();
      }
      
      if(index === null){
        index = patientIndex;
        if(param === 'OPEN'){
          selectPatient(index);
        }
      }

      if(param === 'OPEN' || param === 'CLOSE'){
        setJpgPath('/img/blank.jpg');
        setToolDefault('wl');
        setPatientKey(0); 
        
        if(param === 'OPEN'){
          var divreportarea = document.getElementById('divreportarea');
          var divreportarea_ecg = document.getElementById('divreportarea_ecg');
          if(patientData[index].modality==='ECG'){
            setToolDefault('pan');
            divreportarea.style.display='none'; divreportarea_ecg.style.display='';
          }
          else{
            divreportarea_ecg.style.display='none'; divreportarea.style.display='';
          }
        }
      }

      if(param === 'OPEN' || param === 'CLOSE' || param === 'SAVE_SIGNOFF' 
        || param === 'REVIEW_REWORK' || param === 'REVIEW_SIGNOFF' || param === 'REPORT_SUBMIT_SIGNOFF'){
        const divbody = document.getElementById('body');
        if(divbody!=null){
          if(param === 'OPEN'){
            divbody.style.overflow = 'hidden';
          }
          else{
            divbody.style.overflow = 'auto';
          }
        }
      }

      if(authUser?.user_type !== 'D' && param === 'OPEN'){
        var objddlLineHeight = document.getElementById("ddlLineHeight");
        objddlLineHeight.selectedIndex = 0;
        setReportLineHeight(""); 
        setPrintLineHeight("");
      }

      /*//no need due to it is calling during render report content
      if(param === 'OPEN'){
        ReportTemplateFilter(patientData[index].modality, patientData[index].study_description, patientData[index].body_part, false);
      }*/

      if(authUser?.user_type === 'D' || authUser?.user_type === 'R'){
        if(param === 'OPEN' && caller !== 'DICOM')
        {
          ChangeStudyStatus('LOCK_PATIENT', index, null, null, null, '');
        }
        else if(param === 'CLOSE')
        {
          ChangeStudyStatus('REMOVE_LOCK', index, null, null, null, '');
        }
        else
        {
          openSubmitReportCallBack(param, index, caller);
        }
      }
      else{
        openSubmitReportCallBack(param, index, caller);
      }
    }
    const openSubmitReportCallBack = (param, index, caller) => {
      if(index!=null){
        setPatientIndex(index);
      }

      var report_count = 1;
      var report_content='';
      var report_content2 = '';
      var report_content3 = '';
      var report_content4 = '';
      var tempValue = '';

      /*if(authUser?.user_type !== 'D')
        {
          alert('Permission denied for the user');
          return false;
        }*/

      if(param==='OPEN'){
        openDicomJPG(authUser?.user_key, authUser?.center_key, patientData[index].patient_key, patientData[index].modality, patientData[index].json_data);

        var ddlReportTemplate = document.getElementById('ddlReportTemplate');
        if(patientData[index].modality === 'ECG'){
          document.getElementById('ddlLineHeight').style.display = 'none';
          document.getElementById('btnreportadd').style.display = 'none';
          document.getElementById('report1-tab').style.display = 'none';
          if(ddlReportTemplate!==null){
            ddlReportTemplate.style.display = 'none';
          }
        }
        else{
          document.getElementById('ddlLineHeight').style.display = 'inline';
          document.getElementById('btnreportadd').style.display = 'inline';
          document.getElementById('report1-tab').style.display = 'inline';
          if(ddlReportTemplate!==null){
            ddlReportTemplate.style.display = 'inline';
          }
        }
        
        if(patientData[index].notes===''){
          document.getElementById('btnopenNotes2').title='Empty notes';
          document.getElementById('btnopenNotes2').className='btn btn-outline-warning btn-sm bi bi-bookmarks m-1';
        }
        else{
          document.getElementById('btnopenNotes2').title=patientData[index].notes;
          document.getElementById('btnopenNotes2').className='btn btn-warning btn-sm bi bi-bookmarks-fill m-1';
        }        

        var tabId = 'T1';
        var mobileView = false;
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
          mobileView = true;
        }

        if(patientData[index].viewer_flag === 'JPG' && caller === 'DICOM'){
          if(mobileView){
            tabId = 'T1';
          }
          else{
              tabId = 'T13';
          }
        }
        else{
          if(patientData[index].report_content === '' && authUser?.user_type !== 'D'){
            if(patientData[index].modality === 'CT' || patientData[index].modality === 'MR'){
              tabId = 'T3';
            }
            else if(mobileView){
              tabId = 'T1';
            }
            else{
                tabId = 'T13';
            }
          }
          else{
            if(mobileView || patientData[index].modality === 'CT' || patientData[index].modality === 'MR'){
              tabId = 'T3';
            }
            else{
                tabId = 'T13';
            }
          }
        }

        if(mobileView === false && authUser?.user_type === 'U'){
            if(tabId === 'T13' && patientData[index].report_content !== ''){
              let show_tabarea = localStorage.getItem('show_tabarea');
              if(show_tabarea===null){
                  tabId = 'T3';
              }
              else{
                tabId = show_tabarea;
              }
            }
        }

        showTabArea(null, tabId);
        
        ReportTemplateFilter(patientData[index].modality, patientData[index].study_description, patientData[index].body_part, false);

        var _remarks = patientData[index].remarks;
        if(_remarks.length>78) { _remarks = _remarks.substring(0,75) + '...'; }
        document.getElementById("spnsubmit_patient").innerHTML = '🧑' + patientData[index].patient_name + ' | 🎂' + patientData[index].patient_age.toString() + patientData[index].patient_age_unit + ' | 📋' + patientData[index].modality + '-' + patientData[index].study_description + ' | 💡' + _remarks;
        document.getElementById("hidc_key_submit").value = patientData[index].center_key;
        document.getElementById("hidp_key_submit").value= patientData[index].patient_key;

        if(authUser?.user_type === 'D' || authUser?.user_type === 'R'){
          if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
            //document.getElementById('divSubmitReport').style.width = '60px';
            //document.getElementById('divSubmitReportSignedOff').style.width = '100px';
            //document.getElementById('btnSubmitReportClose').style.width = '60px';
          }
        }

        if(authUser?.user_type === 'D' || authUser?.user_type === 'R' || authUser?.user_type === 'A' || authUser?.user_type === 'S'){
          ;
        }
        else{
          document.getElementById('btnopenEditStudy2').style.display = 'none';
        }

        if(mobileView){
          document.getElementById('divShowReport').style.display = 'inline';
        }
        
        document.getElementById('divReviewSubmitReport').style.display = 'none';
        document.getElementById('divReworkReport').style.display = 'none';
        if(authUser?.user_type !== 'D'){
          if(authUser?.user_type !== 'U' && patientData[index].report_status === 'V'){
            document.getElementById('divPrintReport').style.display = 'none';
            document.getElementById('ddlLineHeight').style.display = 'none';
            document.getElementById('divReviewSubmitReport').style.display = 'inline';
            document.getElementById('divReworkReport').style.display = 'inline';
            //setReportLineHeight('50px');
          }

          document.getElementById('divSubmitReport').style.display = 'none';
          document.getElementById('divSubmitReportSignedOff').style.display = 'none';
          document.getElementById('btnreportadd').style.display = 'none';
          document.getElementById('btnreportremove').style.display = 'none';
        }
        else {
          document.getElementById('divPrintReport').style.display = 'none';
          document.getElementById('ddlLineHeight').style.display = 'none';
        }
      
        if(patientData[index].report_status === "F")
        {
          document.getElementById('btnSubmitReport').disabled = true;
          document.getElementById('btnSubmitReportSignedOff').disabled = true;
        }
        else
        {
          document.getElementById('btnSubmitReport').disabled = false;
          document.getElementById('btnSubmitReportSignedOff').disabled = false;
        }

        report_count = patientData[index].report_count;
        report_content = patientData[index].report_content;
        report_content2 = patientData[index].report_content2;
        report_content3 = patientData[index].report_content3;
        report_content4 = patientData[index].report_content4;
        
        /*Network failure last save can recover report*/
        if(report_content === '' 
          && (authUser?.user_type === 'D' || authUser?.user_type === 'R'))
        {
          let api_status = localStorage.getItem('api_status');
          let user_key = localStorage.getItem('user_key');
          if(api_status!=='Y' && user_key === authUser?.user_key.toString())
          {
            let patient_key_recover = localStorage.getItem('patient_key');
            if(patient_key_recover===patientData[index].patient_key.toString())
            {
              let report_count_recover = localStorage.getItem('report_count');
              let report_content_recover = localStorage.getItem('report_content');
              
              if(report_count_recover>0 && report_content_recover !=='')
              {
                alert('Report is recovered and unsafe mode, please click save button');
                report_count = report_count_recover;
                report_content = report_content_recover;

                let report_content2_recover = localStorage.getItem('report_content2');
                if(report_content2_recover !==''){
                  report_content2 = report_content2_recover;
                }
                
                let report_content3_recover = localStorage.getItem('report_content3');
                if(report_content3_recover !==''){
                  report_content3 = report_content3_recover;
                }
                
                let report_content4_recover = localStorage.getItem('report_content4');
                if(report_content4_recover !==''){
                  report_content4 = report_content4_recover;
                }
              }
            }
          }
        }

        if(patientData[index].modality==='ECG'){
          document.getElementById('txtimpression').value=report_content;

          tempValue = patientData[index].heart_rate; if(tempValue===0) { tempValue = ''; }
          document.getElementById('txtheart_rate').value=tempValue;

          tempValue = patientData[index].pr_interval; if(tempValue===0) { tempValue = ''; }
          document.getElementById('txtpr_interval').value=tempValue;

          tempValue = patientData[index].qrs_duration; if(tempValue===0) { tempValue = ''; }
          document.getElementById('txtqrs_duration').value=tempValue;

          tempValue = patientData[index].qt_interval; if(tempValue===0) { tempValue = ''; }
          document.getElementById('txtqt_interval').value=tempValue;

          tempValue = patientData[index].qtc_interval; if(tempValue===0) { tempValue = ''; }
          document.getElementById('txtqtc_interval').value=tempValue;

          tempValue = patientData[index].rhythm; if(tempValue===null) { tempValue = ''; }
          document.getElementById('ddlrhythm').value=tempValue;

          tempValue = patientData[index].axis; if(tempValue===null) { tempValue = ''; }
          document.getElementById('ddlaxis').value=tempValue;

          tempValue = patientData[index].p_wave; if(tempValue===null) { tempValue = ''; }
          document.getElementById('ddlp_wave').value=tempValue;

          tempValue = patientData[index].t_wave; if(tempValue===null) { tempValue = ''; }
          document.getElementById('ddlt_wave').value=tempValue;

          tempValue = patientData[index].st_segment; if(tempValue===null) { tempValue = ''; }
          document.getElementById('ddlst_segment').value=tempValue;

          tempValue = patientData[index].q_wave; if(tempValue===null) { tempValue = ''; }
          document.getElementById('ddlq_wave').value=tempValue;

          tempValue = patientData[index].qrs_complex; if(tempValue===null) { tempValue = ''; }
          document.getElementById('ddlqrs_complex').value=tempValue;
        }
        
        document.getElementById('myReportTab').tag = report_count;
        document.getElementById('report1-tab').tag = report_content;
        document.getElementById('report2-tab').tag = report_content2;
        document.getElementById('report3-tab').tag = report_content3;
        document.getElementById('report4-tab').tag = report_content4;
        
        if(report_count < 4) {
          document.getElementById('report4-tab').style.display = 'none';  
        }
        else{
          document.getElementById('report4-tab').style.display = '';  
        }
        
        if(report_count < 3) {
          document.getElementById('report3-tab').style.display = 'none'; 
        }
        else{
          document.getElementById('report3-tab').style.display = '';  
        }

        if(report_count < 2) {
          document.getElementById('report2-tab').style.display = 'none'; 
        }
        else{
          document.getElementById('report2-tab').style.display = '';  
        }
        
        if(authUser?.user_type === 'D' || authUser?.user_type === 'R'){
          if(report_count === 1) {
            document.getElementById('btnreportremove').style.display = 'none';
          }
          else
          {
            document.getElementById('btnreportremove').style.display = '';
          }

          if(report_count === 4) {
            document.getElementById('btnreportadd').style.display = 'none';
          }
          else{
            if(patientData[index].modality !== 'ECG'){
              document.getElementById('btnreportadd').style.display = '';
            }
          }
        }
        
        document.getElementById('report4-tab').ariaSelected = false;
        document.getElementById('report3-tab').ariaSelected = false;
        document.getElementById('report2-tab').ariaSelected = false;
        document.getElementById('report1-tab').ariaSelected = true;

        document.getElementById('report4-tab').classList.remove("active");
        document.getElementById('report3-tab').classList.remove("active");
        document.getElementById('report2-tab').classList.remove("active");
        document.getElementById('report1-tab').classList.remove("active");

        document.getElementById('report1-tab').classList.add("active");
        setReportIndex(1);
        
        //report_content = report_content.replace(/ins>/g, "u>");
        //setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(report_content))));
        const { eState, CSMap } = HTMLToEditorState(report_content);
        setEditorState(eState);
        setCustomeStyleMap(CSMap);
        
        setTimeout(function () {
          if(document.getElementById("hidp_key_submit").value!==patientData[index].patient_key.toString())
          {
            alert('Wrong patient details updating, refresh and try again.');
            return false; 
          }

          if(document.getElementById("hidc_key_submit").value!==patientData[index].center_key.toString())
          {
            alert('Wrong center patient updating, refresh and try again.');
            return false;
          }
        }, 1000);
      }

      var action_tag = 'REPORT_SUBMIT';
      var user_key = authUser?.user_key; 
      var notes = '';
      const priority = 'N';
      
      var heart_rate = 0; var pr_interval = 0; var qrs_duration = 0; var qt_interval = 0; var qtc_interval = 0;
      var rhythm = ''; var axis = ''; var p_wave = ''; var t_wave = ''; var st_segment = ''; var q_wave = ''; var qrs_complex = '';

      if(param==='SAVE' || param=== 'SAVE_SIGNOFF' || param=== 'PRINT'){
        //alert(markupReport);
        index = patientIndex;

        if(param !== 'PRINT'){
          if(patientData[index].report_status === 'F')
          {
            alert('Cannot allow to edit after printed.');
            return false;
          }
        }

        report_count = parseInt(document.getElementById('myReportTab').tag, 10);
        report_content = document.getElementById('report1-tab').tag;
        report_content2 = document.getElementById('report2-tab').tag;
        report_content3 = document.getElementById('report3-tab').tag;
        report_content4 = document.getElementById('report4-tab').tag;

        let markupReportTemp = markupReport;
        
        if(reportIndex===4){
          report_content4 = markupReportTemp;
        }
        else if(reportIndex===3){
          report_content3 = markupReportTemp;
        }
        else if(reportIndex===2){
          report_content2 = markupReportTemp;
        }
        else{
          report_content = markupReportTemp;
        }

        if(patientData[index].modality==='ECG'){
          report_content = document.getElementById("txtimpression").value;

          if(report_content === ""){
            alert('Report impression cannot be blank.'); 
            return false;
          }

          heart_rate = document.getElementById('txtheart_rate').value; if(heart_rate==='') { heart_rate = '0'; }
          if(heart_rate === "" || heart_rate === "0"){
            alert('Heart rate is mandatory.'); 
            return false;
          }

          pr_interval = document.getElementById('txtpr_interval').value; if(pr_interval==='') { pr_interval = '0'; }
          qrs_duration = document.getElementById('txtqrs_duration').value; if(qrs_duration==='') { qrs_duration = '0'; }
          qt_interval = document.getElementById('txtqt_interval').value; if(qt_interval==='') { qt_interval = '0'; }
          qtc_interval = document.getElementById('txtqtc_interval').value; if(qtc_interval==='') { qtc_interval = '0'; }

          if(heart_rate > 999){ alert('Invalid Heart Rate '+heart_rate+' Numeric Value.');  return false; }
          if(pr_interval > 999){ alert('Invalid PR Interval '+pr_interval+' Numeric Value.');  return false; }
          if(qrs_duration > 999){ alert('Invalid QRS Duration '+qrs_duration+' Numeric Value.');  return false; }
          if(qt_interval > 999){ alert('Invalid QT Interval '+qt_interval+' Numeric Value.');  return false; }
          if(qtc_interval > 999){ alert('Invalid QTc Interval '+qtc_interval+' Numeric Value.');  return false; }

          rhythm = document.getElementById('ddlrhythm').value;
          axis = document.getElementById('ddlaxis').value;
          p_wave = document.getElementById('ddlp_wave').value;
          t_wave = document.getElementById('ddlt_wave').value;
          st_segment = document.getElementById('ddlst_segment').value;
          q_wave = document.getElementById('ddlq_wave').value;
          qrs_complex = document.getElementById('ddlqrs_complex').value;
        }

        if(report_count > 0 && (report_content === "" || report_content === "<p></p>\n"))
        {
          alert('Report1 content cannot be blank.'); 
          return false;
        }

        if(param !== 'PRINT'){
          if(report_count > 1 && (report_content2 === "" || report_content2 === "<p></p>\n"))
          {
            alert('Report2 content cannot be blank.');
            return false;
          }
          if(report_count > 2 && (report_content3 === "" || report_content3 === "<p></p>\n"))
          {
            alert('Report3 content cannot be blank.');
            return false;
          }
          if(report_count > 3 && (report_content4 === "" || report_content4 === "<p></p>\n"))
          {
            alert('Report4 content cannot be blank.');
            return false;
          }
        }

        var center_key = document.getElementById("hidc_key_submit").value;
        var patient_key = document.getElementById("hidp_key_submit").value;
        
        if(param !== 'PRINT'){
          if(patient_key!==patientData[index].patient_key.toString())
          {
            alert('Wrong patient details updating, refresh and try again.');
            return false;
          }

          if(center_key!==patientData[index].center_key.toString())
          {
            alert('Wrong center patient updating, refresh and try again.');
            return false;
          }
        }

        report_content = reportContentAutoCorrect(report_content);
        report_content2 = reportContentAutoCorrect(report_content2);
        report_content3 = reportContentAutoCorrect(report_content3);
        report_content4 = reportContentAutoCorrect(report_content4);

        if(param === 'PRINT'){
          printReport(null, param, index, 'PRINT', 'SIGNOFF',report_count, report_content, report_content2, report_content3, report_content4, heart_rate, pr_interval, qrs_duration, qt_interval, qtc_interval, rhythm, axis, p_wave, t_wave, st_segment, q_wave, qrs_complex);
        }
        else{
          if(param=== 'SAVE_SIGNOFF'){action_tag = 'REPORT_SUBMIT_SIGNOFF';}  /* for call openSubmitReportPreview need to comment this line */
          
          updateStudy(index, action_tag, user_key, patientData[index].center_key, patientData[index].patient_key, report_count, report_content, report_content2, report_content3, report_content4, notes, '', 0, '', '', '', '', priority, '', '', '', null, null, null, null, null,heart_rate, pr_interval, qrs_duration, qt_interval, qtc_interval, rhythm, axis, p_wave, t_wave, st_segment, q_wave, qrs_complex);
          /*if(param=== 'SAVE_SIGNOFF'){
            setTimeout(function() {
                openSubmitReportPreview(event, 'OPEN', index, report_count, report_content, report_content2, report_content3, report_content4);
            }, 600);
          }*/
        }
      }

      if(param=== 'REVIEW_SIGNOFF' || param=== 'REVIEW_REWORK'){
          action_tag = param;
          if(param=== 'REVIEW_REWORK'){
            let rework_reason = prompt(`Please enter reason for rework`, ``);
            if(rework_reason===null){
              return false;
            }
            if(rework_reason===null || rework_reason === ''){
              alert(`Rework reason is mandatory.`);
              return false;
            }
            notes = rework_reason;
          }
          updateStudy(index, action_tag, user_key, patientData[index].center_key, patientData[index].patient_key, 0, '', '', '', '', notes, '', 0, '', '', '', '', priority, '', '', '');
      } 

      if(param === 'PRINT' || param === 'SAVE'){        
        if(param === 'SAVE'){
          //setAutoCloseTime(autoClose5);
          //notifySuccess('Report save successfully.'); 
          alert(`Report save successfully.`);
        }
      }
      else {
        let modal = document.querySelector("#openSubmitReport");
        modal.classList.toggle("closed");
      }
    };

    function reportContentAutoCorrect(markupReportTemp) {
       markupReportTemp = markupReportTemp.replace(//g, '&#8226;').replace(/Ø/g, '&#8226;').replace(/●/g, '&#8226;').replace(/·/g, '&#8226;'); /*.replace('à', '&rarr;')*/
        
        if(markupReportTemp.indexOf(`\n`) > 0){
          let headerLine = markupReportTemp.slice(0, markupReportTemp.indexOf(`\n`));
          let headerLineTemp = headerLine;
          if(headerLineTemp.indexOf(`<h`) === -1){
            if(headerLineTemp.indexOf(`<p><strong>`) !== -1 
              && headerLineTemp.indexOf(`</strong></p>`) !== -1){
              headerLineTemp = headerLineTemp.replace(`<p><strong>`, `<h2><strong>`);
              headerLineTemp = headerLineTemp.replace(`</strong></p>`, `</strong></h2>`);
            }
          }
          markupReportTemp = markupReportTemp.replace(headerLine, headerLineTemp);
        }

        return markupReportTemp;
    }
    const openSubmitReportPreview = (event, param, index, report_count, report_content, report_content2, report_content3, report_content4) => {
      event.preventDefault();
      
      if(index!=null){
        setPatientIndex(index);
      }
      
      if(authUser?.user_type !== 'D')
        {
          alert('Permission denied for the user');
          return false;
        }

      if(param==='OPEN'){        
        document.getElementById("spnsubmit_patient_preview").innerHTML = '🧑' + patientData[index].patient_name + ' | 📋' + patientData[index].modality + '-' + patientData[index].study_description;

        document.getElementById("hidc_key_submit_preview").value = patientData[index].center_key;
        document.getElementById("hidp_key_submit_preview").value= patientData[index].patient_key;

        if(patientData[index].report_status === "F")
        {
          document.getElementById('btnSubmitReportSignedOffPreview').disabled = true;
        }
        else
        {
          document.getElementById('btnSubmitReportSignedOffPreview').disabled = false;
        }

        document.getElementById('hidreport_count').value = report_count;
        document.getElementById('hidreport1-tab').value = report_content;
        document.getElementById('hidreport2-tab').value = report_content2;
        document.getElementById('hidreport3-tab').value = report_content3;
        document.getElementById('hidreport4-tab').value = report_content4;

        const template = getReportContent(index, report_count, report_content, report_content2, report_content3, report_content4, 'PRINT', '');
        let templatePreview = template.replace('report_template3.css', 'report_template3_preview.css');
        templatePreview = templatePreview.replace(' class ="bodytext">', ' class ="bodytext"> <br/><br/><br/><br/><br/><br/><br/>');
         
        document.getElementById('divPreviewContent').innerHTML = templatePreview;

        var WinPrintPreview = window.open('', '', 'width=850,height=600');
        WinPrintPreview.document.write(template);
        WinPrintPreview.document.close();
        WinPrintPreview.focus();
        
        setTimeout(function() {
          WinPrintPreview.print();
          WinPrintPreview.close();
        }, 600);

      }

      if(param==='SAVE_SIGNOFF_SUBMIT'){
        index = patientIndex;

        if(patientData[index].report_status === "F")
        {
          alert('Cannot allow to edit after printed.');
          return false;
        }

        var action_tag = 'REPORT_SUBMIT';
        var user_key = authUser?.user_key; 
        var notes = '';
        const priority = 'N';

        report_count = parseInt(document.getElementById("hidreport_count").value, 10);
        report_content = document.getElementById("hidreport1-tab").value;
        report_content2 = document.getElementById("hidreport2-tab").value;
        report_content3 = document.getElementById("hidreport3-tab").value;
        report_content4 = document.getElementById("hidreport4-tab").value;

        if(report_count === 0)
        {
          alert('Report1 content cannot be blank.'); 
          return false;
        }
        
        var center_key = document.getElementById("hidc_key_submit_preview").value;
        var patient_key = document.getElementById("hidp_key_submit_preview").value;

        if(patient_key!==patientData[index].patient_key.toString())
        {
          alert('Wrong patient details updating, refresh and try again.');
          return false;
        }

        if(center_key!==patientData[index].center_key.toString())
        {
          alert('Wrong center patient updating, refresh and try again.');
          return false;
        }

        action_tag = 'REPORT_SUBMIT_SIGNOFF';
        updateStudy(index, action_tag, user_key, patientData[index].center_key, patientData[index].patient_key, report_count, report_content, report_content2, report_content3, report_content4, notes, '', 0, '', '', '', '', priority, '', '', '');
      }

      let modal = document.querySelector("#openSubmitReportPreview");
      modal.classList.toggle("closed");
    };

    const getReportContent = (index, report_count, report_content, report_content2, report_content3, report_content4, action_type, caller, heart_rate, pr_interval, qrs_duration, qt_interval, qtc_interval, rhythm, axis, p_wave, t_wave, st_segment, q_wave, qrs_complex) =>
    {
      if(action_type==='' || action_type === null){
        action_type = 'PRINT';
      }

      var dr_sign_position = `right`;
      if (patientData[index].center_key === 56){
        dr_sign_position = `left`;
      }

      var report_hdr_align = ``;
      if (patientData[index].center_key === 58){
        report_hdr_align = `center`;
      }

      var IsEcg = false;
      if (patientData[index].modality === 'ECG'){
        IsEcg = true;
      }

      report_content= report_content.replace('<h1>', '<h2>').replace('</h1>', '</h2>').replace('à', '&rarr;').replace(//g, '&#8226;').replace(/Ø/g, '&#8226;');
      report_content2= report_content2.replace('<h1>', '<h2>').replace('</h1>', '</h2>').replace('à', '&rarr;').replace(//g, '&#8226;').replace(/Ø/g, '&#8226;');
      report_content3= report_content3.replace('<h1>', '<h2>').replace('</h1>', '</h2>').replace('à', '&rarr;').replace(//g, '&#8226;').replace(/Ø/g, '&#8226;');
      report_content4= report_content4.replace('<h1>', '<h2>').replace('</h1>', '</h2>').replace('à', '&rarr;').replace(//g, '&#8226;').replace(/Ø/g, '&#8226;');

      if(report_hdr_align === `center1`)
      {
        report_content= report_content.replace('<h2>', '<h2>').replace('</h2>', '</h2>');
        report_content2= report_content2.replace('<h2>', '<h2>').replace('</h2>', '</h2>');
        report_content3= report_content3.replace('<h2>', '<h2>').replace('</h2>', '</h2>');
        report_content4= report_content4.replace('<h2>', '<h2>').replace('</h2>', '</h2>');
      }

      if(action_type==='RTF' || action_type==='DOCX'){
        report_content= report_content.replace(`text-align:center`, '');
        report_content2= report_content2.replace(`text-align:center`, '');
        report_content3= report_content3.replace(`text-align:center`, '');
        report_content4= report_content4.replace(`text-align:center`, '');

        report_content= report_content.replace(/<li>/g, "<p>&#8226;&nbsp;").replace(/li>/g, "/p>");
        report_content2= report_content2.replace(/<li>/g, "<p>&#8226;&nbsp;").replace(/li>/g, "/p>");
        report_content3= report_content3.replace(/<li>/g, "<p>&#8226;&nbsp;").replace(/li>/g, "/p>");
        report_content4= report_content4.replace(/<li>/g, "<p>&#8226;&nbsp;").replace(/li>/g, "/p>");

        //line gap remove
        if(patientData[index].center_key === 96){
          report_content= report_content.replaceAll('<p>', '<p style="margin:0; ">');
          report_content2= report_content2.replaceAll('<p>', '<p style="margin:0; ">');
          report_content3= report_content3.replaceAll('<p>', '<p style="margin:0; ">');
          report_content4= report_content4.replaceAll('<p>', '<p style="margin:0; ">');
        }
      }
      else{
        //header gap
        if(patientData[index].center_key === 96){
          report_content= report_content.replace('</h2>', '</h2><br/>');
          report_content2= report_content2.replace('</h2>', '</h2><br/>');
          report_content3= report_content3.replace('</h2>', '</h2><br/>');
          report_content4= report_content4.replace('</h2>', '</h2><br/>');

          report_content= report_content.replace('</h3>', '</h3><br/>');
          report_content2= report_content2.replace('</h3>', '</h3><br/>');
          report_content3= report_content3.replace('</h3>', '</h3><br/>');
          report_content4= report_content4.replace('</h3>', '</h3><br/>');
        }

        report_content= report_content.replaceAll("<p></p>", "<p>&nbsp;</p>");
        report_content2= report_content2.replaceAll("<p></p>", "<p>&nbsp;</p>");
        report_content3= report_content3.replaceAll("<p></p>", "<p>&nbsp;</p>");
        report_content4= report_content4.replaceAll("<p></p>", "<p>&nbsp;</p>");
      }
      
      var report_template_code = authUser?.report_template_code.toString();
      var topMarginHeader = authUser?.header_margin.toString(); //'150';
      var bottomMarginFooter = authUser?.footer_margin.toString();//'120';
      var topMarginBodyArea = authUser?.header_bodyarea.toString();//'300';
      var bottomMarginBodyArea = authUser?.footer_bodyarea.toString();//'300';

      //topMarginHeader = '100'; bottomMarginFooter = '100'; topMarginBodyArea = '250'; bottomMarginBodyArea = '250';
      //topMarginHeader = '80'; bottomMarginFooter = '80'; topMarginBodyArea = '230'; bottomMarginBodyArea = '230';
      
      //report_template_code = 'Template4';
      //report_template_code = '';
      const urlRoot = `${process.env.REACT_APP_API_URL_EC2}`;
      //alert(urlRoot); 
      let modality = patientData[index].modality;
      let cssReportName = `css/report_template3.css?v=${process.env.REACT_APP_VERSION}`;
      let cssReportLinkRef1 = ``;
      
      if (modality === 'CT' || modality === 'ct' || modality === 'MR' || report_template_code === 'CT')
      {
        cssReportName = `css/report_template_ct.css?v=${process.env.REACT_APP_VERSION}`;
        cssReportLinkRef1 = `<link rel="preconnect" href="https://fonts.googleapis.com">
          <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
          <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700;900&display=swap" rel="stylesheet">`;
      }
      else if(report_template_code === 'Template4'){
        cssReportName = `css/report_template4.css?v=${process.env.REACT_APP_VERSION}`;
        cssReportLinkRef1 = `<link href="https://fonts.googleapis.com/css2?family=Dancing+Script:wght@500&family=Roboto:wght@500;700;900&display=swap" rel="stylesheet">`;
      }
      
      var template3 = ``;
      var sign_url_data = 'profile/dr-diptendu_sign.png';
      var dr_name = 'Dr. Diptendu Kumar Biswas';
      var dr_design = 'M.B.B.S., D.M.R.D. (Consultant Radiologist)';
      var dr_regn = 'Registration No: 61828 [WBMC]';
      var cssBodyStyle = ``; var gbImage = ``;
      
      var reportHeaderDisplay = true;
      if (patientData[index].center_key === 95 || patientData[index].center_key === 96){
        reportHeaderDisplay = false;
      }

      /*if(patientData[index].center_key >= 19 && patientData[index].center_key <= 23)
      {
        ;
      }
      else */if(patientData[index].doctor_key === 108 || patientData[index].doctor_key === 111)
      {
        sign_url_data = 'profile/108_dr_sign.png';
        dr_name = 'Dr. Bidhan Chandra Sarkar';
        dr_design = 'M.B.B.S. DMRD M.D. [Consultant Radiologist]';
        dr_regn = 'Registration No. : 53091 [WBMC]';
      }
      else if(patientData[index].doctor_key === 148)
      {
        sign_url_data = 'profile/148-dr-shis_sign.png';
        dr_name = 'Dr. Shis Mahammad Pail';
        dr_design = 'MD (Radio-Diagnosis)';
        dr_regn = 'Reg. No.-73040 (WBMC)';
      }
      else if(patientData[index].doctor_key === 149)
      {
        sign_url_data = 'profile/149-dr-sain_sign.png';
        dr_name = 'PROF-DR. DWARAKANATH SAIN';
        dr_design = `MBBS,MD,D.M.R.D
<br/>EX-Prof.& Head of the Dept. of Radiology
<br/>Medical College & hospital`;
        dr_regn = 'Reg. No.-30971';
      }
      else if(patientData[index].doctor_key === 168)
      {
        sign_url_data = 'profile/168-dr-tapas_sign.png';
        dr_name = 'DR. TAPAS KUMAR BISWAS';
        dr_design = `MBBS, MD(MEDICINE),
<br/>CONSULTATANT PHYSICIAN`;
        dr_regn = 'REG. NO.-WB49599';
      }
      else if(patientData[index].doctor_key === 150)
      {
        sign_url_data = 'profile/150-dr-sumit_sign.png';
        dr_name = 'Dr. Sumit Majumder';
        dr_design = `MBBS,DA,MD(Radio-Diagnosis)`;
        dr_regn = 'Reg. No.-58090 (WBMC)';
      }
      else if(patientData[index].doctor_key === 125)
      {
        sign_url_data = 'profile/125-dr-apurba_sign.png';
        dr_name = 'Dr. Apurba Kumar Majhi';
        dr_design = 'MD (Radio-Diagnosis)';
        dr_regn = 'Reg. No.-73132 (WBMC)';
      }
      else if (patientData[index].doctor_key === 78)
      {
        sign_url_data = 'profile/78-dr-asif_sign.png';
        dr_name = 'Dr. Sk Md Asif Iquebal';
        dr_design = 'MD (Radio-Diagnosis)';
        dr_regn = 'Reg. No.-71264 (WBMC)';
      }
      else if (patientData[index].center_key === 14
            || patientData[index].center_key === 77)
      {
        sign_url_data = 'profile/78-dr-asif_sign.png';
        dr_name = 'Dr. Sk Md Asif Iquebal';
        dr_design = 'MD (Radio-Diagnosis)';
        dr_regn = 'Reg. No.-71264 (WBMC)';
      }

      //report_background
      if(patientData[index].zipcode === 'Y'
        && (
          patientData[index].center_key === 64
          || patientData[index].center_key === 53
          )
       )
      { 
        
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
          gbImage = `<img class="mobile-bg-layer" src="img/background_images/bg_`+patientData[index].center_key.toString()+`.jpg" alt="">`;
        }
        else{
          cssBodyStyle = ` style="background-image: url('img/background_images/bg_`+patientData[index].center_key.toString()+`.jpg'); background-size: 740px; background-position: center top; print-color-adjust: exact; -webkit-print-color-adjust: exact; " `;
        }
        
        if(patientData[index].center_key === 53){
          topMarginHeader =  Number(topMarginHeader) + 40;
          topMarginBodyArea =  Number(topMarginBodyArea) + 40;
        }
        else if(patientData[index].center_key === 64){
          topMarginHeader =  Number(topMarginHeader) - 35;
          topMarginBodyArea =  Number(topMarginBodyArea) - 35;

          bottomMarginFooter =  Number(bottomMarginFooter) + 50;
          bottomMarginBodyArea =  Number(bottomMarginBodyArea) + 50;
        }
      }

      if(action_type === 'RTF' || action_type==='DOCX') {
        report_content = report_content.replace(/ins>/g, "u>");
        if(report_content2!== ''){
          report_content2 = report_content2.replace(/ins>/g, "u>");
          report_content2 = '<br/><br/>'+report_content2;
        }
        if(report_content3!== ''){
          report_content3 = report_content3.replace(/ins>/g, "u>");
          report_content3 = '<br/><br/>'+report_content3;
        }
        if(report_content4!== ''){
          report_content4 = report_content4.replace(/ins>/g, "u>");
          report_content4 = '<br/><br/>'+report_content4;
        }

        //var fontawesomemin = urlRoot+'/'+'css/font-awesome.min.css';
        //cssReportName = urlRoot+'/'+cssReportName;
        //<link href="`+fontawesomemin+`" rel="stylesheet">
        //`+cssReportLinkRef1+`

        //sign_url_data =`data:image/jpeg;base64,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`;
        sign_url_data = 'https://tele.mytsofts.com/' + sign_url_data;
        template3 = `<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'>
                      <head><meta charset='utf-8'>
                      <title>`+patientData[index].patient_name + `-` + patientData[index].patient_id +`</title>
                      <style rel="stylesheet">
                    body{
                        font-family: 'Arial','Times New Roman', Times, serif;
                    }
                    table {
                        font-family: arial, sans-serif;
                        border-collapse: collapse;
                        width: 100%;
                      }
                      
                      td, th {
                        text-align: left;
                        padding:8px;
                      }
                      p {
                        font-family:Arial, Helvetica, sans-serif;
                        font-size: 16px;  
                        font-weight: 400;                      
                        }
                        
                    .topheader{
                        font-family:Arial, Helvetica, sans-serif;
                        padding: 5px 10px;
                    }
                    .tab-container{
                        background: #f1f1f1;
                        border-radius: 15px;
                        border: #4e4e4e 2px solid;
                        padding: 20px 10px;
                    }
                    .rptname{
                        font-family: 'Dancing Script', cursive;
                        background: #d7d7d7;
                        border-radius: 10px;
                        padding: 12px 18px;
                        top: -10px;
                        position: relative;
                    }
                    .row{
                        --bs-gutter-x: 1.5rem;
                        --bs-gutter-y: 0;
                        display: flex;
                        flex-wrap: wrap;
                        margin-top: calc(-1 * var(--bs-gutter-y));
                        margin-right: calc(-0.5 * var(--bs-gutter-x));
                        margin-left: calc(-0.5 * var(--bs-gutter-x));
                    }
                    .col-3{ 
                        flex: 0 0 auto;
                        width: 25%;
                        font-weight: 400;
                    }
                    .col-30{ 
                        flex: 0 0 auto;
                        width: 30%;
                        font-weight: 400;
                    }
                    .col-40{ 
                        flex: 0 0 auto;
                        width: 40%;
                        font-weight: 400;
                    }
                    .col-20{ 
                        flex: 0 0 auto;
                        width: 20%;
                        font-weight: 400;
                    }
                    .col-10{ 
                        flex: 0 0 auto;
                        width: 10%;
                        font-weight: 400;
                    }
                    .col-6{ 
                        flex: 0 0 auto;
                        width: 50%;
                        font-weight: 400;
                    }
                    .col-12{ 
                        flex: 0 0 auto;
                        width: 100%;
                        font-weight: 400;
                    }
                    .headertext{
                        font-size:16px;
                        font-weight:400;
                        padding: 5px 20px;
                    }
                    .headertext_bold{
                        font-weight:700;
                    }
                    
                    .bodytext{
                        font-weight:400;
                        padding: 5px 10px;
                    }
                    
                    .bodytextlast{
                        font-weight:400;
                        padding: 5px 10px;
                    }
                    
                    .font20{
                        font-size: 20px;
                    }
                    .font30{
                        font-size: 30px;
                    }
                    .text-center{
                        text-align: center;
                    }
                    .bold{
                        font-weight:700;
                    }
                    .italic{
                        font-style: italic;
                    }
                    .bold_italic{
                        font-weight:700;
                        font-style: italic;
                    }
                    .italic_underline{
                        font-style: italic;
                        text-decoration: underline;
                    }
                    .underline{
                        text-decoration: underline;
                    }
                    .bold_underline{
                        font-weight:700;
                        text-decoration: underline;
                    }
                    .bold_italic_underline{
                        font-weight:700;
                        font-style: italic;
                        text-decoration: underline;
                    }
                    
                    footer{
                        margin-top: auto;
                        bottom: 10px;
                        width: 100%;
                    }
                    .footer_text{
                        font-size: 10px;
                        font-weight: 400;
                        padding: 10px 0;
                        margin-top: 10px;
                        border-top: #000 1px solid;
                        border-bottom: #000 1px solid;
                    }
                    .footer_text span{
                        font-size: 10px;
                        font-weight: 700;
                    }
                    .footsign{
                        font-size: 14px;
                        font-weight: 400;
                        padding: 5px 22px;
                        text-align: center;
                    }
                    .footsign span{
                        font-size: 18px;
                        font-weight: 500;
                    }
                    .float-right{
                        float: right;
                    }
                    .float-left{
                        float: left;
                    }
                    .me-2{
                        margin-right: 2em;
                    }
                    .mw-2{
                        margin-left: 2em;
                    }
                    .margin-auto{ margin:auto;}
                    
                    .divFooter{
                        font-family:Arial, Helvetica, sans-serif;
                        padding: 20px 0 0 0;
                    }
                    
                    
                    @media print {
                        .topheader{
                            position: fixed;
                            top: 50px;
                            font-size: 14px;
                        }
                        .bodyarea{
                            position: relative;
                            height:180px;
                        }
                        .bodytext{ height: 180px;}
                        .bodytext { page-break-after: always; }
                        .divFooter {
                            padding: 20px 0 0 0;
                            position: fixed;
                        }
                    
                    }
                      </style>
                      </head>
                      <body`+cssBodyStyle+`>`+gbImage;
      }
      else
      {
        template3 = `<!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8">
            <meta http-equiv="X-UA-Compatible" content="IE=edge">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>`+patientData[index].patient_name + `-` + patientData[index].patient_id +`</title>
            <link href="css/font-awesome.min.css" rel="stylesheet">
            `+cssReportLinkRef1+`
            <link href="`+cssReportName+`" rel="stylesheet">
        </head>
        <body`+cssBodyStyle+`>`+gbImage;
      }

      let patient_age_unit = ``;
      
      /*if (report_template_code === 'Template4')
      {*/
        if(patientData[index].patient_age_unit==='Y'){
          patient_age_unit = ' Year';
        }
        else if(patientData[index].patient_age_unit==='M'){
          patient_age_unit = ' Month';
        }
        else if(patientData[index].patient_age_unit==='D'){
          patient_age_unit = ' Day';
        }

        if(patient_age_unit !== '' && patientData[index].patient_age>1){
          patient_age_unit += 's';
        }
      /*}
      else{
        patient_age_unit = patientData[index].patient_age_unit;
      }*/
      
      let patient_age_print = patientData[index].patient_age;
      var patient_age_tmp = patient_age_print.toString().split(`.`);
      if( patient_age_tmp.length>1){
        patient_age_print = patient_age_tmp[0] + patient_age_unit + ` ` + patient_age_tmp[1];

        if (report_template_code === 'Template4' && 1===2)
        {
          if(patientData[index].patient_age_unit==='Y'){
            patient_age_print += ' Month';
          }
          else if(patientData[index].patient_age_unit==='M'){
            patient_age_print += ' Day';
          }

          if((patientData[index].patient_age_unit==='Y' || patientData[index].patient_age_unit==='M') && parseFloat(patient_age_tmp[1]) >1){
            patient_age_print += 's';
          }
        }
        else
        {
          if(patientData[index].patient_age_unit==='Y'){
            patient_age_print += 'M';
          }
          else if(patientData[index].patient_age_unit==='M'){
            patient_age_print += 'D';
          }
        }
      }
      else
      {
        patient_age_print += patient_age_unit;
      }

      let patient_sex = '';
      if(patientData[index].patient_sex==='M'){
        patient_sex = 'Male';
      }
      else if(patientData[index].patient_sex==='F'){
        patient_sex = 'Female';
      }
      let patient_id = '';
      if (patientData[index].center_key !== 18){
        patient_id = patientData[index].patient_id;
      }
      
      var bodyTextCustomStyle = "";

      if(caller === 'SIGNOFF'){
        if(printLineHeight !== ""){          
          bodyTextCustomStyle = "line-height:" + printLineHeight + ";";
        }
      }

      let reportHeader = ``;
      if (modality === 'CT' || modality === 'ct' || modality === 'MR' || report_template_code === 'CT')
      {
        if(reportHeaderDisplay){
              reportHeader =`<thead>
                        <tr>
                          <th style="width:130px;border: 1px solid #000;">Name</th>
                          <th style="width:300px;border: 1px solid #000;">`+patientData[index].patient_name+`</th>
                          <th style="width:100px;border: 1px solid #000;">Age/Sex</th>
                          <th style="width:150px;border: 1px solid #000;">`+patient_age_print+`/`+patient_sex+`</th>
                        </tr>
                        <tr>
                          <th style="border: 1px solid #000;">Date</th>
                          <th style="border: 1px solid #000;">`+patientData[index].regn_date+`</th>
                          <th style="border: 1px solid #000;">Patient Id</th>
                          <th style="border: 1px solid #000;">`+patientData[index].patient_id_ref+`</th>
                        </tr>
                        <tr>
                          <th style="border: 1px solid #000;">Referring Doctor</th>
                          <th style="border: 1px solid #000;">`+patientData[index].refer_physician+`</th>
                          <th style="border: 1px solid #000;">Report Id</th>
                          <th style="border: 1px solid #000;">`+patientData[index].patient_id+`</th>
                        </tr>
                        <tr style="height:20px;"><th style="border: 0px none;" colspan="4"></th></tr>
                      </thead>
                      `;
        }
        else{
            reportHeader =`<thead>
                        <tr style="height:100px;"><th style="border: 0px none;" colspan="4"></th></tr>
                      </thead>
                      `;
        }
      }
      else if (report_template_code === 'Template4')
      {
        reportHeader =`<div class ="topheader" style="margin-top: `+ topMarginHeader + `px;">
                      <div class ="tab-container">
                          <table style="width: 900px">
                              <tr>
                              <td style="width:150px;"><i class ="fa fa-user-o" aria-hidden="true"></i> Patient</td>
                              <td style="width:400px;"><i class ="fa fa-caret-right iconcol" aria-hidden="true"></i>&nbsp; <b>`+patientData[index].patient_name+`</b></td>
                              <td style="width:150px;"><i class ="fa fa-venus-mars" aria-hidden="true"></i> Age</td>
                              <td style="width:200px;"><i class ="fa fa-caret-right iconcol" aria-hidden="true"></i>&nbsp; <b>`+patient_age_print+`</b></td>
                              </tr>
                              <tr>
                              <td><i class ="fa fa-refresh" aria-hidden="true"></i> Ref By</td>
                              <td><i class ="fa fa-caret-right iconcol" aria-hidden="true"></i>&nbsp; <b>`+patientData[index].refer_physician+`</b></td>
                              <td><i class ="fa fa-venus" aria-hidden="true"></i> Gender</td>
                              <td><i class ="fa fa-caret-right iconcol" aria-hidden="true"></i>&nbsp; <b>`+patient_sex+`</b></td>
                              </tr>
                              <tr>
                              <td><i class ="fa fa-clock-o" aria-hidden="true"></i> Date</td>
                              <td><i class ="fa fa-caret-right iconcol" aria-hidden="true"></i>&nbsp; <b>`+patientData[index].regn_date+`</b></td>
                              <td><i class ="fa fa-file-text" aria-hidden="true"></i> Report Id</td>
                              <td><i class ="fa fa-caret-right iconcol" aria-hidden="true"></i>&nbsp; <b>`+patient_id+`</b></td>
                              </tr>
                          </table>
                      </div>
                  </div>`;
      }
      else{
        var col1_width = '130';
        var col2_width = '300';
        var col3_width = '100';
        var col4_width = '150';

        if(patientData[index].center_key === 39){
          col2_width = '255';
          col3_width = '80';
          col4_width = '215';
        }

        var hdr_row2_col1 = 'Date';
        var hdr_row2_col2 = patientData[index].regn_date;
        var hdr_row3_col3 = 'Report Id';
        var hdr_row3_col4 = patientData[index].patient_id;

        if(patientData[index].center_key === 91){
          hdr_row2_col1 = 'Report Id/Date';
          hdr_row2_col2 = patientData[index].patient_id + ` / ` + patientData[index].regn_date;
          hdr_row3_col3 = 'Exam. Date';
          hdr_row3_col4 = patientData[index].studyDate;
          if(hdr_row3_col4===''){
            hdr_row3_col4 = patientData[index].regn_date;
          }
        }

        var paddingTopHdr='';
        /*if(cssBodyStyle===''){paddingTopHdr='';}
        else{paddingTopHdr='padding: 0px 0px;';}
        */
       if(reportHeaderDisplay){
        reportHeader = `<div class ="topheader" style="margin-top: `+ topMarginHeader + `px;`+paddingTopHdr+`">
                      <table style="width: 680px;">
                          <tr>
                            <td style="width:`+col1_width+`px;border: 1px solid #000;">Name</td>
                            <td style="width:`+col2_width+`px;border: 1px solid #000;">`+patientData[index].patient_name+`</td>
                            <td style="width:`+col3_width+`px;border: 1px solid #000;">Age/Sex</td>
                            <td style="width:`+col4_width+`px;border: 1px solid #000;">`+patient_age_print+`/`+patient_sex+`</td>
                          </tr>
                          <tr>
                            <td style="border: 1px solid #000;">`+hdr_row2_col1+`</td>
                            <td style="border: 1px solid #000;">`+hdr_row2_col2+`</td>
                            <td style="border: 1px solid #000;">Patient Id</td>
                            <td style="border: 1px solid #000;">`+patientData[index].patient_id_ref+`</td>
                          </tr>
                            <tr>
                            <td style="border: 1px solid #000;">Referring Doctor</td>
                            <td style="border: 1px solid #000;">`+patientData[index].refer_physician+`</td>
                            <td style="border: 1px solid #000;">`+hdr_row3_col3+`</td>
                            <td style="border: 1px solid #000;">`+hdr_row3_col4+`</td>
                          </tr>
                      </table>
                  </div>`;
       }
       else{
              reportHeader = `<div class ="topheader" style="margin-top: `+ topMarginHeader + `px;`+paddingTopHdr+`">
                      <table style="width: 680px;">
                          <tr style="height: 100px;">
                            <td style="width:`+col1_width+`px;border: 0px"> </td>
                            <td style="width:`+col2_width+`px;border: 0px"> </td>
                            <td style="width:`+col3_width+`px;border: 0px"> </td>
                            <td style="width:`+col4_width+`px;border: 0px"> </td>
                          </tr>
                      </table>
                  </div>`;
       }
      }

      var qrCodeValueinnerHTML = '';
      if (modality === 'CT' || modality === 'ct' || modality === 'MR' || report_template_code === 'CT' 
        || patientData[index].center_key === 68 || patientData[index].center_key === 61 
        || patientData[index].center_key === 59 || patientData[index].center_key === 54 
        || patientData[index].center_key === 33 || patientData[index].center_key === 66 
        || patientData[index].center_key === 39 || patientData[index].center_key === 58
        || patientData[index].center_key === 14 
        || patientData[index].center_key > 72
      )
      {
        var qrCodeValue = document.getElementById(`qrCode_`+patientData[index].patient_key);
        if(qrCodeValue!==null){
          qrCodeValueinnerHTML = qrCodeValue.innerHTML;
        }
      }
      var qrCodeDisplay = '';
      if(qrCodeValueinnerHTML===''){
        qrCodeDisplay = 'none';
      }
      
      var reportExtraDeclaration = '';
      if ((modality === 'CT' || modality === 'ct' || modality === 'MR') 
        && patientData[index].center_key === 83
      )
      {
        reportExtraDeclaration = `<span style="font-size:12px;"><b>This CT Scan has been performed in 32 Slices Machine.</b></span><br/>`;
      }
      
      var ctLineHeight = ``;
      if ((modality === 'CT' || modality === 'ct' || modality === 'MR') 
        && (patientData[index].center_key === 83)
      )
      {
        ctLineHeight = ` style="line-height:20px;" `;
      }

      if (modality === 'CT' || modality === 'ct' || modality === 'MR' || report_template_code === 'CT')
      {
        for(var iCnt = 0; iCnt<report_count; iCnt++){
          let reportValue = report_content;
          let pageBreakClass = 'bodytext';
          if(iCnt === report_count-1){
            pageBreakClass = '';
          }

          if(iCnt===1){
            reportValue = report_content2;
          }
          else if(iCnt===2){
            reportValue = report_content3;
          }
          else if(iCnt===3){
            reportValue = report_content4;
          }
          
          template3 += 
          `<div class ="container `+pageBreakClass+`">
            <table id="report">`
              +reportHeader +`
              <tbody class ="report-body">
                <tr>
                  <td colspan="4"`+ctLineHeight+`>` 
                    + reportValue
                    + `
                  </td>
                </tr>

                <tr><td colspan="4"><br/><br/></tr>

                <tr>
                  <td colspan="4">
                    <div class ="row">
                      <table style="width: 100%; border:none;">
                        <tr>
                          <td style="width:44%;">
                            <div class ="margin-auto">
                                <div class ="footsign" style="height:auto; width: 85px; background-color:lightgrey; padding:3px 3px 0px 3px;display:`+qrCodeDisplay+`;">
                                  `+ qrCodeValueinnerHTML +`
                                </div>
                            </div>
                          </td>
                          <td>
                            <div>
                              <div class ="footsign">
                                  <img src="`+ sign_url_data +`" width="229" height="48" /><br/>
                                  <span><b>`+ dr_name +`</b></span> <br/>
                                  `+ dr_design +`<br/>
                                  `+ dr_regn +` <br/>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td colspan="4">
                    <div class ="footer_text" style="font-size:9px; line-height: 10px;">
                        `+ reportExtraDeclaration +`<span style="font-size:12px;"><b>Disclaimer:</b></span> It is an online interpretation of medical imaging based on clinical data. All modern machines
                        /procedures have their own limitation. If there is any clinical discrepancy this investigation may be repeated
                        or reassessed by other tests. Patient’s identification in online reporting is not established, So in no way can
                        this report be utilized for any medico legal purpose.
                    </div>
                  
                  </td>
                </tr>

              </tbody>

              <tfoot class ="report-footer">
                <tr>
                    <th colspan="4" style="width:250px;bottom: `+ bottomMarginFooter + `px;">
                        &nbsp;
                    </th>
                </tr>
              </tfoot>
            </table>
          </div>`;
        }
        
        template3 += `
        </body>
        </html>`;
      }
      else{
        let reportFooter = ``;
        let footerBottom = 'Y';
        let footerDisclaimerText = '';

        let disclaimerFontSize = '9px';
        if(report_template_code === 'Template4'){
          disclaimerFontSize = '10px';
        }

        let footerQRCodeWidth = `44%`;
        if(patientData[index].center_key === 12)
        {
          footerQRCodeWidth = `60%`;
        }

        if(patientData[index].center_key === 33 
          || patientData[index].center_key === 66
          ){
            ;
        }
        else {
          footerDisclaimerText = `
            <div class ="row">
              <table style="width: 100%; border:none;">
                <tr>
                  <td style="width:100%;">
                    <div class ="margin-auto">
                        <div class ="footsign" style="font-size:`+disclaimerFontSize+`; line-height: 10px; text-align:left;">
                          <span style="font-size:12px;"><b>Disclaimer:</b></span> It is an online interpretation of medical imaging based on clinical data. All modern machines
                          /procedures have their own limitation. If there is any clinical discrepancy this investigation may be repeated
                          or reassessed by other tests. Patient’s identification in online reporting is not established, So in no way can
                          this report be utilized for any medico legal purpose.
                        </div>
                    </div>
                  </td>
                </tr>
              </table>
            </div>`;
        }

        if(patientData[index].center_key === 18 || patientData[index].center_key === 42)
        {
          footerBottom = 'N';
        }

        if(dr_sign_position===`left`){
          if (footerBottom === 'Y')
          {
            reportFooter += `
            <footer class ="divFooter" style="bottom: `+ bottomMarginFooter + `px;">`;
          }
          else
          {
            reportFooter += `
            <footer>`;
          }
          reportFooter += `
              <div class ="row">
                  <table style="width: 100%; border:none;">
                    <tr>
                      <td>
                        <div>
                          <div class ="footsign">
                              <img src="`+ sign_url_data +`" width="229" height="48" /><br/>
                              <span><b>`+ dr_name +`</b></span> <br/>
                              `+ dr_design +`<br/>
                              `+ dr_regn +` <br/>
                          </div>
                        </div>
                      </td>
                      <td style="width:44%;">
                        <div class ="margin-auto">
                            <div class ="footsign" style="height:auto; width: 85px; background-color:lightgrey; padding:3px 3px 0px 3px;display:`+qrCodeDisplay+`;">
                              `+ qrCodeValueinnerHTML +`
                            </div>
                        </div>
                      </td>
                    </tr>
                  </table>
              </div>`;

          reportFooter += footerDisclaimerText + `
            </footer>`;
        }
        else{
          if (footerBottom === 'Y')
          {
            reportFooter += `
            <footer class ="divFooter" style="bottom: `+ bottomMarginFooter + `px;">`;
          }
          else
          {
            reportFooter += `
            <footer>`;
          }
          reportFooter += `
                <div class ="row">
                    <table style="width: 100%; border:none;">
                      <tr>
                        <td style="width:`+footerQRCodeWidth+`;">
                          <div class ="margin-auto">
                              <div class ="footsign" style="height:auto; width: 85px; background-color:lightgrey; padding:3px 3px 0px 3px;display:`+qrCodeDisplay+`;">
                                `+ qrCodeValueinnerHTML +`
                              </div>
                          </div>
                        </td>
                        <td>
                          <div>
                            <div class ="footsign">
                                <img src="`+ sign_url_data +`" width="229" height="48" /><br/>
                                <span><b>`+ dr_name +`</b></span> <br/>
                                `+ dr_design +`<br/>
                                `+ dr_regn +` <br/>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </table>
                </div>`;

          reportFooter += footerDisclaimerText + `
            </footer>`;
        }
      
        template3 += reportHeader + `<div class ="bodyarea" style="top: `+ topMarginBodyArea + `px; bottom: `+ bottomMarginBodyArea + `px;">`;

        template3 += `<div`;
        if(report_count > 1){
        template3 += ` class ="bodytext" style="`+ bodyTextCustomStyle + `">`;
        }
        else{
        template3 += ` class ="bodytextlast" style="`+ bodyTextCustomStyle + `">`;
        }

        if(IsEcg){
          let heart_rate_text = '';
          if(heart_rate>0){ heart_rate_text = heart_rate+' bpm'; }

          let pr_interval_text = '';
          if(pr_interval>0){ pr_interval_text = pr_interval+' msec'; }

          let qrs_duration_text = '';
          if(qrs_duration>0){ qrs_duration_text = qrs_duration+' msec'; }

          let qt_interval_text = '';
          if(qt_interval>0){ qt_interval_text = qt_interval+' msec'; }
          
          let qtc_interval_text = '';
          if(qtc_interval>0){ qtc_interval_text = qtc_interval+' msec'; }

          let rhythm_text = ''; let axis_text = ''; let p_wave_text = ''; 
          let t_wave_text = ''; let st_segment_text = ''; let q_wave_text = ''; let qrs_complex_text = ''; 
          
          switch (rhythm) {
            case '': rhythm_text = ''; break;
            case 'SRH': rhythm_text = 'Sinus Rhythm'; break;
            case 'SBR': rhythm_text = 'Sinus Bradycardia'; break;
            case 'STA': rhythm_text = 'Sinus Tachycardia'; break;
            case 'SAR': rhythm_text = 'Sinus Arrhythmia'; break;
            case 'AFI': rhythm_text = 'Atrial Fibrillation'; break;
            case 'AFL': rhythm_text = 'Atrial Flutter'; break;
            case 'VTA': rhythm_text = 'Ventricular Tachycardia'; break;
            case 'VFI': rhythm_text = 'Ventricular Fibrillation'; break;
            case 'IRH': rhythm_text = 'Irregular Rhythm'; break;
            default: rhythm_text = '';
          }

          switch (axis) {
            case '': axis_text = ''; break;
            case 'NOR': axis_text = 'Normal Axis'; break;
            case 'LAD': axis_text = 'Left Axis Deviation'; break;
            case 'RAD': axis_text = 'Right Axis Deviation'; break;
            case 'EAD': axis_text = 'Extreme Axis Deviation'; break;
            default: axis_text = '';
          }

          switch (p_wave) {
            case '': p_wave_text = ''; break;
            case 'NOR': p_wave_text = 'Normal'; break;
            case 'ABS': p_wave_text = 'Absent'; break;
            case 'INV': p_wave_text = 'Inverted'; break;
            case 'PEA': p_wave_text = 'Peaked'; break;
            default: p_wave_text = '';
          }

          switch (t_wave) {
            case '': t_wave_text = ''; break;
            case 'NOR': t_wave_text = 'Normal'; break;
            case 'INV': t_wave_text = 'Inverted'; break;
            case 'PEA': t_wave_text = 'Peaked'; break;
            case 'FLA': t_wave_text = 'Flattened'; break;
            case 'NAB': t_wave_text = 'Nonspecific T Wave Abnormalities'; break;
            case 'NCH': t_wave_text = 'Nonspecific Changes'; break;
            default: t_wave_text = '';
          }

          switch (st_segment) {
            case '': st_segment_text = ''; break;
            case 'NOR': st_segment_text = 'Normal'; break;
            case 'ISO': st_segment_text = 'Isoelectric'; break;
            case 'STE': st_segment_text = 'ST Elevation'; break;
            case 'STD': st_segment_text = 'ST Depression'; break;
            case 'NAB': st_segment_text = 'Nonspecific ST Abnormalities'; break;
            case 'NCH': st_segment_text = 'Nonspecific Changes'; break;
            default: st_segment_text = '';
          }

          switch (q_wave) {
            case '': q_wave_text = ''; break;
            case 'NIL': q_wave_text = 'NIL'; break;
            case 'NOR': q_wave_text = 'Normal'; break;
            case 'NPA': q_wave_text = 'No Pathological'; break;
            case 'PAT': q_wave_text = 'Pathological'; break;
            default: q_wave_text = '';
          }
          
          switch (qrs_complex) {
            case '': qrs_complex_text = ''; break;
            case 'NOR': qrs_complex_text = 'Normal'; break;
            case 'WID': qrs_complex_text = 'Wide QRS'; break;
            case 'LVO': qrs_complex_text = 'Low Voltage'; break;
            case 'LBB': qrs_complex_text = 'LBBB'; break;
            case 'RBB': qrs_complex_text = 'RBBB'; break;
            default: qrs_complex_text = '';
          }

          template3 +=`<br/>`;
          template3 +=`<center class ="mb-1"><span class ="text-center font30 rptname2">Electrocardiogram Report</span></center>`;
          //<tr><td colspan="6" style="height:5px;"></tr>
          template3 +=`<div>
                          <table style="width: 100%">
                              <tr>
                                <td style="width:19%;"><b>Heart Rate</b></td>
                                <td style="width:3px;"><b>:</b></td>
                                <td style="width:30%;">`+heart_rate_text+`</td>
                              
                                <td style="width:19%;"><b>QRS Interval</b></td>
                                <td style="width:3px;"><b>:</b></td>
                                <td style="width:30%;">`+qrs_duration_text+`</td>
                              </tr>

                              <tr>
                                <td><b>Rhythm</b></td>
                                <td><b>:</b></td>
                                <td>`+rhythm_text+`</td>
                              
                                <td><b>Axis</b></td>
                                <td><b>:</b></td>
                                <td>`+axis_text+`</td>
                              </tr>
                              
                              <tr>
                                <td><b>'P' Wave</b></td>
                                <td><b>:</b></td>
                                <td>`+p_wave_text+`</td>
                              
                                <td><b>'T' Wave</b></td>
                                <td><b>:</b></td>
                                <td>`+t_wave_text+`</td>
                              </tr>
                              
                              <tr>
                                <td><b>'PR' Interval</b></td>
                                <td><b>:</b></td>
                                <td>`+pr_interval_text+`</td>
                              
                                <td><b>ST Segment</b></td>
                                <td><b>:</b></td>
                                <td>`+st_segment_text+`</td>
                              </tr>
                              
                              <tr>
                                <td><b>'Q' Wave</b></td>
                                <td><b>:</b></td>
                                <td>`+q_wave_text+`</td>
                              
                                <td><b>QT Interval</b></td>
                                <td><b>:</b></td>
                                <td>`+qt_interval_text+`</td>
                              </tr>
                              
                              <tr>
                                <td><b>QRS Complex</b></td>
                                <td><b>:</b></td>
                                <td>`+qrs_complex_text+`</td>
                              
                                <td><b>QTc Interval</b></td>
                                <td><b>:</b></td>
                                <td>`+qtc_interval_text+`</td>
                              </tr>
                              
                          </table>
                      </div>
                  </div>`;
        }
        else if (report_template_code === 'Template4')
        {
          template3 +=`<center class ="mb-1"><span class ="text-center font30 rptname">Radiological Observation</span></center>`;
        }

        if(IsEcg){
          template3 += '<br/>';

          if(report_content.toUpperCase().indexOf('IMPRESSION') === -1){
            template3 += '<span><b>IMPRESSION: </b></span>';
          }

          report_content = report_content.replace(/\n/g, '<br/>');

          template3 += '<span><b>'+report_content+'</b></span>';
          
          if(report_content.indexOf('Clinical') === -1){
            template3 += '<br/><br/>';
            template3 += '<span><b>**Clinical correlation suggested.</b></span>';
          }
        }
        else{
          template3 += report_content;
        }

        if (footerBottom === 'N')
        {
          template3 += reportFooter;
        }

        template3 += `</div>`;

        if(report_count > 1 && report_content2 !== '')
        {
          if (report_template_code === 'Template4')
          {
            template3 += reportHeader + `<div class ="bodyarea" style="top: `+ topMarginBodyArea + `px; bottom: `+ bottomMarginBodyArea + `px;">`;
          }

        template3 += `<div`;
        if(report_count > 2){
          template3 += ` class ="bodytext" style="`+ bodyTextCustomStyle + `">`;
        }
        else{
          template3 += ` class ="bodytextlast" style="`+ bodyTextCustomStyle + `">`;
        }

        if (report_template_code === 'Template4')
        {
          template3 +=`<center class ="mb-1"><span class ="text-center font30 rptname">Radiological Observation</span></center>`;
        }

        template3 += report_content2;
        if (footerBottom === 'N')
        {
          template3 += reportFooter;
        }

        template3 += `</div>`;
        }

        if(report_count > 2 && report_content3 !== '')
        {
          if (report_template_code === 'Template4')
          {
            template3 += reportHeader + `<div class ="bodyarea" style="top: `+ topMarginBodyArea + `px; bottom: `+ bottomMarginBodyArea + `px;">`;
          }
          
        template3 += `<div`;
        if(report_count > 3){
          template3 += ` class ="bodytext" style="`+ bodyTextCustomStyle + `">`;
        }
        else{
          template3 += ` class ="bodytextlast" style="`+ bodyTextCustomStyle + `">`;
        }

        if (report_template_code === 'Template4')
        {
          template3 +=`<center class ="mb-1"><span class ="text-center font30 rptname">Radiological Observation</span></center>`;
        }

        template3 += report_content3;
        if (footerBottom === 'N')
        {
          template3 += reportFooter;
        }

        template3 += `</div>`;
        }

        if(report_count > 3 && report_content4 !== '')
        {
          if (report_template_code === 'Template4')
          {
            template3 += reportHeader + `<div class ="bodyarea" style="top: `+ topMarginBodyArea + `px; bottom: `+ bottomMarginBodyArea + `px;">`;
          }
          
        template3 += `<div`;
        if(report_count > 4){
          template3 += ` class ="bodytextlast" style="`+ bodyTextCustomStyle + `">`;
        }
        else{
          template3 += ` class ="bodytextlast" style="`+ bodyTextCustomStyle + `">`;
        }

        if (report_template_code === 'Template4')
        {
          template3 +=`<center class ="mb-1"><span class ="text-center font30 rptname">Radiological Observation</span></center>`;
        }

        template3 += report_content4;
        if (footerBottom === 'N')
        {
          template3 += reportFooter;
        }

        template3 += `</div>`;
        }
        template3 += `</div>`;
        
        if (footerBottom === 'Y')
        {
          template3 += reportFooter;
        }
        
        template3 += `</body></html>`;
      }
      return template3;
    }
    const printReport = async (event, param, index, action_type, caller, report_count, report_content, report_content2, report_content3, report_content4, heart_rate, pr_interval, qrs_duration, qt_interval, qtc_interval, rhythm, axis, p_wave, t_wave, st_segment, q_wave, qrs_complex) => {
      if(caller !== 'SIGNOFF'){
        event.preventDefault();
      }

      if(index!=null){
        setPatientIndex(index);
      }
      //alert(index); alert(index);
      if(index!=null){
        //alert(markupReport);
        //alert(patientData[index].report_content);

        if(report_count===null || report_count === undefined)
        {
          report_count = patientData[index].report_count;
          report_content= patientData[index].report_content;
          report_content2= patientData[index].report_content2;
          report_content3= patientData[index].report_content3;
          report_content4= patientData[index].report_content4;

          heart_rate= patientData[index].heart_rate; if(heart_rate===0) { heart_rate = ''; }
          pr_interval= patientData[index].pr_interval; if(pr_interval===0) { pr_interval = ''; }
          qrs_duration= patientData[index].qrs_duration; if(qrs_duration===0) { qrs_duration = ''; }
          qt_interval= patientData[index].qt_interval; if(qt_interval===0) { qt_interval = ''; }
          qtc_interval= patientData[index].qtc_interval; if(qtc_interval===0) { qtc_interval = ''; }

          rhythm= patientData[index].rhythm;
          axis= patientData[index].axis;
          p_wave= patientData[index].p_wave;
          t_wave= patientData[index].t_wave;
          st_segment= patientData[index].st_segment;
          q_wave= patientData[index].q_wave;
          qrs_complex= patientData[index].qrs_complex;
        }

        if(caller === 'SIGNOFF')
        {
          if(report_count === 4)
          {
            if(report_content4 === "" || report_content4 === "<p></p>\n"
              || report_content4 === "<h1></h1>\n"
              || report_content4 === "<h2></h2>\n"
              || report_content4 === "<h3></h3>\n")
            {
              report_content4 = ""; report_count = 3;
            }
          }

          if(report_count === 3)
          {
            if(report_content3 === "" || report_content3 === "<p></p>\n"
              || report_content3 === "<h1></h1>\n"
              || report_content3 === "<h2></h2>\n"
              || report_content3 === "<h3></h3>\n")
            {
              report_content3 = ""; report_count = 2;
            }
          }

          if(report_count === 2)
          {
            if(report_content2 === "" || report_content2 === "<p></p>\n"
              || report_content2 === "<h1></h1>\n"
              || report_content2 === "<h2></h2>\n"
              || report_content2 === "<h3></h3>\n")
            {
              report_content2 = ""; report_count = 1;
            }
          }

        }

        if(patientData[index].report_status !== 'S' && patientData[index].report_status !== 'F')
        {
          alert('Report is not yet signed off.'); 
          return false;
        }

        if(report_count === 0 || (report_content === "" || report_content === "<p></p>\n" 
          || report_content === "<h1></h1>\n" || report_content === "<h2></h2>\n"))
        {
          alert('Report content is empty and not yet submitted.'); 
          return false;
        }

        if(patientData[index].patient_sex === '')
        {
          alert('Patient sex is blank, cannot allow to print.'); 
          return false;
        }
        if(patientData[index].patient_age === '' || patientData[index].patient_age === '0' || patientData[index].patient_age === 0)
        {
          alert('Patient age is blank, cannot allow to print.'); 
          return false;
        }

        const template = getReportContent(index, report_count, report_content, report_content2, report_content3, report_content4, action_type, caller, heart_rate, pr_interval, qrs_duration, qt_interval, qtc_interval, rhythm, axis, p_wave, t_wave, st_segment, q_wave, qrs_complex);
        if(action_type==='RTF' || action_type==='DOCX')
        {
          if(action_type==='RTF') {
            ExportToDoc(template, patientData[index].patient_id +'-'+ patientData[index].patient_name.replace('&', '-'));
          }
          else{
            await ExportToDocx(template, patientData[index].patient_id +'-'+ patientData[index].patient_name.replace('&', '-'));
          }

          patientData[index].notes = 'EXPORT_RTF_STUDY';
          ChangeStudyStatus('PRINT_STUDY', index, null, patientData[index].center_key, patientData[index].patient_key, '');
        }
        else {
          var WinPrint = window.open('', '', 'width=850,height=600');
          WinPrint.document.write(template);
          WinPrint.document.close();
          WinPrint.focus();

          let _print_interval = 1000;
          if(patientData[index].center_key===18 || patientData[index].center_key===6){ 
            _print_interval = 2000;
          }

          setTimeout(function() {
              WinPrint.print();
              if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
                setTimeout(function() {
                  WinPrint.close();
                }, 30000);
              }
              else{
                WinPrint.close();
              }
          }, _print_interval);

          if(caller !== 'SIGNOFF'){
          ChangeStudyStatus('PRINT_STUDY', index, null, patientData[index].center_key, patientData[index].patient_key, '');
          }
        }
        
      }
      
    };

    async function imageUrlToDataUrl(url) {
      const response = await fetch(url);
      const blob = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result); // "data:image/png;base64,..."
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    }
    async function replaceExternalImagesWithDataUrls(htmlString) {
      // Match any <img> tag with an http(s) src (adjust selector if signature has a class/id)
      const imgRegex = /<img[^>]*src="(https?:\/\/[^"]+)"[^>]*>/g;
      let processedHtml = htmlString;
      const matches = [...htmlString.matchAll(imgRegex)];

      for (const match of matches) {
        const fullTag = match[0];
        const url = match[1];
        try {
          const dataUrl = await imageUrlToDataUrl(url);
          const newTag = fullTag.replace(url, dataUrl);
          processedHtml = processedHtml.replace(fullTag, newTag);
        } catch (err) {
          console.error(`Failed to inline image from ${url}:`, err);
          // leave original tag if fetch fails, so export doesn't crash
        }
      }

      return processedHtml;
    }
    // Converts an SVG string to a PNG data URI via canvas
    function svgStringToPngDataUrl(svgString, size = 256) {
      return new Promise((resolve, reject) => {
        const svgBlob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
        const url = URL.createObjectURL(svgBlob);

        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = size;
          canvas.height = size;
          const ctx = canvas.getContext('2d');
          // white background so it's not transparent in Word
          ctx.fillStyle = '#ffffff';
          ctx.fillRect(0, 0, size, size);
          ctx.drawImage(img, 0, 0, size, size);
          URL.revokeObjectURL(url);
          resolve(canvas.toDataURL('image/png'));
        };
        img.onerror = (e) => {
          URL.revokeObjectURL(url);
          reject(e);
        };
        img.src = url;
      });
    }

    // Finds the QR <svg>...</svg> block in the HTML string and replaces it with an <img>
    async function replaceSvgWithImg(htmlString) {
      const svgMatch = htmlString.match(/<svg[^>]*viewBox="0 0 33 33"[\s\S]*?<\/svg>/);
      if (!svgMatch) return htmlString; // no SVG found, nothing to do

      const svgString = svgMatch[0];
      const dataUrl = await svgStringToPngDataUrl(svgString, 256);
      const imgTag = `<img src="${dataUrl}" width="85" height="85" />`;

      return htmlString.replace(svgString, imgTag);
    }

    const wrapHtmlDocument = (innerHtml) => {
    return `
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="utf-8" />
        </head>
        <body>${innerHtml}</body>
      </html>
    `;
  };

    const ExportToDocx = async (elementValue, filename = '') => {
    try {
      if(filename.indexOf('.')>0){
        filename = filename+'.docx';
      }

      elementValue = elementValue.replace('background-color:lightgrey;', 'background-color:transparent;');
      
      let  processedHtml = await replaceSvgWithImg(elementValue); // QR code fix
      processedHtml = await replaceExternalImagesWithDataUrls(processedHtml); // signature url fix
      const fullDocument = wrapHtmlDocument(processedHtml);
      const blob = htmlDocx.asBlob(fullDocument);
      saveAs(blob, filename);
    } catch (err) {
      console.error("DOCX Export Failed:", err);
      alert("Failed to generate DOCX.");
    }
  };

    function ExportToDoc(elementValue, filename = ''){
      var html = elementValue;   
      var blob = new Blob(['\ufeff', html], {
          type: 'application/msword'
      });
      
      // Specify link url
      var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
      
      // Specify file name
      filename = filename?filename+'.rtf':'document.rtf';
      
      // Create download link element
      var downloadLink = document.createElement("a");
   
      document.body.appendChild(downloadLink);
      
      if(navigator.msSaveOrOpenBlob ){
          navigator.msSaveOrOpenBlob(blob, filename);
      }else{
          // Create a link to the file
          downloadLink.href = url;
          
          // Setting the file name
          downloadLink.download = filename;
          
          //triggering the function
          downloadLink.click();
      }
      
      document.body.removeChild(downloadLink);
    }

    const openActivityReport = (event, param, column_name, column_value_old, column_value_new) => {
      event.preventDefault();
      if(param==='OPEN'){        
        document.getElementById("spnlog_report").innerHTML = document.getElementById("spnlog_patient").innerHTML;
        setColumnNameReport(column_name);
        setOldReport(column_value_old);
        setNewReport(column_value_new);
      }

      let modal = document.querySelector("#activityReport");
      modal.classList.toggle("closed");
    }
    const openActivityLog = (event, param, index, action_tag) => {
      event.preventDefault();
      
      if(index!=null){
        setPatientIndex(index);
      }

      if(param === 'OPEN'){
        document.getElementById("spnlog_patient").innerHTML = '🧑' + patientData[index].patient_id + '-' + patientData[index].patient_name;
        
        if (!authUser){
          alert('Unauthorized session, please try to relogin.');
          return null;
        }

        const url = `${process.env.REACT_APP_API_URL}/activitylog`;
  
        const user_key = authUser?.user_key;
        const center_key = authUser?.center_key;
        const patient_key = patientData[index].patient_key;

        const request_id = randomNumberInRange(1000000, 9000000);
        const token = JSON.parse(localStorage.getItem('user')).token;
        const action_tag = "";
        const config = {
          headers: {
            'content-type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'user_key': user_key.toString(),
            'center_key': center_key.toString(),
            'patient_key': patient_key.toString(),
            'action_tag': action_tag,
            'request_id': request_id.toString()
          },
        };
    
        try {
          
          setActivitylogData([]); 

          axios.get(url, config).then((response) => { 
            let updatedValue = {};
            if(response.data.length>0){
              updatedValue = response.data; 
            }
           
           setActivitylogData(updatedValue); 
          })
          
        .catch(error => {
          var Unauthorized = false; var errorCatch = '';
          if(error.response!= null)
          {
            errorCatch = 'Exception found!';
            if(error.response.data != null)
            {
              if(error.response.data.message==='Unauthorized')
              {
                Unauthorized = true;
              }
              else
              {
                errorCatch = error.response.data.message;
              }
            }
          }
          else if(error.message!= null)
          {
            errorCatch = error.message;
          }

          if(Unauthorized)
          {
            alert('Unauthorized session, try to relogin.');
            logout();
          }
          else{
            alert(errorCatch);
          }
         });
        } catch (err) {
          //debugger;
          //alert('error');
            //alert(err.code);
          if (err.code === '404') {
            //setError('Object does not exist.')
            return
          }
        }

      }

      let modal = document.querySelector("#activityLog");
      modal.classList.toggle("closed");
    };

    const openModal2 = (event, param) => {
      event.preventDefault();

      let modal2 = document.querySelector("#modal2");
      modal2.classList.toggle("closed");
    };
    
    const openContactInfo = (event, param, i) => {
      event.preventDefault();

      let modal3 = document.querySelector("#modal3");
      modal3.classList.toggle("closed");
    };
    
    const openModalSuccess = (event, param) => {
      event.preventDefault();

      let modal4 = document.querySelector("#modal_success");
      modal4.classList.toggle("closed");
    };
    const openModalError = (event, param) => {
      event.preventDefault();

      let modal5 = document.querySelector("#modal_error");
      modal5.classList.toggle("closed");
    };
    
    const viewDicom = (event, dicomUrl, index, objectType, viewerName) => {
      event.preventDefault();

      if(authUser?.user_type !== 'D')
        {
          if(objectType==='div'){
            return false;  
          }

          if(viewerName!=='ohif'){
            alert('Permission denied for the user');
            return false;
          }
        }
 
      if(prev_dicomobj!==null){
        //prev_dicomobj.classList.remove("bi-eye-slash");
        //prev_dicomobj.classList.add("bi-eye-fill");
      }

      var dicomobj = document.getElementById("btndicom_"+index.toString());
      if(dicomobj!==null){
        //dicomobj.classList.remove("bi-eye-fill");
        //dicomobj.classList.add("bi-eye-slash");
      }

      if(prev_dicomobj === null || prev_dicomobj !== dicomobj){
        prev_dicomobj = dicomobj;
      }
    
      if(authUser?.user_type !== 'D' && viewerName === 'ohif' && patientData[index].viewer_flag !== 'JPG'){
        openDicomViewer(patientData[index].patient_key, patientData[index].study_key, patientData[index].instance_uid, patientData[index].modality, patientData[index].image_total_count, dicomUrl, viewerName);
      }
      else{
        ChangeStudyStatus('LOCK_DICOM', index, dicomUrl, null, null, viewerName);
      }
    };
    
    const NotificationPending = () => {
      if (pendingCount > 0){
        return <span className="badge notification-badge rounded-pill badge-primary">{pendingCount}</span>;
      }
      else
      {
        return null;
      }
    }

    const NotificationWaiting = () => {
      if (waitingCount > 0){
        return <span className="badge notification-badge rounded-pill badge-notification bg-dark">{waitingCount}</span>;
      }
      else
      {
        return null;
      }
    }
    const NotificationHold = () => {
      if (holdCount > 0){
        return <span className="badge notification-badge rounded-pill badge-notification bg-dark">{holdCount}</span>;
      }
      else
      {
        return null;
      }
    }
    const NotificationDraft = () => {
      if (draftCount > 0){
        return <span className="badge notification-badge rounded-pill badge-notification">{draftCount}</span>;
      }
      else
      {
        return null;
      }
    }
    const NotificationReview = () => {
      if (reviewCount > 0){
        return <span className="badge notification-badge rounded-pill badge-notification bg-warning">{reviewCount}</span>;
      }
      else
      {
        return null;
      }
    }
    const NotificationSignedoff = () => {
      if (signedoffCount > 0){
        return <span className="badge notification-badge rounded-pill badge-notification bg-warning">{signedoffCount}</span>;
      }
      else
      {
        return null;
      }
    }
    const NotificationUrgent = () => {
      if (urgentCount > 0){
        return <span className="badge notification-badge rounded-pill badge-notification bg-danger" title="Count Only Pending Status">{urgentCount}</span>
      }
      else
      {
        return null;
      }
    }

    const EncryptPatientKey = (data) => {
      var CryptoJS = require("crypto-js");
      var ciphertext = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(data));
      return encodeURIComponent(ciphertext);
    }

    return (
        <div className="tele-body">
            
            <main>
              
                    <div className="container-fluid px-4">
                        <div className="row">
                          {/*<div className="col-md-7 mt-2">
                            <h5 className="text-blue font-roboto font-weight700">Study List</h5>
                          </div>
                          */}
                          
                          <div className="col-12 col-lg-7 col-md-7 mt-2">
                            <ul className="nav nav-tabs" id="myTab" role="tablist">
                              <li className="nav-item" role="presentation">
                                <button className="nav-link padd-right-navtab notification active" id="pending-tab" data-bs-toggle="tab" data-bs-target="#pending-tab-pane" type="button" role="tab" aria-controls="pending-tab-pane" aria-selected="true" onClick={event => tabClick('P', 'A') }><small><b>Pending </b></small>
                                {NotificationPending()}
                                </button>
                              </li>
                              {(waitingCount > 0  ? 
                                  <li className="nav-item" role="presentation">
                                    <button className="nav-link padd-right-navtab notification" id="waiting-tab" data-bs-toggle="tab" data-bs-target="#waiting-tab-pane" type="button" role="tab" aria-controls="waiting-tab-pane" aria-selected="false" onClick={event => tabClick('PW', 'A') }><small><b>Waiting </b></small>
                                    {NotificationWaiting()}
                                    </button>
                                  </li>
                                : <span></span>
                              )}
                              
                              {(holdCount > 0  ? 
                                  <li className="nav-item" role="presentation">
                                    <button className="nav-link padd-right-navtab notification" id="hold-tab" data-bs-toggle="tab" data-bs-target="#hold-tab-pane" type="button" role="tab" aria-controls="hold-tab-pane" aria-selected="false" onClick={event => tabClick('PH', 'A') }><small><b>On-Hold </b></small>
                                    {NotificationHold()}
                                    </button>
                                  </li>
                                : <span></span>
                              )}
                              
                              {(draftCount > 0  ? 
                                  <li className="nav-item" role="presentation">
                                    <button className="nav-link padd-right-navtab notification" id="draft-tab" data-bs-toggle="tab" data-bs-target="#draft-tab-pane" type="button" role="tab" aria-controls="draft-tab-pane" aria-selected="false" onClick={event => tabClick('PD', 'A') }><small><b>Draft </b></small>
                                    {NotificationDraft()}
                                    </button>
                                  </li>
                                : <span></span>
                              )}
                              
                              {(reviewCount > 0  ? 
                                  <li className="nav-item" role="presentation">
                                    <button className="nav-link padd-right-navtab notification" id="review-tab" data-bs-toggle="tab" data-bs-target="#review-tab-pane" type="button" role="tab" aria-controls="review-tab-pane" aria-selected="false" onClick={event => tabClick('V', 'A') }><small><b>Review </b></small>
                                    {NotificationReview()}
                                    </button>
                                  </li>
                                : <span></span>
                              )}

                              <li className="nav-item" role="presentation">
                                <button className="nav-link padd-right-navtab notification" id="signedoff-tab" data-bs-toggle="tab" data-bs-target="#signedoff-tab-pane" type="button" role="tab" aria-controls="signedoff-tab-pane" aria-selected="false" onClick={event => tabClick('S', 'A') }><small><b>Signed Off </b></small>
                                {NotificationSignedoff()}
                                </button>
                              </li>
                              <li className="nav-item" role="presentation">
                                <button className="nav-link padd-right-navtab notification" id="printed-tab" data-bs-toggle="tab" data-bs-target="#printed-tab-pane" type="button" role="tab" aria-controls="printed-tab-pane" aria-selected="false" onClick={event => tabClick('F', 'A') }><small><b>Printed </b></small>
                                </button>
                              </li>
                              {(urgentCount > 0 ? 
                                  <li className="nav-item" role="presentation">
                                    <button className="nav-link padd-right-navtab notification" id="urgent-tab" data-bs-toggle="tab" data-bs-target="#urgent-tab-pane" type="button" role="tab" aria-controls="urgent-tab-pane" aria-selected="false" onClick={event => tabClick('A', 'Y') }><small><b>Urgent </b></small>
                                    {NotificationUrgent()}
                                    </button>
                                  </li>
                                : <span></span>
                              )}
                              
                              {(authUser?.user_type === 'A' || authUser?.user_type === 'S' || authUser?.user_type === 'U' ? 
                                  <li className="nav-item" role="presentation">
                                    <button className="nav-link notification" id="deactivated-tab" data-bs-toggle="tab" data-bs-target="#deactivated-tab-pane" type="button" role="tab" aria-controls="deactivated-tab-pane" aria-selected="false" onClick={event => tabClick('X', 'A') }><small><b>Deactivated </b></small>
                                    </button>
                                  </li>
                                : <span></span>
                              )}
                              <li className="nav-item" role="presentation">
                                <button className="nav-link notification" id="all-tab" data-bs-toggle="tab" data-bs-target="#all-tab-pane" type="button" role="tab" aria-controls="all-tab-pane" aria-selected="false" onClick={event => tabClick('A', 'A') }><small><b>All </b></small>
                                </button>
                              </li>
                              <div className="nav-item" id="divLoading"> processing...</div>
                            </ul>
                          </div>

                          <div className="col-md-5">
                            <nav aria-label="Page navigation" className="mt-2">
                            <ul className="pagination pagination-sm justify-content-end">
                              <li>
                                <select className="form-select form-select-sm" id="ddlSelection" name="ddlSelection"
                                      onChange={event => pageClick(1)}>
                                    <option value="today">Today</option>
                                    <option value="yesterday">Yesterday</option>
                                    <option value="last7days">Last 7 Days</option>
                                    <option value="thismonth">This Month</option>
                                    <option value="prevmonth">Previous Month</option>
                                    <option value="last2months">Last 2 Months</option>
                                    <option value="last3months">Last 3 Months</option>
                                    <option value="last4months">Last 4 Months</option>
                                    <option value="last5months">Last 5 Months</option>
                                    <option value="last6months">Last 6 Months</option>
                                </select>
                              </li>
                              <li className="page-item disabled" id="pageFirst">
                                <a className="page-link" href=" #" onClick={event => pageClick(1)}><i className="bi bi-arrow-left" title="First Page"></i></a>
                              </li>
                              <li className="page-item disabled" id="pagePrev">
                                <a className="page-link" href=" #" onClick={event => pagePrev()}><i className="bi bi-caret-left-fill" title="Previous Page"></i></a>
                              </li>
                              <li className="page-item active"><a className="page-link" href=" #" id="lnkpageno1" onClick={event => pageClick(1)}>1</a></li>
                              <li className="page-item"><a className="page-link" href=" #" id="lnkpageno2" onClick={event => pageClick(2)}>2</a></li>
                              <li className="page-item"><a className="page-link" href=" #" id="lnkpageno3" onClick={event => pageClick(3)}>3</a></li>
                              <li className="page-item disabled"><a className="page-link" href=" #" id="lnkpagenomore">...</a></li>
                              <li className="page-item"><a className="page-link" href=" #" id="lnkpagenoLast" onClick={event => pageClick(0)}>4</a></li>
                              <li className="page-item" id="pageNext">
                                <a className="page-link" href=" #" onClick={event => pageNext()}><i className="bi bi-caret-right-fill" title="Next Page"></i></a>
                              </li>
                              <li className="page-item" id="pageLast">
                                <a className="page-link" href=" #" onClick={event => pageClick(0)}><i className="bi bi-arrow-right" title="Last Page"></i></a>
                              </li>
                              <li id="lipage_no_s"><input type="page" className="form-control form-control-sm width60 height30" id="txtpage_no_s" placeholder="1 of 1" /></li>
                              <li id="lipagesearch"><button type="button" className="btn btn-tele btn-sm" id="btnpagesearch" value="0" onClick={event => pageSearch()}><i className="bi bi-arrow-right-square"></i></button></li>
                              <li>
                                {/* Pagination */}
                                <select className="form-select form-select-sm" style={{width:"70px"}} id="ddlpage_size_s" name="sellist1" onChange={event => pageSizeChange(null, true)}>
                                  <option>10</option>
                                  <option>25</option>
                                  <option>50</option>
                                  <option>100</option>{/**/}
                                </select>
                              </li>
                            </ul>
                          </nav>
                          </div>
                          
                        </div>

                        <hr className="mt-0" />

                        <div className="row">
                            <div className="col-md-12 mb-2">
                                <div className="card">
                                    <div className="card-header bg-gradient-1 text-light">
                                      {/* Table Heading */}
                                      <div className="row">
                                        <div className="col-3 col-sm-1 col-md-1">
                                          <p className="tele-table-heading"><i className="bi bi-arrow-up" onClick={event => sortClick(event, 'patient_id') }></i> Id </p>
                                          <input type="text" className="form-control form-control-sm tele-table-searcharea" id="patient_id" onChange={handleSearchChange} placeholder="" />
                                        </div>
                                        <div className="col-5 col-sm-2 col-md-2">
                                          <p className="tele-table-heading"><i className="bi bi-arrow-down icon-muted" onClick={event => sortClick(event, 'patient_name') }></i>Patient </p>
                                          <input type="text" className="form-control form-control-sm tele-table-searcharea" id="patient_name" onChange={handleSearchChange} placeholder="" />
                                        </div>
                                        <div className="col-4 col-sm-2 col-md-2">
                                          <p className="tele-table-heading"><i className="bi bi-arrow-up icon-muted" onClick={event => sortClick(event, 'regn_date') }></i>Date/History </p>
                                          <input type="date" className="form-control form-control-sm tele-table-searcharea" id="regn_date" onChange={handleSearchChange} />
                                        </div>
                                        <div className="col-4 col-sm-2 col-md-2 d-none d-sm-block" >
                                          <p className="tele-table-heading"><i className="bi bi-arrow-down icon-muted" onClick={event => sortClick(event, 'modality') }></i>Study </p>
                                          <input style={{display:"none"}} type="text" className="form-control form-control-sm tele-table-searcharea" id="txtmodality" onChange={handleSearchChange} placeholder="" />
                                          <select style={{lineHeight:"1.2"}} className="form-select-sm form-control form-control-sm tele-table-searcharea" id="modality" name="modality" onChange={handleSearchChange}>
                                                        <option value="">ALL</option>
                                                        <option value="DX">X-Ray</option>
                                                        <option value="MG">MG</option>
                                                        <option value="CT">CT</option>
                                                        <option value="ECG">ECG</option>
                                                        <option value="CHEST">CHEST</option>
                                                        <option value="SPINE">SPINE</option>
                                                        <option value="KNEE">KNEE</option>
                                                        <option value="HEEL">HEEL</option>
                                                        <option value="FOOT">FOOT</option>
                                                        <option value="HAND">HAND</option>
                                                        <option value="WRIST">WRIST</option>
                                                        <option value="SHOULDER">SHOULDER</option>
                                                    </select>
                                        </div>
                                        <div className="col-sm-1 col-md-1 d-none d-md-none d-lg-none">
                                          <p className="tele-table-heading"><i className="bi bi-arrow-down icon-muted" onClick={event => sortClick(event, 'refer_physician') }></i>Referral </p>
                                          <input type="text" className="form-control form-control-sm tele-table-searcharea" id="refer_physician" onChange={handleSearchChange} placeholder="" />
                                        </div>
                                        <div className="col-sm-1 col-md-1 d-none d-sm-block">
                                          <p className="tele-table-heading"><i className="bi bi-arrow-down icon-muted" onClick={event => sortClick(event, 'report_status_desc') }></i>Status </p>
                                          <input type="text" className="form-control form-control-sm tele-table-searcharea" id="report_status_desc" onChange={handleSearchChange} placeholder="" />
                                        </div>
 
                                        {(authUser?.user_type === 'A' || authUser?.user_type === 'S' || authUser?.user_key === 11 || authUser?.user_key === 78 || authUser?.user_key === 85 || authUser?.user_key === 125 ?
                                          <div className="col-3 col-sm-center col-md-center d-none d-sm-block">
                                            <p className="tele-table-heading"><i className="bi bi-arrow-down icon-muted" onClick={event => sortClick(event, 'center_id') }></i> Center </p>
                                            <input type="text" className="form-control form-control-sm tele-table-searcharea" id="center_id" onChange={handleSearchChange} placeholder="" />
                                          </div>
                                        :
                                          <div className="col-sm-1 col-md-1 d-none d-md-none d-lg-none">
                                            <p className="tele-table-heading"><i className="bi bi-arrow-down icon-muted" onClick={event => sortClick(event, 'center_name') }></i>Center Name </p>
                                            <input type="text" className="form-control form-control-sm tele-table-searcharea" id="center_name" onChange={handleSearchChange} placeholder="" />
                                          </div>
                                        )}

                                        <div className="col-sm-2 col-md-2 d-none d-sm-block"><p className="tele-table-heading">Process</p></div>

                                        <div className="col-sm-1 col-md-1 d-none d-md-none d-lg-none d-sm-block"><p className="tele-table-heading">Report</p></div>
                                        <div className="col-sm-2 col-md-2 d-none d-sm-block"><p className="tele-table-heading">Action</p></div>
                                      </div>
                                    </div>
                                    <div className="card-body tele-table-padding studylist-area">
                                        {/* tele-table-rowbg1 */}
                                        <div className="row studylist" id="divStatusResult">
                                        </div>

                                        {Object.keys(patientData).map((data, i) => (
                                          <div key={i} className="row studylist" onDoubleClick={event => viewDicom(event, patientData[i].dicom_path, i, 'div', '')}>
                                          
                                          <div className="col-3 col-sm-1 col-md-1"><p className="tele-table-text float-left">{patientData[i].patient_id}</p></div>
                                          
                                          <div className="col-5 col-sm-2 col-md-2">
                                            <p className="tele-table-text">
                                              {(patientData[i].priority === 'Y' && (search_priority !== 'Y' || patientData[i].report_status === 'P') ? 
                                                  <font color='#e51b48'>{patientData[i].patient_name}<br/></font>
                                                : <div>{patientData[i].patient_name}</div>
                                              )}
                                            <span>{patientData[i].patient_id_ref}, ({patientData[i].patient_sex}), {patientData[i].patient_age}{patientData[i].patient_age_unit}</span></p>
                                          </div>

                                          <div className="col-4 col-sm-2 col-md-2">
                                            <p className="tele-table-text">{patientData[i].regn_date} &nbsp;
                                            <span>{patientData[i].regn_time}</span> <br/>
                                            <span title={patientData[i].remarks}>{patientData[i].remarks.substring(0, 20)}</span>
                                            </p>
                                          </div>

                                          <div className="col-8 col-sm-2 col-md-2">
                                            <p className="tele-table-text">{patientData[i].modality} - {patientData[i].study_description} <br/>
                                            <span>
                                              {patientData[i].body_part}, {patientData[i].fileupload_status}
                                            </span></p>
                                          </div>
                                          <div className="col-sm-1 col-md-1 d-none d-md-none d-lg-none"><p className="tele-table-text">Hospital</p></div>
                                          <div className="col-4 col-sm-1 col-md-1"><p className="tele-table-text">
                                              {(patientData[i].priority === 'Y' && (search_priority !== 'Y' || patientData[i].report_status === 'P') ? 
                                                  <div><font color='#e51b48'>{patientData[i].report_status_desc}</font></div>
                                                : <div>{patientData[i].report_status_desc}</div>
                                              )}
                                            </p>
                                          </div>

                                          {(authUser?.user_type === 'A' || authUser?.user_type === 'S' || authUser?.user_key === 11 || authUser?.user_key === 78 || authUser?.user_key === 85 || authUser?.user_key === 125 ?
                                              <div className="col-3 col-sm-center col-md-center d-none d-sm-block">
                                                <p className="tele-table-text float-left">
                                                  {(authUser?.user_type === 'A' || authUser?.user_type === 'S' ?
                                                    <div>
                                                      <div title={patientData[i].center_name}>{patientData[i].center_id}</div>
                                                      <span title={patientData[i].doctor_name}>{patientData[i].doctor_id}</span>
                                                    </div>
                                                    :
                                                    <div>{patientData[i].center_id}</div>
                                                  )}
                                                  
                                                </p>
                                              </div>
                                            :
                                              <div className="col-sm-2 col-md-2 d-none d-md-none d-lg-none"><p className="tele-table-text">Center</p></div>
                                          )}
                                          
                                          <div className="col-8 col-sm-2 col-md-2">
                                            
                                            {(patientData[i].attach_file_count > 0 ? 
                                                  <span className="badge badge-notification1">{patientData[i].attach_file_count}</span>
                                                : <span></span>
                                            )}
                                            <button type="button" className="btn btn-outline-warning btn-sm bi bi-pencil-fill" title="Edit Study" onClick={event => openEditStudy(event, 'OPEN', i)}>
                                            </button>

                                            {(patientData[i].notes !== '' ? 
                                                  (patientData[i].updated_by === authUser?.user_key ? 
                                                    <button type="button" className="btn btn-outline-warning btn-sm bi bi-bookmarks-fill m-1" title={patientData[i].notes} onClick={event => openNotes(event, 'OPEN', i)}>
                                                    </button>
                                                  : 
                                                    <button type="button" className="btn btn-warning btn-sm bi bi-bookmarks-fill m-1" title={patientData[i].notes} onClick={event => openNotes(event, 'OPEN', i)}>
                                                    </button>
                                                  )
                                                : 
                                                <button type="button" className="btn btn-outline-warning btn-sm bi bi-bookmarks m-1" title="Empty notes" onClick={event => openNotes(event, 'OPEN', i)}>
                                                </button>
                                            )}
                                            
                                            
                                            {(authUser?.user_type === 'D' || authUser?.user_type === 'R'
                                              || (
                                                  (     patientData[i].report_status === 'S' || patientData[i].report_status === 'V'
                                                     || patientData[i].report_status === 'F' || patientData[i].report_status === 'P'
                                                  ) 
                                                    && ( authUser?.user_type === 'A' || authUser?.user_type === 'S' || authUser?.user_type === 'V'
                                                      || authUser?.user_key > 96 
                                                      || authUser?.user_key === 1 || authUser?.user_key === 26 || authUser?.user_key === 25
                                                      || authUser?.user_key === 41 || authUser?.user_key === 39 || authUser?.user_key === 52
                                                      || authUser?.user_key === 48 || authUser?.user_key === 82 || authUser?.user_key === 87 || authUser?.user_key === 89 
                                                      || authUser?.user_key === 94 || authUser?.user_key === 17 || authUser?.user_key === 18 
                                                      || authUser?.user_key === 21 || authUser?.user_key === 83 || authUser?.user_key === 22
                                                      )
                                                 ) ? 
                                                  <button type="button" className="btn btn-outline-warning btn-sm bi bi-check-square"  title="Submit Report" onClick={event => openSubmitReport(event, 'OPEN', i, '')}></button>
                                                : <span></span>
                                            )}

                                            {(authUser?.user_type === 'D' || authUser?.user_type === 'R' ? 
                                                  <span style={{display:"none"}}></span>
                                                : 
                                                (patientData[i].report_status === 'P' || patientData[i].report_status === 'X' ? 
                                                  
                                                  <button type="button" className="btn btn-outline-warning btn-sm bi bi-printer m-1" title="Report not yet ready" onClick={event => printReport(event, 'OPEN', i, 'PRINT', '')}></button>
                                                  
                                                : 
                                                  (authUser?.user_key === 1 || authUser?.user_key === 26 || authUser?.user_key === 41 || authUser?.user_key === 39 || authUser?.user_key === 83 || authUser?.user_key === 22 ? 
                                                    <span>
                                                      <button type="button" className="btn btn-outline-warning btn-sm bi bi-printer-fill m-1" title="Print Report" onClick={event => printReport(event, 'OPEN', i, 'PRINT', '')}></button>
                                                    </span>
                                                  : 
                                                  <button type="button" className="btn btn-outline-warning btn-sm bi bi-printer-fill m-1" title="Print Report" onClick={event => printReport(event, 'OPEN', i, 'PRINT', '')}></button>
                                                  )
                                                )
                                            )}

                                            {(authUser?.user_type === 'A' || authUser?.user_type === 'S' || authUser?.user_type === 'D' || authUser?.user_type === 'R' ? 
                                                  <button id={`btnCopyClip_${patientData[i].patient_key.toString()}`} type="button" className="btn btn-outline-warning btn-sm bi bi-clipboard" title="Copy to clipboard" onClick={event => copyClipboard(event, i, patientData[i].patient_key)}></button>
                                                : 
                                                <span style={{display:"none"}}></span>
                                            )}

                                            {(patientData[i].modality === 'CT' || patientData[i].modality === 'MR' || patientData[i].modality === 'ECG' 
                                            || patientData[i].center_key > 72 
                                            || patientData[i].center_key === 14 
                                            || patientData[i].center_key === 68 || patientData[i].center_key === 61 
                                            || patientData[i].center_key === 59 || patientData[i].center_key === 54
                                            || patientData[i].center_key === 33 || patientData[i].center_key === 66 
                                            || patientData[i].center_key === 39 || patientData[i].center_key === 58 ? 
                                                  <div id={`qrCode_${patientData[i].patient_key.toString()}`} style={{ height: "auto", margin: "0 auto", maxWidth: 64, width: "100%", display: "none" }}>
                                                    <QRCode
                                                    size={256}
                                                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                                    value={`https://tele.mytsofts.com/qrcodereport?data=${EncryptPatientKey(patientData[i].center_key.toString() + '~' + patientData[i].patient_key.toString())}`}
                                                    viewBox={`0 0 256 256`}
                                                    />
                                                </div>
                                                : <span></span>
                                            )}

                                          </div>
                                          
                                          <div className="col-sm-1 col-md-1 d-none d-md-none d-lg-none"><p className="tele-table-text">Report 1</p></div>
                                          <div className="col-4 col-sm-2 col-md-2">
                                            {((authUser?.user_type === 'D' || authUser?.user_type === 'R') && patientData[i].modality !== 'MR'? 
                                              <button type="button" className="btn btn-outline-warning btn-sm2 bi bi-eye-fill" title={`View ${patientData[i].viewer_flag === 'JPG' ? "JPG Image" : "DICOM"}`} id={"btndicom_"+i.toString()} onClick={event => viewDicom(event, patientData[i].dicom_path, i, 'button', '')}></button>
                                              : <span style={{display:"none"}}></span>
                                            )}
                                            
                                            {(((patientData[i].modality !== 'CT') 
                                              && (authUser?.user_type === 'A' || authUser?.user_type === 'S' || authUser?.user_type === 'D' || authUser?.user_type === 'R'
                                                || authUser?.user_key === 100 || authUser?.user_key === 17 
                                                || authUser?.user_key === 94  || authUser?.user_key === 122 )
                                              ) ? 
                                                  (patientData[i].viewer_flag === 'JPG' ? 
                                                    <button type="button" className="btn btn-outline-warning btn-sm2 bi bi-display m-1" title="View JPG Image" id={"btndicomOHIF_"+i.toString()} onClick={event => openSubmitReport(event, 'OPEN', i, '')}></button>
                                                  : <button type="button" className="btn btn-outline-warning btn-sm2 bi bi-display m-1" title="OHIF DICOM Viewer" id={"btndicomOHIF_"+i.toString()} onClick={event => viewDicom(event, patientData[i].dicom_path, i, 'button', 'ohif')}></button>
                                                  )
                                                  
                                                : <span style={{display:"none"}}></span>
                                            )}
                                            
                                            {((authUser?.user_type === 'A' || authUser?.user_type === 'S') && patientData[i].report_status === 'P' && patientData[i].report_content === '' ? 
                                                  <button type="button" className="btn btn-outline-warning btn-sm2 bi bi-person-check" title="Assign Doctor" onClick={event => openAssignDoctor(event, 'OPEN', i)}></button>
                                                : <span>
                                                  {(patientData[i].report_status === 'F'? 
                                                        <button type="button" className="btn btn-outline-warning btn-sm2 bi bi-arrow-counterclockwise" title="Rework study" onClick={event => openReworkStudy(event, 'OPEN', i)}></button>
                                                      : 
                                                        (patientData[i].report_status === 'S'? 
                                                              <button type="button" className="btn btn-outline-warning btn-sm2 bi bi-lock-fill"  title="Unlock study" onClick={event => openUnlockStudy(event, 'OPEN', i)}></button>
                                                            : 
                                                              <span></span>
                                                        )
                                                  )}
                                                </span>
                                            )}

                                            {/*
                                            {<button type="button" className="btn btn-outline-warning btn-sm bi bi-cloud-arrow-down-fill m-1" title="Download zip" onClick={event => openModalSuccess(event, 'OPEN')}></button>
                                            */}
                                            
                                            {(authUser?.user_type === 'D' || authUser?.user_type === 'R' || authUser?.user_type === 'A' || authUser?.user_type === 'S' || authUser?.user_type === 'V' || patientData[i].report_status === 'P' ? 
                                                  <button id={`btnActivityLog_${patientData[i].patient_key.toString()}`} type="button" className="btn btn-outline-warning btn-sm2 bi bi-activity m-1" style={{ display: "inline" }} title="Activity Log" onClick={event => openActivityLog(event, 'OPEN', i, null)}></button>
                                                : <span></span>
                                            )}

                                            
                                            {(authUser?.user_type === 'S' || authUser?.user_type === 'A' ? 
                                                  <button id={`btnCopyStudy_${patientData[i].patient_key.toString()}`} type="button" className="btn btn-outline-warning btn-sm2 bi bi-file-break" title="Copy study" onClick={event => ChangeStudyStatus('COPY_STUDY', i, null, patientData[i].center_key, patientData[i].patient_key, '')}></button>
                                                : <span></span>
                                            )}

                                            {(authUser?.user_type === 'A' || authUser?.user_type === 'S' || authUser?.user_type === 'D' || authUser?.user_type === 'R' ? 
                                                  <span style={{display:"none"}}></span>
                                                : 
                                                <button id={`btnCopyClip_${patientData[i].patient_key.toString()}`} type="button" className="btn btn-outline-warning btn-sm2 bi bi-clipboard m-1" title="Copy to clipboard" onClick={event => copyClipboard(event, i, patientData[i].patient_key)}></button>
                                            )}
                                          
                                            {(authUser?.user_type === 'D' || authUser?.user_type === 'R' || authUser?.user_type === 'A' || authUser?.user_type === 'S' ? 
                                                  <span style={{display:"none"}}></span>
                                                : 
                                                (authUser?.user_key === 1 || authUser?.user_key === 26 || authUser?.user_key === 41 || authUser?.user_key === 39 || authUser?.user_key === 83 
                                                    || authUser?.user_key === 22 ? 
                                                  <button type="button" className="btn btn-outline-warning btn-sm2 bi bi-wordpress" title="Export Report to RTF" onClick={event => printReport(event, 'OPEN', i, 'RTF', '')}></button>
                                                : 
                                                  <span style={{display:"none"}}></span>
                                                )
                                            )}

                                            {(authUser?.user_type === 'D' || authUser?.user_type === 'R' ? 
                                                  <span style={{display:"none"}}></span>
                                                : 
                                                (authUser?.allow_flag_export === "Y"? 
                                                  <button type="button" className="btn btn-outline-warning btn-sm2 bi bi-file-earmark-word" title="Export Report to DOCX" onClick={event => printReport(event, 'OPEN', i, 'DOCX', '')}></button>
                                                : 
                                                  <span style={{display:"none"}}></span>
                                                )
                                            )}

                                          </div>
                                          </div>
                                          
                                        ))}
                                        
                                        
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </main>
        
        
        {/*<!-- Custom Modal -->*/}
        <div id="modal" className="modal closed" style={{zIndex:"21055"}}> 

            {/*<!-- Modal content -->*/}
            <div className="editstudy-modal-content">
                <div className="modal-header pt-2">
                    <span className="close" id="close-button" onClick={event => openEditStudy(event, 'CLOSE', null)}>&times;</span>
                    <h6 className="mb-0" style={{marginTop: "0.3em"}}><i className="bi bi-person-circle"></i> Patient Details: <span id="spnedit_patient" style={{fontSize: "12px"}}></span></h6>
                </div>
                <div className="modal-body">
                  {/*<!-- justify-content-center -->*/}
                    <div className="row ">
                        <div className="col-lg-2 col-6 pe-1">
                            <div className="input-group input-group-sm mt-2">
                                <div className="input-group-prepend"><span className="input-group-text input-sm">
                                        <small>ID</small></span></div> <input type="text" placeholder="Patient ID"
                                    required="required" className="form-control"
                                    id="txtp_id" readOnly />
                                    <input type="hidden" id="hidc_key" />
                                    <input type="hidden" id="hidp_key" />
                            </div>
                        </div>
                        <div className="col-lg-4 col-6 ps-1 pe-1">
                            <div className="input-group input-group-sm mt-2">
                                <div className="input-group-prepend"><span className="input-group-text input-sm">
                                        <small>Name</small></span></div> <input type="text" placeholder="Name"
                                    required="required" className="form-control"
                                    id="txtp_name" />
                            </div>
                        </div>
                        <div className="col-lg-3 col-12 ps-1 pe-1">
                            <div className="input-group input-group-sm mt-2">
                                <div className="input-group-prepend"><span className="input-group-text input-sm">
                                        <small>Age</small></span></div> <input type="text" placeholder="Age"
                                    required="required" className="form-control"
                                    id="txtage" />
                                    <select
                                      className="form-select form-select-sm"
                                      aria-label=".form-select-sm example"
                                      name="patient_age_unit"
                                      id="ddlage_unit"
                                    >
                                      <option value="Y">Years</option>
                                      <option value="M">Months</option>
                                      <option value="D">Days</option>
                                    </select>
                            </div>
                        </div>
                        <div className="col-lg-3 col-12 ps-1 pe-1">
                            <div className="input-group input-group-sm mt-2">
                                <div className="input-group-prepend"><span className="input-group-text input-sm">
                                        <small>Gender</small></span></div> <input type="text" placeholder="Gender"
                                    required="required" className="form-control"
                                    id="txtgender" />
                            </div>
                        </div>

                        <div className="col-lg-6 col-12 ps-1 pe-1">
                            <div className="input-group input-group-sm mt-2">
                                <div className="input-group-prepend"><span className="input-group-text input-sm">
                                        <small>Reference ID:</small></span></div> <input type="text" placeholder="Reference ID"
                                    required="required" className="form-control"
                                    id="txtp_id_ref" />
                            </div>
                        </div>

                        <div className="col-lg-1 col-12 ps-1 pe-1">
                            <div className="input-group input-group-sm mt-2">
                                <div className="input-group-prepend">
                                  <span className="input-group-text input-sm">
                                    <small>Urgent &nbsp;</small>
                                    <input type="checkbox" placeholder="Urgent" title="Priority" id="chkurgent" />
                                    
                                    &nbsp;&nbsp;&nbsp;
                                    <small>&nbsp;Case Type &nbsp;</small>
                                    <select style={{width:"144px"}}
                                      className="form-select form-select-sm"
                                      aria-label=".form-select-sm example"
                                      name="case_type"
                                      id="ddlcase_type"
                                    >
                                      <option value="NEW">New Case</option>
                                      <option value="FUP">Follow-up</option>
                                      <option value="POP">Post-operative</option>
                                      <option value="SCR">Screening</option>
                                      <option value="REF">Referral</option>
                                    </select>

                                    &nbsp;&nbsp;
                                    <small id="lblRBG">&nbsp;Report Background &nbsp;</small>
                                    <input type="checkbox" placeholder="ReportBackground" title="Report Background" id="chkreport_background" />
                                  </span>
                                </div> 
                            </div>
                        </div>

                        <div className="col-lg-6 col-12 ps-1 pe-1">
                            <div className="input-group input-group-sm mt-2">
                                <div className="input-group-prepend"><span className="input-group-text input-sm">
                                        <small>Study Name:</small></span></div> <input type="text" placeholder="Study Name"
                                    required="required" className="form-control"
                                    id="txtstudyname" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-12 ps-1 pe-1">
                            <div className="input-group input-group-sm mt-2">
                                <div className="input-group-prepend"><span className="input-group-text input-sm">
                                        <small>Referring Physician Name:</small></span></div> <input type="text" placeholder="Physician"
                                    required="required" className="form-control"
                                    id="txtphysician_name" />
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center pb-3">
                        <div className="col-lg-12 col-12 ps-1 pe-1">
                            <div className="form-group mt-2">
                                <label className="font-size14">Add History:</label>
                                <textarea className="form-control font-size14" rows="4" id="txthistory"></textarea>
                            </div>
                        </div>
                    </div>
                    
                    <div className="row justify-content-center pb-1">
                      <div className="col-lg-12 col-md-12 mb-2">
                        
                          <div>
                            Upload History Images:
                            <input type="hidden" id="hidattachcount"></input>
                            <input type="hidden" id="hidattachjson"></input>
                          </div>
                            
                              
                              <div className="col-12 report-bg">
                                <div className="row mt-3">
                                  <div className="col-1">
                                    <a href=" #" title="prev">
                                      <div style={divStyle1}>
                                        <i className="bi bi-caret-left-fill"></i>
                                      </div>
                                    </a>
                                  </div>
                                  <div className="col-10" style={divStyle2}>
                                    <output className="row" id="attachFileResult"></output>
                                  </div>
                                  <div className="col-1">
                                    <a href=" #" title="next">
                                      <div style={divStyle3}>
                                        <i className="bi bi-caret-right-fill"></i>
                                      </div>
                                    </a>
                                  </div>
                                </div>
                              </div>
                        
                      </div>
                    </div>
                    <div className="row justify-content-center pb-0">
                        <div className="col-4 text-left pl-2">
                          <label htmlFor="historyFiles">
                            <small>Select files </small>
                          </label>
                          <input id="historyFiles" className="form-control-sm"
                                  type="file" multiple="multiple"
                                  onChange={handleChangeUploadFile} />
                        </div>
                        <div className="col-lg-4 col-4"><button type="button"
                                className="btn btn-secondary btn-sm btn-block bi bi-save2-fill" id="btnEditSave" onClick={event => openEditStudy(event, 'SAVE')}> SAVE</button></div>
                        <div className="col-lg-3 col-4"><button type="button"
                                className="btn btn-secondary btn-sm btn-block bi bi-x-square" id="btnEditClose" onClick={event => openEditStudy(event, 'CLOSE')}> CLOSE</button></div>
                    </div>
                </div>
            </div>
        </div>
        {/*<!--End of Custom Modal -->*/}

        <div id="modalShowPatient" className="modal closed" style={{zIndex:"91055"}}> 

            {/*<!-- Modal content -->*/}
            <div className="viewstudy-modal-content">
                <div className="modal-header pt-2">
                    <span className="close" id="close-button" onClick={event => openViewStudy(event, 'CLOSE', null)}>&times;</span>
                    <h6 className="mb-0" style={{marginTop: "0.3em"}}><i className="bi bi-person-circle"></i> Patient Details: <span id="spnview_patient" style={{fontSize: "12px"}}></span></h6>
                </div>
                <div className="modal-body">
                  
                    <div className="row justify-content-start">
                        <div className="col-lg-6 col-12 ps-1 pe-1">
                            <div className="form-group">
                                <label className="font-size14">Patient:</label>
                                
                                <div className="input-group-prepend"><span className="input-group-text input-sm">
                                        <small id="lblpatient_v"></small></span></div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-12 ps-1 pe-1">
                            <div className="form-group">
                                <label className="font-size14"></label>
                                <div className="input-group-prepend"><span className="input-group-text input-sm">
                                        <small id="lblurgent_v"></small></span></div>
                            </div>
                        </div>
                    </div>

                    <div className="row justify-content-start">
                        <div className="col-lg-6 col-12 ps-1 pe-1">
                            <div className="form-group">
                                <label className="font-size14">Study:</label>
                                <div className="input-group-prepend"><span className="input-group-text input-sm">
                                        <small id="lblstudy_v" style={{maxHeight:"170px", height:"170px", textAlign:"left", overflow:"auto"}}></small></span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-12 ps-1 pe-1">
                            <div className="form-group">
                                <label className="font-size14">History:</label>
                                <div className="input-group-prepend"><span className="input-group-text input-sm">
                                        <small id="lblhistory_v" style={{maxHeight:"170px", height:"170px", textAlign:"left", overflow:"auto"}}></small></span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row justify-content-center pb-1">
                      <div className="col-lg-12 col-md-12">
                          <div>
                            History Images:
                          </div>
                              
                              <div className="col-12 report-bg">
                                <div className="row">
                                  <div className="col-1">
                                    <a href=" #" title="prev">
                                      <div style={divStyle1}>
                                        <i className="bi bi-caret-left-fill"></i>
                                      </div>
                                    </a>
                                  </div>
                                  <div className="col-10" style={divStyle2}>
                                    <output className="row" id="attachFileResult_v"></output>
                                  </div>
                                  <div className="col-1">
                                    <a href=" #" title="next">
                                      <div style={divStyle3}>
                                        <i className="bi bi-caret-right-fill"></i>
                                      </div>
                                    </a>
                                  </div>
                                </div>
                              </div>
                        
                      </div>
                    </div>
                    <div className="row justify-content-center pb-0">
                       
                        <div className="col-lg-3 col-4"><button type="button"
                                className="btn btn-secondary btn-sm btn-block bi bi-x-square" id="btnEditClose" onClick={event => openViewStudy(event, 'CLOSE')}> CLOSE</button></div>
                    </div>
                </div>
            </div>
        </div>

        {/*<!-- Assign Doctor Custom Modal -->*/}
        <div id="modalAssignDoctor" className="modal closed">

          {/*<!-- Modal content -->*/}
          <div className="assigdoctor-modal-content">
              <div className="modal-header pt-2">
                  <span className="close" id="close-button" onClick={event => openAssignDoctor(event, 'CLOSE', null)}>&times;</span>
                  <h6 className="mb-0" style={{marginTop: "0.3em"}}><i className="bi bi-person-circle"></i> Patient Details: <span id="spnassign_doctor" style={{fontSize: "12px"}}></span></h6>
                  <input type="hidden" id="hidc_key_assigndr" />
                  <input type="hidden" id="hidp_key_assigndr" />
                  <input type="hidden" id="hiddoctor_key" />
                  <input type="hidden" id="hidpriority_level" />
              </div>
              <div className="modal-body" style={{overflowX:"hidden", overflowY:"auto", minHeight:0}}>
                  <div className="row justify-content-center">
                      <div className="col-lg-12 col-12 ps-1 pe-1">
                          <div className="priority-row">
                              <span className="font-size14">Study Priority Level: </span>
                              <span className={`priority-opt ${studyPriorityLevel === 0 ? "active" : ""}`} data-priority="None" onClick={event => selectStudyNoneLowHigh(event, 0)}>None</span>
                              <span className={`priority-opt ${studyPriorityLevel === 1 ? "active" : ""}`} data-priority="Low" onClick={event => selectStudyNoneLowHigh(event, 1)}>Low</span>
                              <span className={`priority-opt ${studyPriorityLevel === 2 ? "active" : ""}`} data-priority="High" onClick={event => selectStudyNoneLowHigh(event, 2)}>High</span>
                          </div>
                      </div>
                  </div>
                  <div className="row justify-content-center">
                      <div className="col-lg-12 col-12 ps-1 pe-1">
                          <div id="divassign_doctor_notes" className="form-group" style={{display:"none"}}>
                              <span className="font-size14">Notes: </span>
                              <span id="assign_doctor_notes"></span>
                          </div>
                          <div className="form-group" style={{display:"none"}}>
                              <span className="font-size14">Search Radiologists</span>
                              <input className="form-control font-size14" id="txtassign_doctor_search"></input>
                          </div>
                      </div>
                  </div>

                  <div className="row justify-content-center pb-3" >
      
                    {doctorListData.map((doctor) => (
                      <div key={doctor.doctor_key} className={`doctor-row${doctor.doctor_key === assignDoctorKey ? " selected" : ""} ${doctor.assign_dr_allow === "N" ? " disabled" : ""}`} onClick={event => selectAssignDoctor(event, doctor.doctor_key, doctor.assign_dr_allow)}>
                        <div className="doctor-name">
                              <span className="check-icon">
                                <svg viewBox="0 0 16 16" fill="none">
                                  <path d="M3 8l3.5 3.5L13 5" stroke="#9c9c9c" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                              </span>
                              <span>{doctor.doctor_name}</span>
                        </div>
                        <div className="row-meta">
                          <span className="status">{doctor.doctor_remarks}</span>
                          <span className="last">{doctor.doctor_status}</span>
                        </div>
                      </div>
                    ))}
                  </div>
              </div>

              <div className="modal-footer pt-2">
                <div className="row justify-content-center pb-0">
                    <div className="col-lg-4 col-6"><button type="button"
                            className="btn btn-secondary btn-sm btn-block bi bi-save2-fill" id="btnAssignDrSave" onClick={event => openAssignDoctor(event, 'SAVE')}> ASSIGN </button></div>
                    <div className="col-lg-4 col-6"><button type="button"
                            className="btn btn-secondary btn-sm btn-block bi bi-x-square" id="btnAssignDrClose" onClick={event => openAssignDoctor(event, 'CLOSE')}> CANCEL </button></div>
                </div>
              </div>
          </div>
        </div>
        {/*<!--End of  Assign Doctor Custom Modal -->*/}

        <div id="openSubmitReport" className="modal closed">

            {/*<!--Modal content -->*/}
            <div className="report-modal-content">
                <div className="modal-header pt-0">
                    <span className="close" onClick={event => openSubmitReport(event, 'CLOSE', null, '')}>&times;</span>
                    <h6 className="mb-0" style={{marginTop: "0.3em"}}><i className="bi bi-clipboard-check-fill"></i> Submit Report: <span id="spnsubmit_patient" style={{fontSize: "12px"}}></span>
                    <input type="hidden" id="hidc_key_submit" />
                    <input type="hidden" id="hidp_key_submit" />
                    </h6>
                </div>
                <div className="modal-body" style={{paddingTop:"0rem", paddingBottom:"0rem" }}>
                  <div className="row">

                      <div className="icol-1 icol-s-12" id="thumnailarea">
                        <div className="border-rounded-crimson image-thumnail-container">
                            {/*<div className="left-textarea border-radius-5 thumbnail_heading">
                              <p className="text-off-white">X-Ray</p>
                            </div>*/}
                            <div className="thumbnails">
                              <button className="btn-jpg btn-blue tooltip-jpg" onClick={event => showTabArea(event, 'T3')}><i className="bi bi-card-image"></i>
                                Show/hide<span className="tooltiptext-jpg">Show/hide Image</span>
                              </button>
                              {Object.keys(patientFilesData).map((data, i) => ( 
                                <img key={i} src={patientFilesData[i].file_name} alt="" title={patientFilesData[i].study_description} onClick={event => showImage(event, i)}></img>
                              ))}
                            </div>
                  
                            {/* Thumbnails for Mobile */}
                            <div className="thumbnails_mob">
                              
                              <button className="btn-jpg btn-blue tooltip-jpg" onClick={event => showTabArea(event, 'T3')}><i className="bi bi-card-image"></i>
                                <span className="tooltiptext-jpg">Show/hide Image</span>
                              </button>
                              {Object.keys(patientFilesData).map((data, i) => ( 
                                <img key={i} src={patientFilesData[i].file_name} alt="" title={patientFilesData[i].study_description} onClick={event => showImage(event, i)}></img>
                              ))}
                            </div>
                            
                        </div>
                      </div>
    
                      <div className="icol-11 icol-s-12" id="imgarea">
                          <div  style={{display:"none"}} className="header menu_dektop">
                            <div className="row">
                                <div className="icol-10 col-s-12 border-right">
                                    <div className="text-center">
                                        <button type="button" id="btnWindowLevel" className="btn-jpg btn-blue tooltip-jpg btn-selected" onClick={event => windowlevelJPG(event)}><i className="bi bi-circle-half"></i>
                                            <span className="tooltiptext-jpg">Window Level</span>
                                        </button>
                                        <button type="button" id="btnZoom" className="btn-jpg btn-blue tooltip-jpg" onClick={event => zoomJPG(event)}><i className="bi bi-search"></i>
                                            <span className="tooltiptext-jpg">Zoom</span>
                                        </button>
                                        <button type="button" id="btnPan" className="btn-jpg btn-blue tooltip-jpg" onClick={event => panJPG(event)}><i className="bi bi-arrows-move"></i>
                                            <span className="tooltiptext-jpg">Pan</span>
                                        </button>

                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => zoomIn(event)}><i className="bi bi-zoom-in"></i>
                                            <span className="tooltiptext-jpg">Zoom In</span>
                                        </button>
                                        {/* 
                                        <div className="dropdown-jpg" tabindex="1">
                                            <i className="db2-jpg" tabindex="1"></i>
                                            <a href="#" className="dropbtn-jpg"><i className="bi bi-caret-down-fill"></i></a>
                                            <div className="dropdown-content-jpg">
                                                <a href="#">Soft Tissue</a>
                                                <a href="#">Lung</a>
                                                <a href="#">Liver</a>
                                                <a href="#">Bone</a>
                                                <a href="#">Brain</a>
                                            </div>
                                        </div>
                                        */}
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => zoomOut(event)}><i className="bi bi-zoom-out"></i>
                                            <span className="tooltiptext-jpg">Zoom Out</span>
                                        </button>
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => rotate(event)}><i className="bi bi-arrow-clockwise"></i>
                                            <span className="tooltiptext-jpg">Rotate</span>
                                        </button>
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => flip(event)}><i className="bi bi-phone-flip"></i>
                                            <span className="tooltiptext-jpg">Flip</span>
                                        </button>
                                        {/*
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => pan(event, "left")}><i className="bi bi-arrow-bar-left"></i>
                                            <span className="tooltiptext-jpg">Pan Left</span>
                                        </button>
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => pan(event, "right")}><i className="bi bi-arrow-bar-right"></i>
                                            <span className="tooltiptext-jpg">Pan Right</span>
                                        </button>
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => pan(event, "up")}><i className="bi bi-arrow-bar-up"></i>
                                            <span className="tooltiptext-jpg">Pan Up</span>
                                        </button>
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => pan(event, "down")}><i className="bi bi-arrow-bar-down"></i>
                                            <span className="tooltiptext-jpg">Pan Down</span>
                                        </button>
                                        */}
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => invert(event)}><i className="bi bi-mask"></i>
                                            <span className="tooltiptext-jpg">Invert Color</span>
                                        </button>
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => magnify(event)}><i className="bi bi-plus-square"></i>
                                            <span className="tooltiptext-jpg">Magnify</span>
                                        </button>
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" id="fullscreen-btn" onClick={event => fullScreen(event)}><i className="bi bi-arrows-fullscreen"></i>
                                            <span className="tooltiptext-jpg">Toggle Fullscreen</span>
                                        </button>
                                        <button style={{display:"none"}} type="button" className="btn-jpg btn-blue tooltip-jpg"><i className="bi bi-caret-left-square"></i>
                                            <span className="tooltiptext-jpg">Previous</span>
                                        </button>
                                        <button style={{display:"none"}} type="button" className="btn-jpg btn-blue tooltip-jpg"><i className="bi bi-caret-right-square"></i>
                                            <span className="tooltiptext-jpg">Next</span>
                                        </button>
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => resetImage(event)}><i className="bi bi-arrow-clockwise"></i>
                                            <span className="tooltiptext-jpg">Reset</span>
                                        </button>
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => openImage(event)}><i className="bi bi-box-arrow-up-right"></i>
                                            <span className="tooltiptext-jpg">Open Image in Window</span>
                                        </button>
                                        
                                        <button className="btn-jpg btn-blue tooltip-jpg" onClick={event => showTabArea(event, 'T3')}><i className="bi bi-card-image"></i>
                                          <span className="tooltiptext-jpg">Show/hide Image</span>
                                        </button>

                                        &nbsp;
                                        <label style={{display:"inline"}} className="btn-link" onClick={event => showTabArea(event, 'T2')}>Viewer-II</label>
                                        &nbsp;
                                        <label className="btn-link" onClick={event => showTabArea(event, 'T3')}>Reporting</label>
                                        &nbsp;
                                        <label id="splitwindow1" className="btn-link" onClick={event => showTabArea(event, 'T13')}>Split Window</label>
                                    </div>
                                </div>
                                <div className="col-5 col-s-12">
                                    <div className="text-center">
                                        
                                        <button style={{display:"none"}} className="btn-jpg btn-blue tooltip-jpg"><i className="bi bi-bookmarks-fill"></i>
                                            <span className="tooltiptext-jpg">Notes</span> 
                                        </button>
                                    </div>
                                </div>
                            </div>
                          </div>

                          <div id="mainImageContainer" className="p-1 xray-image-container mt-1">
                            <XrayViewer showPatientInfo={showPatientInfo} patientKey={patientKey} imageUrl={jpgPath} toolDefault={toolDefault} refNumber={refNumber} />
                          </div>

                          <div style={{display:"none"}} id="mainImageContainer1" className="p-1 border-rounded-crimson image-container mt-1" onTouchStart={event => imageTouchStart(event) } onTouchMove={event => imageTouchMove(event) } onTouchEnd={event => imageTouchEnd(event) } onMouseDown={event => imageMouseDown(event) } onMouseMove={event => imageMouseMove(event) } onMouseUp={event => imageMouseUp(event) } onMouseLeave={event => imageMouseLeave(event) } >
                              <img id="mainImage" src={jpgPath} alt="MainImage"></img>
                              <div className="magnifier"></div>
                          </div>

                          {/* Mobile Menu Bottom */}
                          <div style={{display:"none"}} className="row menu_mobile">
                              <div className="icol-s-12 text-center">
                                  <div className="row menu_mobile">
                                      <div className="icol-s-12 text-center">

                                        <button type="button" id="btnWindowLevelMobile" className="btn-jpg btn-blue tooltip-jpg btn-selected" onClick={event => windowlevelJPG(event)}><i className="bi bi-circle-half"></i>
                                            <span className="tooltiptext-jpg">Window Level</span>
                                        </button>
                                        <button type="button" id="btnZoomMobile" className="btn-jpg btn-blue tooltip-jpg" onClick={event => zoomJPG(event)}><i className="bi bi-search"></i>
                                            <span className="tooltiptext-jpg">Zoom</span>
                                        </button>
                                        <button type="button" id="btnPanMobile" className="btn-jpg btn-blue tooltip-jpg" onClick={event => panJPG(event)}><i className="bi bi-arrows-move"></i>
                                            <span className="tooltiptext-jpg">Pan</span>
                                        </button>

                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => zoomIn(event)}><i className="bi bi-zoom-in"></i>
                                            <span className="tooltiptext-jpg">Zoom In</span>
                                        </button>
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => zoomOut(event)}><i className="bi bi-zoom-out"></i>
                                            <span className="tooltiptext-jpg">Zoom Out</span>
                                        </button>
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => rotate(event)}><i className="bi bi-arrow-clockwise"></i>
                                            <span className="tooltiptext-jpg">Rotate</span>
                                        </button>
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => flip(event)}><i className="bi bi-phone-flip"></i>
                                            <span className="tooltiptext-jpg">Flip</span>
                                        </button>
                                        {/* 
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => pan(event, "left")}><i className="bi bi-arrow-bar-left"></i>
                                            <span className="tooltiptext-jpg">Pan Left</span>
                                        </button>
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => pan(event, "right")}><i className="bi bi-arrow-bar-right"></i>
                                            <span className="tooltiptext-jpg">Pan Right</span>
                                        </button>
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => pan(event, "up")}><i className="bi bi-arrow-bar-up"></i>
                                            <span className="tooltiptext-jpg">Pan Up</span>
                                        </button>
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => pan(event, "down")}><i className="bi bi-arrow-bar-down"></i>
                                            <span className="tooltiptext-jpg">Pan Down</span>
                                        </button>
                                        */}
                                      </div>
                                      <div className="col-s-12 text-center mt-0">
                                      <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => invert(event)}><i className="bi bi-mask"></i>
                                            <span className="tooltiptext-jpg">Invert Color</span>
                                        </button>
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => magnify(event)}><i className="bi bi-plus-square"></i>
                                            <span className="tooltiptext-jpg">Magnify</span>
                                        </button>
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" id="fullscreen-btn" onClick={event => fullScreen(event)}><i className="bi bi-arrows-fullscreen"></i>
                                            <span className="tooltiptext-jpg">Toggle Fullscreen</span>
                                        </button>
                                        <button style={{display:"none"}} type="button" className="btn-jpg btn-blue tooltip-jpg"><i className="bi bi-caret-left-square"></i>
                                            <span className="tooltiptext-jpg">Previous</span>
                                        </button>
                                        <button style={{display:"none"}} type="button" className="btn-jpg btn-blue tooltip-jpg"><i className="bi bi-caret-right-square"></i>
                                            <span className="tooltiptext-jpg">Next</span>
                                        </button>
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => resetImage(event)}><i className="bi bi-arrow-clockwise"></i>
                                            <span className="tooltiptext-jpg">Reset</span>
                                        </button>
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => openImage(event)}><i className="bi bi-box-arrow-up-right"></i>
                                            <span className="tooltiptext-jpg">Open Image in Window</span>
                                        </button>
                                       
                                        <button className="btn-jpg btn-blue tooltip-jpg" onClick={event => showTabArea(event, 'T3')}><i className="bi bi-card-image"></i>
                                          <span className="tooltiptext-jpg">Show/hide Image</span>
                                        </button>
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                        <label className="btn-link" onClick={event => showTabArea(event, 'T3')}>Reporting</label>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
    
                      <div className="icol-12 icol-s-12" id="imgarea2" style={{display:"none"}} >
                        
                      </div>
    
                      <div style={{display:"none"}} className="icol-7 col-s-12 reportarea" >
                          <div className="p-2 border-rounded-crimson image-container mt-1">
                              {/* Embedded Report Viewer 
                              <object data="resources/report.pdf" type="application/pdf" width="100%" height="100%">
                                  <p>Alternative text - include a link <a href="resources/report.pdf">to the PDF!</a></p>
                              </object>
                              */}

                              
                          </div>
                      </div>
    
                      <div className="icol-12 col-s-12 reportarea row justify-content-center pb-3" id="reportarea">
                        <div style={{paddingLeft:"0.9rem"}}  className="container wrapper">
                            <div className="page-wrapper">
                                <div className="row">
                                  <div className="col-12 col-lg-9 col-md-9">
                                    <ul className="nav nav-tabs" id="myReportTab" role="tablist">
                                      <li className="nav-item" role="presentation">
                                        <button className="nav-link active" id="report1-tab" data-bs-toggle="tab" data-bs-target="#report1-tab-pane" type="button" role="tab" aria-controls="report1-tab-pane" aria-selected="true" onClick={event => tabReportClick(event, 1, false) }><small><b>Report1 </b></small></button>
                                      </li>
                                      <li className="nav-item" role="presentation">
                                        <button className="nav-link" id="report2-tab" data-bs-toggle="tab" data-bs-target="#report2-tab-pane" type="button" role="tab" aria-controls="report2-tab-pane" aria-selected="false" onClick={event => tabReportClick(event, 2, false) }><small><b>Report2 </b></small></button>
                                      </li>
                                      <li className="nav-item" role="presentation">
                                      <button className="nav-link" id="report3-tab" data-bs-toggle="tab" data-bs-target="#report3-tab-pane" type="button" role="tab" aria-controls="report3-tab-pane" aria-selected="false" onClick={event => tabReportClick(event, 3, false) }><small><b>Report3 </b></small></button>
                                      </li>
                                      <li className="nav-item" role="presentation">
                                      <button className="nav-link" id="report4-tab" data-bs-toggle="tab" data-bs-target="#report4-tab-pane" type="button" role="tab" aria-controls="report4-tab-pane" aria-selected="false" onClick={event => tabReportClick(event, 4, false) }><small><b>Report4 </b></small></button>
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                        <button type="button" className="btn btn-secondary btn-sm bi bi-plus-square-fill float-right m-1" id="btnreportadd" onClick={event => tabAddClick() }> ADD</button>
                                        <button type="button" className="btn btn-secondary btn-sm bi bi-x-square-fill float-right m-1" id="btnreportremove" onClick={event => tabRemoveClick() }> REMOVE(LAST)</button>
                                      </li>
                                      <li style={{ marginLeft: "auto" }}>
                                        {(authUser?.user_type === 'D' || authUser?.user_type === 'R'? 
                                          <select className="form-select form-select-sm float-right m-1" style={{ width: "150px"}} id="ddlReportTemplate" name="ddlReportTemplate" onChange= {selectReportTemplate}>
                                            <option value="">[Select Template]</option>
                                            {reportTemplatesFiltered.map((data, i) => (
                                              <option key = {i} value={data.template_id}>{data.template_name + '('+ data.category + ')'}</option>
                                            ))}
                                            <option value="[CLEAR FILTER]" style={{fontStyle:"italic", fontWeight:"bold"}}>[Display All Template]</option>
                                          </select>
                                          : <span style={{display:"none"}}></span>)
                                        }

                                        <select className="form-select form-select-sm float-right m-1" style={{ width: "160px"}} id="ddlLineHeight" name="ddlLineHeight" onChange={event => lineHeightChange()}>
                                          <option value="">Line Height - Default</option>
                                          <option value="1">Line Height - 1</option>
                                          <option value="1.3">Line Height - 1.3</option>
                                          <option value="1.5">Line Height - 1.5</option>
                                          <option value="1.8">Line Height - 1.8</option>
                                          <option value="2">Line Height - 2</option>
                                          <option value="2.3">Line Height - 2.3</option>
                                          <option value="2.5">Line Height - 2.5</option>
                                          <option value="2.8">Line Height - 2.8</option>
                                        </select>
                                      </li>
                                    </ul>
                                  </div>
                                  <div className="col-12 col-lg-3 col-md-3 text-end">

                                    <label className="btn-link" onClick={event => showTabArea(event, 'T1')}>Viewer-I</label>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <label style={{display:"none"}} className="btn-link" onClick={event => showTabArea(event, 'T2')}>Viewer-II</label>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <label id="splitwindow2" className="btn-link" onClick={event => showTabArea(event, 'T13')}>Split Window</label>                                    

                                    &nbsp;
                                    <button type="button" className="btn btn-outline-warning btn-sm bi bi-bookmarks m-1" title="Empty notes" id="btnopenNotes2" onClick={event => openNotes2(event, 'OPEN')}></button>
                                    &nbsp;
                                    <button type="button" className="btn btn-outline-warning btn-sm bi bi-pencil-fill" title="View Study" id="btnopenEditStudy2" onClick={event => openEditStudy2(event, 'OPEN')}></button>
                                  </div>
                                </div>
                                
                            </div>
                        </div>
                        <div id="divreportarea" className="col-lg-12 col-12">
                            <div className="form-group" style={{ lineHeight: reportLineHeight}} > 
                                {/*<label className="font-size14">Report Content:</label>*/}
                                <Editor
                                  editorState={editorState}
                                  onEditorStateChange={setEditorState}
                                  customStyleMap={customStyleMap}
                                  wrapperClassName="wrapper-class"
                                  editorClassName="editor-class"
                                  toolbarClassName="toolbar-class"
                                  handlePastedText={handlePastedText}
                                  spellCheck={true}
                                  onTab={handleTab}
                                   toolbar={{
        options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'history'],
        inline: {
          options: ['bold', 'italic', 'underline'],
        },
      }}
                                />
                            </div>
                        </div>

                        <div style={{display:"none"}} id="divreportarea_ecg" className="col-lg-12 col-12">
                          <div className="modal-body">
                            <div className="row justify-content-center pb-3">
                              <div className="col-lg-12 col-12 ps-1 pe-1">
                                  <div className="form-group mt-2 card">
                                      <label className="card-header bg-gradient-1 text-light">Measurement:</label>
                                  </div>
                              </div>
                              <div className="col-lg-ecg_measure col-12 ps-1 pe-1">
                                  <div className="form-group mt-2">
                                      <label className="font-size14">Heart Rate:</label>
                                      <input type="text" placeholder="e.g. 75" required="required" className="form-control" id="txtheart_rate" name="heart_rate" />
                                  </div>
                              </div>
                              <div className="col-lg-ecg_measure col-12 ps-1 pe-1">
                                  <div className="form-group mt-2">
                                      <label className="font-size14">PR Interval:</label>
                                      <input type="text" placeholder="e.g. 160" required="required" className="form-control" id="txtpr_interval" name="pr_interval" />
                                  </div>
                              </div>
                              <div className="col-lg-ecg_measure col-12 ps-1 pe-1">
                                  <div className="form-group mt-2">
                                      <label className="font-size14">QRS Duration:</label>
                                      <input type="text" placeholder="e.g. 80" required="required" className="form-control" id="txtqrs_duration" name="qrs_duration" />
                                  </div>
                              </div>
                              <div className="col-lg-ecg_measure col-12 ps-1 pe-1">
                                  <div className="form-group mt-2">
                                      <label className="font-size14">QT Interval:</label>
                                      <input type="text" placeholder="e.g. 400" required="required" className="form-control" id="txtqt_interval" name="qt_interval" />
                                  </div>
                              </div>
                              <div className="col-lg-ecg_measure col-12 ps-1 pe-1">
                                  <div className="form-group mt-2">
                                      <label className="font-size14">QTc Interval:</label>
                                      <input type="text" placeholder="e.g. 420" required="required" className="form-control" id="txtqtc_interval" name="qtc_interval" />
                                  </div>
                              </div>
                              

                              <div className="col-lg-12 col-12 ps-1 pe-1">
                                  <div className="form-group mt-2 card">
                                      <label className="card-header bg-gradient-1 text-light">Core Interpretation:</label>
                                  </div>
                              </div>
                              <div className="col-lg-ecg_core col-12 ps-1 pe-1">
                                  <div className="form-group mt-2">
                                      <label className="font-size14">Rhythm:</label>
                                      <select
                                        className="form-select form-select-sm"
                                        aria-label=".form-select-sm example"
                                        name="rhythm"
                                        id="ddlrhythm"
                                      >
                                        <option value="">[Select]</option>
                                        <option value="SRH">Sinus Rhythm</option>
                                        <option value="SBR">Sinus Bradycardia</option>
                                        <option value="STA">Sinus Tachycardia</option>
                                        <option value="SAR">Sinus Arrhythmia</option>
                                        <option value="AFI">Atrial Fibrillation</option>
                                        <option value="AFL">Atrial Flutter</option>
                                        <option value="VTA">Ventricular Tachycardia</option>
                                        <option value="VFI">Ventricular Fibrillation</option>
                                        <option value="IRH">Irregular Rhythm</option>
                                      </select>
                                  </div>
                              </div>
                              <div className="col-lg-ecg_core col-12 ps-1 pe-1">
                                  <div className="form-group mt-2">
                                      <label className="font-size14">Axis:</label>
                                      <select
                                        className="form-select form-select-sm"
                                        aria-label=".form-select-sm example"
                                        name="axis"
                                        id="ddlaxis"
                                      >
                                        <option value="">[Select]</option>
                                        <option value="NOR">Normal Axis</option>
                                        <option value="LAD">Left Axis Deviation</option>
                                        <option value="RAD">Right Axis Deviation</option>
                                        <option value="EAD">Extreme Axis Deviation</option>
                                      </select>
                                  </div>
                              </div>

                              <div className="col-lg-12 col-12 ps-1 pe-1">
                                  <div className="form-group mt-2 card">
                                      <label className="card-header bg-gradient-1 text-light">Wave Analysis:</label>
                                  </div>
                              </div>
                              <div className="col-lg-ecg_wave col-12 ps-1 pe-1">
                                  <div className="form-group mt-2">
                                      <label className="font-size14">P Wave:</label>
                                      <select
                                        className="form-select form-select-sm"
                                        aria-label=".form-select-sm example"
                                        name="p_wave"
                                        id="ddlp_wave"
                                      >
                                        <option value="">[Select]</option>
                                        <option value="NOR">Normal</option>
                                        <option value="ABS">Absent</option>
                                        <option value="INV">Inverted</option>
                                        <option value="PEA">Peaked</option>
                                      </select>
                                  </div>
                              </div>
                              <div className="col-lg-ecg_wave col-12 ps-1 pe-1">
                                  <div className="form-group mt-2">
                                      <label className="font-size14">T Wave:</label>
                                      <select
                                        className="form-select form-select-sm"
                                        aria-label=".form-select-sm example"
                                        name="t_wave"
                                        id="ddlt_wave"
                                      >
                                        <option value="">[Select]</option>
                                        <option value="NOR">Normal</option>
                                        <option value="INV">Inverted</option>
                                        <option value="PEA">Peaked</option>
                                        <option value="FLA">Flattened</option>
                                        <option value="NAB">Nonspecific T Wave Abnormalities</option>
                                        <option value="NCH">Nonspecific Changes</option>
                                      </select>
                                  </div>
                              </div>
                              <div className="col-lg-ecg_wave col-12 ps-1 pe-1">
                                  <div className="form-group mt-2">
                                      <label className="font-size14">ST Segment:</label>
                                      <select
                                        className="form-select form-select-sm"
                                        aria-label=".form-select-sm example"
                                        name="st_segment"
                                        id="ddlst_segment"
                                      >
                                        <option value="">[Select]</option>
                                        <option value="NOR">Normal</option>
                                        <option value="ISO">Isoelectric</option>
                                        <option value="STE">ST Elevation</option>
                                        <option value="STD">ST Depression</option>
                                        <option value="NAB">Nonspecific ST Abnormalities</option>
                                        <option value="NCH">Nonspecific Changes</option>
                                      </select>
                                  </div>
                              </div>
                              <div className="col-lg-ecg_wave col-12 ps-1 pe-1">
                                  <div className="form-group mt-2">
                                      <label className="font-size14">Q Wave:</label>
                                      <select
                                        className="form-select form-select-sm"
                                        aria-label=".form-select-sm example"
                                        name="q_wave"
                                        id="ddlq_wave"
                                      >
                                        <option value="">[Select]</option>
                                        <option value="NIL">NIL</option>
                                        <option value="NOR">Normal</option>
                                        <option value="NPA">No Pathological</option>
                                        <option value="PAT">Pathological</option>
                                      </select>
                                  </div>
                              </div>
                              <div className="col-lg-ecg_wave col-12 ps-1 pe-1">
                                  <div className="form-group mt-2">
                                      <label className="font-size14">QRS Complex:</label>
                                      <select
                                        className="form-select form-select-sm"
                                        aria-label=".form-select-sm example"
                                        name="qrs_complex"
                                        id="ddlqrs_complex"
                                      >
                                        <option value="">[Select]</option>
                                        <option value="NOR">Normal</option>
                                        <option value="WID">Wide QRS</option>
                                        <option value="LVO">Low Voltage</option>
                                        <option value="LBB">LBBB</option>
                                        <option value="RBB">RBBB</option>
                                      </select>
                                  </div>
                              </div>


                              <div className="col-lg-12 col-12 ps-1 pe-1">
                                  <div className="form-group mt-2">
                                      <label className="font-size14 fw-bold">Impression:</label>
                                      <textarea className="form-control font-size14" rows="3" id="txtimpression" name="impression"></textarea>
                                  </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
    
                  </div>  
                    
                </div>
                

                <div className="modal-footer pt-2">
                  <div className="row justify-content-center">
                        <div style={{display:"none"}} id="divShowReport" className="col-lg-3 col-2"><button type="button"
                                className="btn btn-secondary btn-sm btn-block" id="btnShowReport" onClick={event => showTabArea(event, 'T3')}> REPORT </button></div>
                        <div id="divPrintReport" className="col-lg-3 col-3"><button type="button"
                                className="btn btn-secondary btn-sm btn-block bi bi-send-fill" id="btnPrintReport" onClick={event => openSubmitReport(event, 'PRINT', null, '')}> PRINT </button></div>
                        <div id="divReviewSubmitReport" className="col-lg-3 col-6"><button type="button"
                                className="btn btn-secondary btn-sm btn-block bi bi-check2-circle" id="btnReviewSubmitReport" onClick={event => openSubmitReport(event, 'REVIEW_SIGNOFF', null, '')}> Review & Submit </button></div>
                        <div id="divReworkReport" className="col-lg-3 col-3"><button type="button"
                                className="btn btn-secondary btn-sm btn-block bi bi-reply-all-fill" id="btnReworkReport" onClick={event => openReviewRework(event, 'OPEN')}> Rework </button></div>
                        <div id="divSubmitReport" className="col-lg-3 col-3"><button type="button"
                                className="btn btn-secondary btn-sm btn-block bi bi-send-fill" id="btnSubmitReport" onClick={event => openSubmitReport(event, 'SAVE', null, '')}> SAVE </button></div>
                        <div id="divSubmitReportSignedOff" className="col-lg-3 col-4"><button type="button"
                                className="btn btn-secondary btn-sm btn-block bi bi-check2-square" id="btnSubmitReportSignedOff" onClick={event => openSubmitReport(event, 'SAVE_SIGNOFF', null, '')}> SIGN OFF</button></div>
                        <div className="col-lg-3 col-3"><button type="button"
                                className="btn btn-secondary btn-sm btn-block bi bi-x-square" id="btnSubmitReportClose" onClick={event => openSubmitReport(event, 'CLOSE', null, '')}> CLOSE </button></div>
                    </div>
                </div>
            </div>
        </div>
        
        <div id="openSubmitReportPreview" className="modal closed">

            {/*<!--Modal content -->*/}
            <div className="report-modal-content-preview">
                <div className="modal-header pt-2">
                    <span className="close" onClick={event => openSubmitReportPreview(event, 'CLOSE', null)}>&times;</span>
                    <h6 className="mb-0" style={{marginTop: "0.3em"}}><i className="bi bi-clipboard-check-fill"></i> Submit Report Preview: <span id="spnsubmit_patient_preview" style={{fontSize: "12px"}}></span>
                    <input type="hidden" id="hidc_key_submit_preview" />
                    <input type="hidden" id="hidp_key_submit_preview" />
                    <input type="hidden" id="hidreport_count" />
                    <input type="hidden" id="hidreport1-tab" />
                    <input type="hidden" id="hidreport2-tab" />
                    <input type="hidden" id="hidreport3-tab" />
                    <input type="hidden" id="hidreport4-tab" />
                    </h6>
                </div>
                <div className="modal-body">
                  <div className="row justify-content-center">
                    <div className="PreviewContent" id="divPreviewContent">
                    </div>
                  </div>
              
                  <div className="row justify-content-center">
                        <button type="button"
                                className="btn btn-secondary btn-sm btn-block bi bi-check-square-fill" id="btnSubmitReportSignedOffPreview" onClick={event => openSubmitReportPreview(event, 'SAVE_SIGNOFF_SUBMIT', null)}> SUBMIT(SIGN OFF)</button>
                  </div>
                </div>
            </div>
        </div>

        {/*<!--Custom Modal Open Notes -->*/}
        <div id="attachNotes" className="modal closed" style={{zIndex:"31055"}}>

            {/*<!--Modal content -->*/}
            <div className="notes-modal-content">
                <div className="modal-header pt-2">
                    <span className="close" onClick={event => openNotes(event, 'CLOSE')}>&times;</span>
                    <h6 className="mb-0" style={{marginTop: "0.3em"}}><i className="bi bi-clipboard-check-fill"></i> Notes: <span id="spnnotes_patient" style={{fontSize: "12px"}}></span></h6>
                </div>
                <div className="modal-body" style={{ paddingBottom: "0px"}}>
                    <div className="row justify-content-center pb-3">
                        <div className="col-lg-12 col-12 ps-1 pe-1">
                            <div className="form-group">
                                <div className="overflow-y-scroll">
                                  <label for="divp_comments" className="font-size14">History Notes:</label>
                                  <div className="note_comments" id="divp_comments" style={{ fontSize: "12px"}}>
                                    &nbsp;
                                  </div>
                                </div>

                                <label for="txtp_notes" className="font-size14">Add Note:</label>
                                <textarea className="form-control font-size14" rows="2" id="txtp_notes"></textarea>
                                <input type="hidden" id="hidc_key_notes" />
                                <input type="hidden" id="hidp_key_notes" />
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div className="modal-footer pt-2">
                  <div className="row justify-content-end"> 
                      <div className="col-lg-4 col-4">
                        <input id="notesFiles" title="Select multiple files to upload" className="form-control-sm"
                            type="file" multiple="multiple" onChange={handleChangeNotesFile} />
                      </div>
                      <div className="col-lg-2 col-4" style={{display:"none"}} ><button type="button"
                              className="btn btn-secondary btn-sm btn-block bi bi-send-fill" id="btnNotesPaste" onClick={event => openNotes(event, 'PASTE')}> PASTE </button>
                      </div>
                      <div className="col-lg-2 col-4"><button type="button"
                              className="btn btn-secondary btn-sm btn-block bi bi-send-fill" id="btnNotesSave" onClick={event => openNotes(event, 'SAVE')}> SAVE </button>
                      </div>
                      <div className="col-lg-2 col-4"><button type="button"
                              className="btn btn-secondary btn-sm btn-block bi bi-x-square" id="btnNotesClose" onClick={event => openNotes(event, 'CLOSE', null, null)}> CLOSE </button>
                      </div>
                  </div>
                </div>
            </div>
        </div>

        {/*<!--Custom Modal Rework Study -->*/}
        <div id="reworkStudy" className="modal closed" style={{zIndex:"31056"}}>

            {/*<!--Modal content -->*/}
            <div className="rework-modal-content">
                <div className="modal-header pt-2">
                    <span className="close" onClick={event => openReworkStudy(event, 'CLOSE')}>&times;</span>
                    <h6 className="mb-0" style={{marginTop: "0.3em"}}><i className="bi bi-clipboard-check-fill"></i> Rework Study: <span id="spnrework_patient" style={{fontSize: "12px"}}></span></h6>
                </div>
                <div className="modal-body" style={{ paddingBottom: "0px"}}>
                    <div className="row justify-content-center pb-3">
                        <div className="col-lg-12 col-12 ps-1 pe-1">
                            <div className="form-group">
                                <label for="txtrework_reason" className="font-size14">Rework Reason:</label>
                                <textarea className="form-control font-size14" rows="2" id="txtrework_reason"></textarea>
                                <input type="hidden" id="hidc_key_rework" />
                                <input type="hidden" id="hidp_key_rework" />
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div className="modal-footer pt-2">
                  <div className="row justify-content-end"> 
                      <div className="col-lg-4 col-4">
                        <input id="reworkFiles" title="Select multiple files to upload" className="form-control-sm"
                            type="file" multiple="multiple" onChange={handleChangeNotesFile} /> 
                      </div>
                      <div className="col-lg-2 col-4"><button type="button"
                              className="btn btn-secondary btn-sm btn-block bi bi-send-fill" id="btnReworkSave" onClick={event => openReworkStudy(event, 'SAVE')}> SAVE </button>
                      </div>
                      <div className="col-lg-2 col-4"><button type="button"
                              className="btn btn-secondary btn-sm btn-block bi bi-x-square" id="btnReworkClose" onClick={event => openReworkStudy(event, 'CLOSE', null, null)}> CLOSE </button>
                      </div>
                  </div>
                </div>
            </div>
        </div>

        {/*<!--Custom Modal Unlock Study -->*/}
        <div id="unlockStudy" className="modal closed" style={{zIndex:"31058"}}>

            {/*<!--Modal content -->*/}
            <div className="rework-modal-content">
                <div className="modal-header pt-2">
                    <span className="close" onClick={event => openUnlockStudy(event, 'CLOSE')}>&times;</span>
                    <h6 className="mb-0" style={{marginTop: "0.3em"}}><i className="bi bi-clipboard-check-fill"></i> Unlock Study: <span id="spnunlock_patient" style={{fontSize: "12px"}}></span></h6>
                </div>
                <div className="modal-body" style={{ paddingBottom: "0px"}}>
                    <div className="row justify-content-center pb-3">
                        <div className="col-lg-12 col-12 ps-1 pe-1">
                            <div className="form-group">
                                <label for="txtunlock_reason" className="font-size14">Unlock Reason:</label>
                                <textarea className="form-control font-size14" rows="2" id="txtunlock_reason"></textarea>
                                <input type="hidden" id="hidc_key_unlock" />
                                <input type="hidden" id="hidp_key_unlock" />
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div className="modal-footer pt-2">
                  <div className="row justify-content-end"> 
                      <div className="col-lg-4 col-4">
                        <input id="unlockFiles" title="Select multiple files to upload" className="form-control-sm"
                            type="file" multiple="multiple" onChange={handleChangeNotesFile} /> 
                      </div>
                      <div className="col-lg-2 col-4"><button type="button"
                              className="btn btn-secondary btn-sm btn-block bi bi-send-fill" id="btnUnlockSave" onClick={event => openUnlockStudy(event, 'SAVE')}> SAVE </button>
                      </div>
                      <div className="col-lg-2 col-4"><button type="button"
                              className="btn btn-secondary btn-sm btn-block bi bi-x-square" id="btnUnlockClose" onClick={event => openUnlockStudy(event, 'CLOSE', null, null)}> CLOSE </button>
                      </div>
                  </div>
                </div>
            </div>
        </div>

        {/*<!--Custom Modal Review Rework Study -->*/}
        <div id="reviewRework" className="modal closed" style={{zIndex:"31057"}}>

            {/*<!--Modal content -->*/}
            <div className="rework-modal-content">
                <div className="modal-header pt-2">
                    <span className="close" onClick={event => openReviewRework(event, 'CLOSE')}>&times;</span>
                    <h6 className="mb-0" style={{marginTop: "0.3em"}}><i className="bi bi-clipboard-check-fill"></i> Rework Study: <span id="spnreview_rework" style={{fontSize: "12px"}}></span></h6>
                </div>
                <div className="modal-body" style={{ paddingBottom: "0px"}}>
                    <div className="row justify-content-center pb-3">
                        <div className="col-lg-12 col-12 ps-1 pe-1">
                            <div className="form-group">
                                <label for="txtreview_rework_reason" className="font-size14">Rework Reason:</label>
                                <textarea className="form-control font-size14" rows="2" id="txtreview_rework_reason"></textarea>
                                <input type="hidden" id="hidc_key_review_rework" />
                                <input type="hidden" id="hidp_key_review_rework" />
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div className="modal-footer pt-2">
                  <div className="row justify-content-end"> 
                      <div className="col-lg-4 col-4">
                        <input id="reviewReworkFiles" title="Select multiple files to upload" className="form-control-sm"
                            type="file" multiple="multiple" onChange={handleChangeNotesFile} /> 
                      </div>
                      <div className="col-lg-2 col-4"><button type="button"
                              className="btn btn-secondary btn-sm btn-block bi bi-send-fill" id="btnReviewReworkSave" onClick={event => openReviewRework(event, 'SAVE')}> SAVE </button>
                      </div>
                      <div className="col-lg-2 col-4"><button type="button"
                              className="btn btn-secondary btn-sm btn-block bi bi-x-square" id="btnReviewReworkClose" onClick={event => openReviewRework(event, 'CLOSE', null, null)}> CLOSE </button>
                      </div>
                  </div>
                </div>
            </div>
        </div>

        {/*<!--Custom Modal Open Notes -->*/}
        <div id="activityLog" className="modal closed">
          {/*<!--Modal content -->*/}
          <div className="activitylog-modal-content">
              <div className="modal-header pt-2">
                  <span className="close" onClick={event => openActivityLog(event, 'CLOSE', null, null)}>&times;</span>
                  <h6 className="mb-0" style={{marginTop: "0.3em"}}><i className="bi bi-clipboard-check-fill"></i> Activity Log: <span id="spnlog_patient" style={{fontSize: "12px"}}></span></h6>
              </div>
              
              <div className="modal-body" style={{overflow:"auto"}}>
                <div className="card-body tele-table-padding">
                  {/* tele-table-rowbg1 */}
                        
                  {Object.keys(activitylogData).map((data, i) => (
                    <div key={i} className="">
                      <div className="item">
                          <div className="image">
                            <div>
                              <div className="img-div">
                                {(activitylogData[i].activity_action === 'Uploaded Patient' ?  
                                    <img alt="" src="img/upload.png" />    
                                    : 
                                      activitylogData[i].activity_action === 'Printed Report' ?  
                                      <img alt="" src="img/print.png" />    
                                      : 
                                        activitylogData[i].activity_action === 'Review Report' ?  
                                        <img alt="" src="img/review.png" />    
                                        : 
                                          activitylogData[i].activity_action === 'SignedOff Report' ?  
                                          <img alt="" src="img/report.png" />    
                                          : 
                                            activitylogData[i].activity_action === 'Locked Patient' || activitylogData[i].activity_action === 'Locked Study' ?  
                                            <img alt="" src="img/lock.png" />    
                                            : 
                                              activitylogData[i].activity_action === 'Removed Lock Patient' || activitylogData[i].activity_action === 'Unlocked Study' ?  
                                              <img alt="" src="img/unlocked.png" />    
                                              : 
                                              <img alt="" src="img/message.png" />        
                                )}
                                
                              </div>
                              <span>
                                {activitylogData[i].activity_time} 
                              </span>
                            </div>
                          </div>
                          <div className="details">
                            <div>
                              <h1>
                                {activitylogData[i].activity_action}:&nbsp;

                                {(authUser?.user_type === 'U' ?  
                                  (activitylogData[i].user_type === 'D' ?  
                                      <span>Doctor</span>
                                      : <span>{activitylogData[i].user_name}</span>
                                  )
                                  : 
                                  (authUser?.user_type === 'D' || authUser?.user_type === 'R' ?  
                                      (activitylogData[i].user_type === 'U' ?  
                                          <span>Center User</span>
                                          : <span>{activitylogData[i].user_name}</span>
                                      )
                                      : 
                                      (activitylogData[i].user_type === 'D' ?  
                                          <span>{activitylogData[i].user_title} {activitylogData[i].user_name} ({activitylogData[i].user_id})</span>
                                          : <span>{activitylogData[i].user_name}</span>
                                      )
                                  )
                              )}
                              </h1>
                              
                              
                              {(activitylogData[i].activity_action === 'Modified Report' || activitylogData[i].activity_action === 'Modified Draft Report' ? 
                              
                                  <p style={{color:"#0d6efd"}} onClick={event => openActivityReport(event, 'OPEN', activitylogData[i].column_name, activitylogData[i].column_value_old, activitylogData[i].column_value_new)}> 
                                    Click here to view the changes of {activitylogData[i].column_name}
                                  </p>
                                  
                                  : 
                                    (activitylogData[i].activity_action.indexOf('Modified') === 0 ? 
                                  
                                      <ActivityLogTable 
                                                  rawDataString={activitylogData[i].activity_remarks}
                                      />                                  
                                      : 
                                      <p>{activitylogData[i].activity_remarks}</p>
                                  )
                              )}
                              

                            </div>
                          </div>
                        </div>
                        
                    </div>
                          
                  ))}
                        
                  </div>
              </div>

              <div className="modal-footer pt-2">
                <div className="row justify-content-center">
                    <div className="col-lg-6 col-6"><button type="button"
                            className="btn btn-secondary btn-sm btn-block bi bi-x-square" id="btnActityLogClose" onClick={event => openActivityLog(event, 'CLOSE', null, null)}> CLOSE </button></div>
                </div>
              </div>

          </div>
        </div>

        <div id="activityReport" className="modal closed">
          {/*<!--Modal content -->*/}
          <div className="activityreport-modal-content">
              <div className="modal-header pt-2">
                  <span className="close" onClick={event => openActivityReport(event, 'CLOSE', null, null, null)}>&times;</span>
                  <h6 className="mb-0" style={{marginTop: "0.3em"}}><i className="bi bi-clipboard-check-fill"></i> Report Log: <span id="spnlog_report" style={{fontSize: "12px"}}></span></h6>
              </div>
              
              <div className="modal-body" style={{overflow:"auto", zIndex:"41055"}} >
                <div className="card-body tele-table-padding">
                  
                     <ReportDiff 
                        columnName = {columnNameReport}
                        oldReport = {oldReport}
                        newReport = {newReport}
                      />     
                        
                  </div>
              </div>

              <div className="modal-footer pt-2">
                <div className="row justify-content-center">
                    <div className="col-lg-6 col-6"><button type="button"
                            className="btn btn-secondary btn-sm btn-block bi bi-x-square" id="btnActityReportClose" onClick={event => openActivityReport(event, 'CLOSE', null, null, null)}> CLOSE </button></div>
                </div>
              </div>

          </div>
        </div>

        <div id="modal2" className="modal closed">

            {/*<!--Modal content -->*/}
            <div className="modal-content">
                <div className="modal-header pt-2">
                    <span className="close" id="close-button2" onClick={event => openModal2(event, 'CLOSE')}>&times;</span>
                    <h6 className="mb-0" style={{marginTop: "0.3em"}}><i className="bi bi-clipboard-check-fill"></i> Notes</h6>
                </div>
                <div className="modal-body">
                    <div className="row justify-content-center pb-3">
                        <div className="col-lg-12 col-12 ps-1 pe-1">
                            <div className="form-group mt-2">
                                <label className="font-size14">Add Note:</label>
                                <textarea className="form-control font-size14" rows="2"  name="history"></textarea>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-4 col-12"><button type="button"
                                className="btn btn-secondary btn-sm btn-block bi bi-send-fill"> SAVE DETAILS</button></div>
                    </div>
                </div>
            </div>
        </div>
        {/*<!--End of Custom Modal Type 2 -->*/}

        {/*<!--Custom Modal Type 3 -->*/}
        <div id="modal3" className="modal closed">

            {/*<!-- Modalcontent -->*/}
            <div className="modal-content">
                <div className="modal-header pt-2">
                    <span className="close" id="close-button3" onClick={event => openContactInfo(event, 'CLOSE')}>&times;</span>
                    <h6 className="mb-0" style={{marginTop: "0.3em"}}><i className="bi bi-person-lines-fill"></i> Contact Info</h6>
                </div>
                <div className="modal-body">
                    <div className="row justify-content-center pb-3">
                        <div className="col-lg-6 col-12 ps-1 pe-1">
                            <div className="form-group mt-2">
                                <label className="font-size14">Email:</label>
                                <input type="text" placeholder="Email" required="required" className="form-control" id="Email" name="Email" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-12 ps-1 pe-1">
                            <div className="form-group mt-2">
                                <label className="font-size14">Contact Number:</label>
                                <input type="text" placeholder="Contact Number" required="required" className="form-control" id="Contact" name="Contact" />
                            </div>
                        </div>
                        <div className="col-lg-12 col-12 ps-1 pe-1">
                            <div className="form-group mt-2">
                                <label className="font-size14">Address:</label>
                                <textarea className="form-control font-size14" rows="2" id="address" name="address"></textarea>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-4 col-12"><button type="button"
                                className="btn btn-secondary btn-sm btn-block bi bi-send-fill"> SAVE DETAILS</button></div>
                    </div>
                </div>
                <div className="modal-footer pt-2"><p className="mb-0 text-center font-size12">Please add this information as this will show in the invoice</p></div>
            </div>
        </div>
        {/*<!--End of Custom Modal Type 3 -->*/}

        {/*<!--Custom Modal for Alert -->*/}
        <div id="modal_alert">
          {/*<ToastContainer limit={3}></ToastContainer>*/}
          <ToastContainer style={{ zIndex: 999999 }} limit={1} stacked role="alert" autoClose={autoCloseTime} />
        </div>
        {/*<!--End of Custom Modal for Alert -->*/}

        {/*<!--Custom Modal for Success -->*/}
        <div id="modal_success" className="modal modal-confirm closed">

            {/*<!--Modal content -->*/}
            <div className="success-modal-content">
                <div className="modal-header-success">
                    <div className="icon-box"><i className="fa fa-check" aria-hidden="true"></i></div>
                    <h4 className="modal-title mb-0 text-center">Success</h4>
                </div>
                <div className="modal-body">
                    <div className="row justify-content-center pb-3">
                        <div className="col-lg-12 col-12 ps-1 pe-1 text-center">
                            <p>Form has been created successfully.</p>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-12 col-12"><button type="button"
                                className="btn btn-success btn-sm btn-block" id="close-button-success" onClick={event => openModalSuccess(event, 'CLOSE')}> OK</button></div>
                    </div>
                </div>
            </div>
        </div>
        {/*<!--End of Custom Modal for Success -->*/}

        {/*<!--Custom Modal for Error -->*/}
        <div id="modal_error" className="modal modal-error closed">

            {/*<!-- Modal content -->*/}
            <div className="success-modal-content">
                <div className="modal-header-error">
                    <div className="icon-box"><i className="fa fa-times" aria-hidden="true"></i></div>
                    <h4 className="modal-title mb-0 text-center">Error!</h4>
                </div>
                <div className="modal-body">
                    <div className="row justify-content-center">
                        <div className="col-lg-12 col-12 ps-1 pe-1 text-center">
                            <p>An unexpected error has been occured.</p>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-12 col-12"><button type="button"
                                className="btn btn-danger btn-sm btn-block" id="close-button-error" onClick={event => openModalError(event, 'CLOSE')}> OK</button></div>
                    </div>
                </div>
            </div>
        </div>
        {/*<!-- End of Custom Modal for Error -->*/}
        
        </div>
    );
}

